import React, { useState, useEffect, useMemo, useRef } from "react";
import { connect } from "react-redux";
import { generateAIArticle, refineArticleSection, generateAIImage, createArticle, updateArticle, uploadThumnail, checkSimilarity, writeArticle, getArticles, deleteArticle } from "../../RestServices/videosService";
import "./styles.css";

// Vector SVG Icons for premium, dependency-free graphics
const Icons = {
  Sparkles: () => (
    <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
    </svg>
  ),
  Header: () => (
    <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h7" />
    </svg>
  ),
  User: () => (
    <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  ),
  Question: () => (
    <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
  ),
  List: () => (
    <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 10h16M4 14h16M4 18h16" />
    </svg>
  ),
  Globe: () => (
    <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 002 2h1.5a3 3 0 003-3V6.7m-2 9l-3-3m0 0l-3 3m3-3V21m-9-9a9 9 0 1118 0 9 9 0 01-18 0z" />
    </svg>
  ),
  Seo: () => (
    <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M7 12l3-3 3 3 4-4M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
    </svg>
  ),
  Settings: () => (
    <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),
  Check: ({ style }) => (
    <svg style={{ width: "16px", height: "16px", ...style }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
    </svg>
  ),
  Trash: () => (
    <svg style={{ width: "18px", height: "18px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
    </svg>
  ),
  Plus: () => (
    <svg style={{ width: "16px", height: "16px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
    </svg>
  ),
  Eye: () => (
    <svg style={{ width: "16px", height: "16px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
  ),
  ArrowUp: () => (
    <svg style={{ width: "14px", height: "16px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 15l7-7 7 7" />
    </svg>
  ),
  ArrowDown: () => (
    <svg style={{ width: "14px", height: "16px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7" />
    </svg>
  ),
  Sync: () => (
    <svg style={{ width: "16px", height: "16px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 1121.21 15.89M9 11l3-3m0 0l3 3m-3-3v12" />
    </svg>
  ),
  Search: ({ style }) => (
    <svg style={{ width: "16px", height: "16px", ...style }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
    </svg>
  ),
  Edit: ({ style }) => (
    <svg style={{ width: "16px", height: "16px", ...style }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
    </svg>
  ),
  Lightbulb: ({ style }) => (
    <svg style={{ width: "16px", height: "16px", ...style }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
    </svg>
  ),
  Undo: () => (
    <svg style={{ width: "16px", height: "16px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
    </svg>
  )
};

const SELECT_OPTIONS = {
  RelatedRates: [
    "Daily White Egg & Layer Rates|/rates/white-egg",
    "Daily Desi & Brown Egg Rates|/rates/brown-egg",
    "Daily Broiler & Chicken Rates|/rates/broiler",
    "Daily White Layer Chick Rates|/rates/whitelayer-chick",
    "Daily Brown Layer Chick Rates|/rates/brownlayer-chick",
    "Daily Broiler Chick Rates|/rates/broiler-chick",
    "Daily Poultry Feed & Ingredient Rates|/rates",
    "Daily Bajra Grains Market Rates|/rates/bajra",
    "Daily Soyabean Meal Rates|/rates/soyabean",
    "Daily Canola Meal Market Rates|/rates/canola-meal",
    "Daily Rice Polish Market Rates|/rates/rice-polish",
    "Daily Wheat Grain Rates|/rates/wheat",
    "Daily Corn & Yellow Maize Rates|/rates/corn"
  ],
  Encyclopedia: [
    "White Egg Poultry Encyclopedia|/encyclopedia/white-egg",
    "Brown Egg Poultry Encyclopedia|/encyclopedia/brown-egg",
    "Broiler Poultry Encyclopedia|/encyclopedia/broiler",
    "Soyabean Meal Feed Encyclopedia|/encyclopedia/soyabean",
    "Corn & Yellow Maize Feed Encyclopedia|/encyclopedia/corn",
    "Rice Polish Feed Encyclopedia|/encyclopedia/rice-polish",
    "Canola Meal Feed Encyclopedia|/encyclopedia/canola-meal",
    "Wheat Grain Feed Encyclopedia|/encyclopedia/wheat",
    "Bajra Grain Feed Encyclopedia|/encyclopedia/bajra"
  ],
  Articles: [
    "Broiler Farming Profit Guide|/blogs",
    "Layer Farming Business & Setup Cost|/blogs",
    "Poultry Feed Management|/blogs",
    "How Climate Affects Egg Production|/blogs"
  ]
};

const ENCYCLOPEDIA_TAXONOMY = {
  Poultry: {
    subcategories: ["General", "Farming Tips", "Diseases", "Breeds"],
    tertiary: {
      "Farming Tips": ["Broiler", "Layer", "Golden Misri", "Desi Murgi"],
      "Diseases": ["Viral", "Bacterial", "Fungal", "Parasitic"],
      "Breeds": ["Heritage", "Commercial", "Dual Purpose"]
    }
  },
  "Poultry Rates": {
    subcategories: ["Daily Rates", "Mandi Trends", "Historical Analysis", "Feed Rates"],
    tertiary: {
      "Daily Rates": ["Punjab Board", "Sindh Board", "KPK Board", "Balochistan Board"],
      "Mandi Trends": ["Auction Records", "Demand Shifts", "Supply Analysis"],
      "Feed Rates": ["Sadiq Feed", "National Feed", "Supreme Feed"]
    }
  },
  "Poultry Plaza": {
    subcategories: ["Medicine", "Equipment", "Shed Construction", "Services"],
    tertiary: {
      "Medicine": ["Antibiotic", "Vaccine", "Dewormer", "Vitamin", "Disinfectant"],
      "Equipment": ["Feeders", "Drinkers", "Cages", "Heaters", "Fans"],
      "Shed Construction": ["Controlled Shed", "Semi-Controlled", "Conventional Coop"]
    }
  },
  "Breed": {
    subcategories: ["Commercial Broiler", "Commercial Layer", "Fancy Breeds", "Desi Selection"],
    tertiary: {
      "Commercial Broiler": ["Cobb 500", "Ross 308", "Hubbard"],
      "Commercial Layer": ["Hy-Line", "Lohmann", "Novogen", "Bovans"],
      "Fancy Breeds": ["Aseel", "Silkie", "Sebright", "Light Sussex"]
    }
  }
};

// Build a clean, SEO-friendly slug that never ends/starts with a dash and never
// cuts a word in half. Keeps whole words while staying within ~60 characters.
const cleanSlug = (input = "", maxLength = 50) => {
  const SEO_STOP_WORDS = new Set([
    "a", "an", "the", "in", "on", "at", "by", "with", "for", "to", "from", "of", "and", "or", "but", "about", 
    "how", "what", "why", "where", "who", "which", "is", "are", "was", "were", "be", "been", "being", "have", 
    "has", "had", "do", "does", "did", "latest", "today", "update", "updates", "guide", "manual", "tutorial", 
    "new", "best", "top", "choose", "choosing"
  ]);

  const rawWords = String(input)
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "")
    .split("-")
    .filter(Boolean);

  // Strip stop-words to make slugs extremely clean and 100/100 SEO ready
  let words = rawWords.filter(word => !SEO_STOP_WORDS.has(word));

  // Fallback to raw words if everything was a stop word
  if (words.length === 0) {
    words = rawWords;
  }

  let slug = "";
  for (const word of words) {
    const next = slug ? `${slug}-${word}` : word;
    if (next.length > maxLength) break;
    slug = next;
  }

  // If even the first word is longer than maxLength, fall back to a hard cut.
  if (!slug && words.length) {
    slug = words[0].substring(0, maxLength);
  }
  return slug.replace(/^-+|-+$/g, "");
};

function AIArticle(props) {
  // DB Article ID tracker for edit mode
  const [articleId, setArticleId] = useState(null);

  // States: Set to empty/null initially as requested by user to support clean testing from scratch
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  // Holds a complete slug returned by the AI so it wins over the title-derived one.
  const aiSlugRef = useRef(null);
  // Tracks which existing article has already been loaded into the editor.
  const populatedIdRef = useRef(null);
  const [category, setCategory] = useState("Poultry Rates");
  const [country, setCountry] = useState("Worldwide");
  const [province, setProvince] = useState("Global");
  const [city, setCity] = useState("All");
  const [language, setLanguage] = useState("English");
  const [status, setStatus] = useState("Draft");
  const [publishDate, setPublishDate] = useState(new Date().toISOString().split("T")[0]);
  const [updatedDate, setUpdatedDate] = useState(new Date().toISOString().split("T")[0]);
  const [featuredImage, setFeaturedImage] = useState("");

  const [author, setAuthor] = useState("Dr. Wahab Naveed");
  const [reviewer, setReviewer] = useState("");
  const [editor, setEditor] = useState("");
  const [factChecker, setFactChecker] = useState("");
  const [publisher, setPublisher] = useState("");

  const [quickAnswer, setQuickAnswer] = useState("");
  const [takeaways, setTakeaways] = useState([]);
  const [mainArticleText, setMainArticleText] = useState("");
  const [editorTab, setEditorTab] = useState("preview"); // "edit" | "preview"


  const [relevanceSAARC, setRelevanceSAARC] = useState("");
  const [relevanceMENA, setRelevanceMENA] = useState("");
  const [relevanceAsia, setRelevanceAsia] = useState("");
  const [relevanceEurope, setRelevanceEurope] = useState("");

  const [analysisTitle, setMarketAnalysisTitle] = useState("");
  const [analysisDesc, setMarketAnalysisDesc] = useState("");
  const [analysisUrl, setMarketAnalysisUrl] = useState("");

  const [sources, setSources] = useState([]);
  const [faqs, setFaqs] = useState([]);

  const [relatedRatesSelected, setRelatedRatesSelected] = useState([]);
  const [encyclopediaSelected, setEncyclopediaSelected] = useState([]);
  const [relatedArticlesSelected, setRelatedArticlesSelected] = useState([]);

  const [dbArticles, setDbArticles] = useState([]);
  const [dbEncyclopedia, setDbEncyclopedia] = useState([]);

  // Post Type state ('Article' vs 'Encyclopedia' as requested)
  const [postType, setPostType] = useState("Article");
  const [writingTone, setWritingTone] = useState("informative");
  const [initialSeoScore, setInitialSeoScore] = useState(null);
  const [initialHealthScore, setInitialHealthScore] = useState(null);
  const [mappedLocation, setMappedLocation] = useState("Main Landing");
  const [parentPage, setParentPage] = useState("Poultry");
  const [subCategory, setSubCategory] = useState("General");
  const [tertiaryCategory, setTertiaryCategory] = useState("");
  const [detailValue, setDetailValue] = useState("");

  const [metaTitle, setMetaTitle] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [focusKeyword, setFocusKeyword] = useState("");
  const [secondaryKeywords, setSecondaryKeywords] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");
  const [schemaType, setSchemaType] = useState("NewsArticle");

  const [showTopRates, setShowTopRates] = useState(true);
  const [showPopularTags, setShowPopularTags] = useState(true);
  const [showSocialLinks, setShowSocialLinks] = useState(true);
  const [showDownloadAppToggle, setShowDownloadAppToggle] = useState(true);
  const [showAdsToggle, setShowAdsToggle] = useState(true);
  const [stickySidebarToggle, setStickySidebarToggle] = useState(true);

  const [similarityWarning, setSimilarityWarning] = useState(null);
  const [showSimilarityModal, setShowSimilarityModal] = useState(false);
  const [aiSuggestedTitles, setAiSuggestedTitles] = useState([]);
  const [articleEmbedding, setArticleEmbedding] = useState([]);

  const [activeTab, setActiveSection] = useState("header");
  const [isSavedToast, setToastMessage] = useState("");
  const [isSaving, setIsSaving] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);

  const isFirstMount = useRef(true);
  const isPopulatingRef = useRef(false);

  const resetFormState = () => {
    setArticleId(null);
    populatedIdRef.current = null;
    aiSlugRef.current = null;
    setInitialSeoScore(null);
    setInitialHealthScore(null);
    setTitle("");
    setSlug("");
    setCategory("Poultry Rates");
    setCountry("Worldwide");
    setProvince("Global");
    setCity("All");
    setLanguage("English");
    setStatus("Published");
    setPublishDate(new Date().toISOString().split("T")[0]);
    setUpdatedDate(new Date().toISOString().split("T")[0]);
    setFeaturedImage("");
    setAuthor("Dr. Wahab Naveed");
    setReviewer("");
    setEditor("");
    setFactChecker("");
    setPublisher("");
    setQuickAnswer("");
    setTakeaways([]);
    setMainArticleText("");
    setRelevanceSAARC("");
    setRelevanceMENA("");
    setRelevanceAsia("");
    setRelevanceEurope("");
    setMarketAnalysisTitle("");
    setMarketAnalysisDesc("");
    setMarketAnalysisUrl("");
    setSources([]);
    setFaqs([]);
    setRelatedRatesSelected([]);
    setEncyclopediaSelected([]);
    setRelatedArticlesSelected([]);
    setPostType("Article");
    setMappedLocation("Main Landing");
    setParentPage("Poultry");
    setSubCategory("General");
    setTertiaryCategory("");
    setDetailValue("");
    setMetaTitle("");
    setMetaDescription("");
    setFocusKeyword("");
    setSecondaryKeywords("");
    setCanonicalUrl("");
    setSchemaType("NewsArticle");
    setShowTopRates(true);
    setShowPopularTags(true);
    setShowSocialLinks(true);
    setShowDownloadAppToggle(true);
    setShowAdsToggle(true);
    setStickySidebarToggle(true);
    setArticleEmbedding([]);
    setIsDirty(false);
  };

  // AI Generator Panel State
  const [aiInputTitle, setAiInputTitle] = useState("");
  const [aiRefinementPrompt, setAiRefinementPrompt] = useState("");
  const [isAiGenerating, setIsAiGenerating] = useState(false);
  const [refinementBackup, setRefinementBackup] = useState(null);
  const [isCheckingSimilarity, setIsCheckingSimilarity] = useState(false);
  const [isMatchingBeforePublish, setIsMatchingBeforePublish] = useState(false);
  const [isAiGeneratingImage, setIsAiGeneratingImage] = useState(false);
  const [aiCustomImagePrompt, setAiCustomImagePrompt] = useState("");
  const [isFileUploading, setIsFileUploading] = useState(false);
  const [aiGeneratingStep, setAiGeneratingStep] = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showPublishModal, setShowPublishModal] = useState(false);
  const [isLastOperationUpdate, setIsLastOperationUpdate] = useState(false);
  const [aiModalOpen, setAiModalOpen] = useState(false);
  const [customAlert, setCustomAlert] = useState({
    isOpen: false,
    title: "",
    message: "",
    type: "info"
  });

  const triggerAlert = (message, title = "Validation Alert", type = "warning") => {
    setCustomAlert({
      isOpen: true,
      title,
      message,
      type
    });
  };

  const [draftsModalOpen, setDraftsModalOpen] = useState(false);
  const [draftsList, setDraftsList] = useState([]);
  const [isLoadingDrafts, setIsLoadingDrafts] = useState(false);

  const fetchDrafts = async () => {
    const token = props.Auth?.user?.token;
    if (!token) return;
    setIsLoadingDrafts(true);
    try {
      const data = await getArticles(
        {
          pageNo: 1,
          limit: 100,
          status: "Draft"
        },
        token
      );
      if (data && data.articles && data.articles.docs) {
        setDraftsList(data.articles.docs);
      }
    } catch (err) {
      console.error("Failed to fetch drafts:", err);
    } finally {
      setIsLoadingDrafts(false);
    }
  };

  useEffect(() => {
    if (draftsModalOpen) {
      fetchDrafts();
    }
  }, [draftsModalOpen]);

  useEffect(() => {
    const fetchAllLiveSelectorOptions = async () => {
      const token = props.Auth?.user?.token;
      if (!token) return;
      try {
        // Fetch published articles (limit 100 to get a rich representative list)
        const res = await getArticles({ pageNo: 1, limit: 100 }, token);
        if (res && res.articles && res.articles.docs) {
          const docs = res.articles.docs;
          
          // Combine ALL database articles (including DOCTORS_CORNER and TIPS) into a single related blogs list
          const combinedArticlesList = docs
            .filter(d => d.status !== "Draft" && (
              d.postType === "Article" || 
              d.postType === "Encyclopedia" || 
              d.articleType === "ARTICLE" || 
              d.articleType === "DOCTORS_CORNER" || 
              d.articleType === "TIPS" || 
              !d.articleType
            ))
            .map(d => `${d.title}|/blogs/${d.permalink}`);
          
          if (combinedArticlesList.length > 0) {
            setDbArticles(combinedArticlesList);
          }
          // Keep dbEncyclopedia empty so the UI always defaults to the clean /encyclopedia landing routes
          setDbEncyclopedia([]);
        }
      } catch (err) {
        console.error("[Selector Prepopulator] Failed to fetch live articles for cross-linking:", err);
      }
    };
    fetchAllLiveSelectorOptions();
  }, [props.Auth?.user?.token]);

  const loadDraftIntoEditor = (a) => {
    if (!a || !a._id) return;
    isPopulatingRef.current = true;
    populatedIdRef.current = a._id;
    setArticleId(a._id);
    aiSlugRef.current = a.permalink || null;
    setInitialSeoScore(a.seoScore || null);
    setInitialHealthScore(a.healthScore || null);
    setTitle(a.title || "");
    if (a.permalink) setSlug(a.permalink);

    setCategory(Array.isArray(a.pageCategory) ? (a.pageCategory[0] || "") : (a.pageCategory || ""));
    setQuickAnswer(a.quickAnswer || "");
    setTakeaways(Array.isArray(a.takeaways) ? a.takeaways : []);
    setMainArticleText(a.description || "");
    setRelevanceSAARC(a.relevanceSAARC || "");
    setRelevanceMENA(a.relevanceMENA || "");
    setRelevanceAsia(a.relevanceAsia || "");
    setRelevanceEurope(a.relevanceEurope || "");
    setMarketAnalysisTitle(a.analysisTitle || "");
    setMarketAnalysisDesc(a.analysisDesc || "");
    setMarketAnalysisUrl(a.analysisUrl || "");
    setFaqs(Array.isArray(a.faqs) ? a.faqs : []);
    setSources(Array.isArray(a.sources) ? a.sources : []);
    setMetaTitle(a.metaTitle || "");
    setMetaDescription(a.metaDescription || "");
    setFocusKeyword(a.focusKeyword || "");
    setSecondaryKeywords(a.secondaryKeywords || "");
    setFeaturedImage(a.articleImage?.[0]?.url || "");
    setPostType(a.postType || "Article");
    setParentPage(a.parentPage || "");
    setSubCategory(a.subCategory || "");
    setTertiaryCategory(a.tertiaryCategory || "");
    setDetailValue(a.detailValue || "");
    setMappedLocation(a.mappedLocation || "");
    setCountry(a.country || "Pakistan");
    setProvince(a.province || "Punjab");
    setCity(a.city || "All Cities");
    setLanguage(a.language || "English");
    setStatus(a.status || "Draft");
    setArticleEmbedding(Array.isArray(a.articleEmbedding) ? a.articleEmbedding : []);
    setCanonicalUrl(a.canonicalUrl || "");
    setSchemaType(a.schemaType || "");
    setRelatedRatesSelected(Array.isArray(a.relatedRatesSelected) ? a.relatedRatesSelected : []);
    setEncyclopediaSelected(Array.isArray(a.encyclopediaSelected) ? a.encyclopediaSelected : []);
    setRelatedArticlesSelected(Array.isArray(a.relatedArticlesSelected) ? a.relatedArticlesSelected : []);
    if (a.createdBy) setAuthor(a.createdBy);
    if (typeof a.showTopRates === "boolean") setShowTopRates(a.showTopRates);
    if (typeof a.showPopularTags === "boolean") setShowPopularTags(a.showPopularTags);
    if (typeof a.showSocialLinks === "boolean") setShowSocialLinks(a.showSocialLinks);
    if (typeof a.showDownloadAppToggle === "boolean") setShowDownloadAppToggle(a.showDownloadAppToggle);
    if (typeof a.showAdsToggle === "boolean") setShowAdsToggle(a.showAdsToggle);
    if (typeof a.stickySidebarToggle === "boolean") setStickySidebarToggle(a.stickySidebarToggle);

    if (a.publishedAt) {
      setPublishDate(new Date(a.publishedAt).toISOString().split("T")[0]);
    } else if (a.createdAt) {
      setPublishDate(new Date(a.createdAt).toISOString().split("T")[0]);
    }
    if (a.updatedAt) {
      setUpdatedDate(new Date(a.updatedAt).toISOString().split("T")[0]);
    } else if (a.createdAt) {
      setUpdatedDate(new Date(a.createdAt).toISOString().split("T")[0]);
    }

    setIsDirty(false);
    setToastMessage("Draft loaded successfully! ready to write or publish.");
    setTimeout(() => {
      isPopulatingRef.current = false;
      setIsDirty(false);
      setToastMessage("");
    }, 150);
    setDraftsModalOpen(false); // Close modal when a draft is loaded
  };

  // Section Refiner Panel State
  const [sectionRefinerOpen, setSectionRefinerOpen] = useState(false);
  const [refinerSectionName, setRefinerSectionName] = useState("");
  const [refinerSectionKey, setRefinerSectionKey] = useState("");
  const [refinerCurrentValue, setRefinerCurrentValue] = useState(null);
  const [refinerInstruction, setRefinerInstruction] = useState("");
  const [isRefiningSection, setIsRefiningSection] = useState(false);
  const [imagePromptModalOpen, setImagePromptModalOpen] = useState(false);

  const sections = {
    header: "Article Header",
    author: "Author Roles",
    quickAnswer: "Quick Answer Block",
    takeaways: "Key Takeaways",
    mainArticle: "Main Article Content",
    marketRelevance: "Market Relevance Commentary",
    faqs: "Faqs Section",
    selectors: "Cross Linking Pages",
    seo: "SEO Settings Panel",
    sidebarSettings: "Sidebar Configurations"
  };

  useEffect(() => {
    if (isFirstMount.current) {
      isFirstMount.current = false;
      return;
    }
    if (isPopulatingRef.current) {
      return;
    }
    setIsDirty(true);
  }, [
    title, slug, category, country, province, city, language, status, publishDate, updatedDate,
    author, reviewer, editor, factChecker, publisher, quickAnswer, takeaways, mainArticleText,
    relevanceSAARC, relevanceMENA, relevanceAsia, relevanceEurope,
    analysisTitle, analysisDesc, analysisUrl, sources, faqs, relatedRatesSelected,
    encyclopediaSelected, relatedArticlesSelected, metaTitle, metaDescription, focusKeyword,
    secondaryKeywords, canonicalUrl, schemaType, showTopRates, showPopularTags,
    showSocialLinks, showDownloadAppToggle, showAdsToggle, stickySidebarToggle,
    postType, mappedLocation, parentPage, subCategory, tertiaryCategory, detailValue
  ]);

  useEffect(() => {
    if (!title) {
      setSlug("");
      return;
    }

    // SAFEGUARD: If we are editing an already-published article, NEVER auto-overwrite the slug when editing the title.
    // This protects live SEO indexed page links from returning a 404 error on the live website.
    if (articleId && status === "Published") {
      return;
    }

    // If the AI provided a complete slug, use it once (it takes precedence).
    if (aiSlugRef.current) {
      setSlug(cleanSlug(aiSlugRef.current));
      aiSlugRef.current = null;
      return;
    }

    setSlug(cleanSlug(title));
  }, [title]);

  // Load an existing article (passed in when the admin clicks "AI Edit" in the
  // list) into every editor field, so editing reuses the full AI Article form.
  useEffect(() => {
    const a = props.editArticle;
    if (!a || Array.isArray(a) || !a._id) {
      resetFormState();
      return;
    }
    if (populatedIdRef.current === a._id) return; // already loaded
    isPopulatingRef.current = true;
    populatedIdRef.current = a._id;

    setArticleId(a._id);
    // Preserve the existing permalink instead of re-deriving it from the title.
    aiSlugRef.current = a.permalink || null;
    setInitialSeoScore(a.seoScore || null);
    setInitialHealthScore(a.healthScore || null);
    setTitle(a.title || "");
    if (a.permalink) setSlug(a.permalink);

    setCategory(Array.isArray(a.pageCategory) ? (a.pageCategory[0] || "") : (a.pageCategory || ""));
    setQuickAnswer(a.quickAnswer || "");
    setTakeaways(Array.isArray(a.takeaways) ? a.takeaways : []);
    setMainArticleText(a.description || "");
    setRelevanceSAARC(a.relevanceSAARC || "");
    setRelevanceMENA(a.relevanceMENA || "");
    setRelevanceAsia(a.relevanceAsia || "");
    setRelevanceEurope(a.relevanceEurope || "");
    setMarketAnalysisTitle(a.analysisTitle || "");
    setMarketAnalysisDesc(a.analysisDesc || "");
    setMarketAnalysisUrl(a.analysisUrl || "");
    setFaqs(Array.isArray(a.faqs) ? a.faqs : []);
    setSources(Array.isArray(a.sources) ? a.sources : []);
    setMetaTitle(a.metaTitle || "");
    setMetaDescription(a.metaDescription || "");
    setFocusKeyword(a.focusKeyword || "");
    setSecondaryKeywords(a.secondaryKeywords || "");
    setFeaturedImage(a.articleImage?.[0]?.url || "");
    setPostType(a.postType || "Article");
    setParentPage(a.parentPage || "");
    setSubCategory(a.subCategory || "");
    setTertiaryCategory(a.tertiaryCategory || "");
    setDetailValue(a.detailValue || "");
    setMappedLocation(a.mappedLocation || "");
    setCountry(a.country || "Pakistan");
    setProvince(a.province || "Punjab");
    setCity(a.city || "All Cities");
    setLanguage(a.language || "English");
    setStatus(a.status || "Published");
    setArticleEmbedding(Array.isArray(a.articleEmbedding) ? a.articleEmbedding : []);
    setCanonicalUrl(a.canonicalUrl || "");
    setSchemaType(a.schemaType || "");
    setRelatedRatesSelected(Array.isArray(a.relatedRatesSelected) ? a.relatedRatesSelected : []);
    setEncyclopediaSelected(Array.isArray(a.encyclopediaSelected) ? a.encyclopediaSelected : []);
    setRelatedArticlesSelected(Array.isArray(a.relatedArticlesSelected) ? a.relatedArticlesSelected : []);
    if (a.createdBy) setAuthor(a.createdBy);
    if (typeof a.showTopRates === "boolean") setShowTopRates(a.showTopRates);
    if (typeof a.showPopularTags === "boolean") setShowPopularTags(a.showPopularTags);
    if (typeof a.showSocialLinks === "boolean") setShowSocialLinks(a.showSocialLinks);
    if (typeof a.showDownloadAppToggle === "boolean") setShowDownloadAppToggle(a.showDownloadAppToggle);
    if (typeof a.showAdsToggle === "boolean") setShowAdsToggle(a.showAdsToggle);
    if (typeof a.stickySidebarToggle === "boolean") setStickySidebarToggle(a.stickySidebarToggle);

    if (a.publishedAt) {
      setPublishDate(new Date(a.publishedAt).toISOString().split("T")[0]);
    } else if (a.createdAt) {
      setPublishDate(new Date(a.createdAt).toISOString().split("T")[0]);
    }
    if (a.updatedAt) {
      setUpdatedDate(new Date(a.updatedAt).toISOString().split("T")[0]);
    } else if (a.createdAt) {
      setUpdatedDate(new Date(a.createdAt).toISOString().split("T")[0]);
    }

    setIsDirty(false);
    setTimeout(() => {
      isPopulatingRef.current = false;
      setIsDirty(false);
    }, 150);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.editArticle]);


  // Real-time automatic SEO meta-field self-healing & enrichment
  useEffect(() => {
    if (articleId || isPopulatingRef.current) return;
    if (!mainArticleText) return;

    const textOnly = mainArticleText.replace(/<[^>]*>/g, " ").trim();
    const firstSentence = textOnly.split(/[.!?]/)[0] || "";

    setFocusKeyword((prev) => {
      if (!prev || prev.trim() === "") {
        const rawKeyword = (title || "").trim().split(/\s+/).slice(0, 3).join(" ");
        // Strip out colons, commas, apostrophes, and punctuation
        return rawKeyword.replace(/[:,'"?]/g, "").trim() || "poultry industry";
      }
      return prev;
    });

    setMetaTitle((prev) => {
      if (!prev || prev.trim() === "") {
        return title || "";
      }
      return prev;
    });

    setMetaDescription((prev) => {
      const cleanPrev = (prev || "").trim();
      if (!cleanPrev || cleanPrev.length < 110) {
        // Discard too short or empty prev and take a clean slice from textOnly
        let descSnippet = textOnly.slice(0, 140);
        if (descSnippet.length > 160) {
          descSnippet = descSnippet.slice(0, 150);
        }
        if (descSnippet) {
          return descSnippet.trim() + ".";
        }
      }
      return prev;
    });
  }, [mainArticleText, title]);



  useEffect(() => {
    fetchDrafts();
  }, []);

  // Accessibility: Prevent background scrolling and support ESC key modal dismissal
  useEffect(() => {
    if (showSimilarityModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [showSimilarityModal]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && showSimilarityModal) {
        setShowSimilarityModal(false);
      }
    };
    window.addEventListener("keydown", handleEscape);
    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, [showSimilarityModal]);

  const articleStats = useMemo(() => {
    const textOnly = mainArticleText ? mainArticleText.replace(/<[^>]*>/g, " ") : "";
    const words = textOnly.trim().split(/\s+/).filter(Boolean).length;
    const readingTime = Math.max(1, Math.round(words / 200));
    return { words, readingTime };
  }, [mainArticleText]);

  const autoTOC = useMemo(() => {
    if (!mainArticleText) return [];
    const headingMatches = [...mainArticleText.matchAll(/<h[1-3][^>]*>(.*?)<\/h[1-3]>/gi)];
    return headingMatches.map((m, idx) => `${idx + 1}. ${m[1].replace(/<[^>]*>/g, "")}`);
  }, [mainArticleText]);

  const seoScore = useMemo(() => {
    let score = 20; // Base score
    
    // 1. Focus Keyword in Meta Title (flexible word-by-word match, or contains any core word)
    if (focusKeyword && metaTitle) {
      const words = focusKeyword.toLowerCase().split(/\s+/).filter(w => w.length > 2 && !["for", "the", "and", "with", "from", "of", "in", "to", "at", "by", "on", "a", "an"].includes(w));
      const cleanMeta = metaTitle.toLowerCase().replace(/[^a-z0-9]/g, "");
      const matches = words.some(w => cleanMeta.includes(w.replace(/[^a-z0-9]/g, ""))) || cleanMeta.includes(focusKeyword.toLowerCase().replace(/[^a-z0-9]/g, ""));
      if (matches) score += 20;
    } else if (metaTitle) {
      // If we have a meta title but focusKeyword is not set yet, give points
      score += 20;
    }

    // 2. Meta Description Length Check (Lenient: at least 70 characters is perfectly fine)
    if (metaDescription && metaDescription.length >= 70) {
      score += 20;
    }

    // 3. Word Count Check (Word count > 150)
    if (articleStats.words > 150) {
      score += 20;
    }

    // 4. Focus Keyword in Slug (flexible word-by-word match, or contains any core word)
    if (focusKeyword && slug) {
      const words = focusKeyword.toLowerCase().split(/\s+/).filter(w => w.length > 2 && !["for", "the", "and", "with", "from", "of", "in", "to", "at", "by", "on", "a", "an"].includes(w));
      const cleanSlug = slug.toLowerCase().replace(/[^a-z0-9]/g, "");
      const matches = words.some(w => {
        const cw = w.replace(/[^a-z0-9]/g, "");
        const cwSingular = cw.replace(/s$/, "");
        return cleanSlug.includes(cw) || cleanSlug.includes(cwSingular);
      }) || cleanSlug.includes(focusKeyword.toLowerCase().replace(/[^a-z0-9]/g, ""));
      if (matches) score += 20;
    } else if (slug) {
      // If slug is present, give points
      score += 20;
    }

    return Math.min(100, score);
  }, [metaTitle, metaDescription, focusKeyword, slug, articleStats.words]);

  const contentHealthScore = useMemo(() => {
    let score = 20; // Base score
    
    // 1. Numbers check (Does it contain numerical details, statistics, etc.?)
    if (/\d+/.test(mainArticleText || "")) {
      score += 15;
    }

    // 2. Tables check (Does it contain HTML or Markdown tables?)
    if ((mainArticleText || "").includes("<table>") || (mainArticleText || "").includes("<tr>") || /\|[-:]+\|/.test(mainArticleText || "")) {
      score += 20;
    }

    // 3. References check (Does it have external source links or references section?)
    const hasReferences = (sources && sources.length > 0) || 
                          (mainArticleText || "").toLowerCase().includes("reference") || 
                          (mainArticleText || "").toLowerCase().includes("source") || 
                          (mainArticleText || "").includes("http://") || 
                          (mainArticleText || "").includes("https://");
    if (hasReferences) {
      score += 15;
    }

    // 4. Headings & Structure check (Does it contain proper sub-headings for SEO/readability?)
    const hasStructure = (mainArticleText || "").includes("<h2>") || 
                         (mainArticleText || "").includes("<h3>") || 
                         (mainArticleText || "").includes("<h4>") || 
                         (mainArticleText || "").includes("##") || 
                         (mainArticleText || "").includes("<ul>") || 
                         (mainArticleText || "").includes("<ol>");
    if (hasStructure) {
      score += 15;
    }

    // 5. Completeness check (Does it have FAQs or Takeaways?)
    if ((takeaways && takeaways.length > 0) || (faqs && faqs.length > 0)) {
      score += 15;
    }

    return Math.min(100, score);
  }, [mainArticleText, sources, takeaways, faqs]);

  const completionProgress = contentHealthScore;

  const displayHealthScore = useMemo(() => {
    if (articleId && !isDirty && initialHealthScore !== null) {
      return initialHealthScore;
    }
    return contentHealthScore;
  }, [articleId, isDirty, initialHealthScore, contentHealthScore]);

  const displaySeoScore = useMemo(() => {
    if (articleId && !isDirty && initialSeoScore !== null) {
      return initialSeoScore;
    }
    return seoScore;
  }, [articleId, isDirty, initialSeoScore, seoScore]);

  const isLegacyArticle = useMemo(() => {
    if (!articleId) return false;
    return (
      !quickAnswer || 
      !takeaways || takeaways.length === 0 || 
      !faqs || faqs.length === 0 || 
      !relevanceSAARC || !relevanceAsia
    );
  }, [articleId, quickAnswer, takeaways, faqs, relevanceSAARC, relevanceAsia]);

  // Dynamic status-loader timeline for premium AI experience
  const stepMessages = [
    "Initiating real-time Google Search for the target keyword...",
    "Crawling and analyzing top 3 Google ranking publications...",
    "Extracting best insights, factual statistics, and market rates from top sources...",
    "Fusing Google ranking data with localized Punjab and global poultry parameters...",
    "Weaving a search-optimized masterpiece article with high-value headings...",
    "Integrating HTML analytical tables and professional FAO/USDA citations...",
    "Curating stunning high-definition professional background banner from Unsplash...",
    "Validating structured response schemas. Almost done!..."
  ];

  useEffect(() => {
    let interval;
    if (isAiGenerating) {
      interval = setInterval(() => {
        setAiGeneratingStep((prev) => (prev + 1) % stepMessages.length);
      }, 3000);
    } else {
      setAiGeneratingStep(0);
    }
    return () => clearInterval(interval);
  }, [isAiGenerating]);

  // AI Content Writer: Initial generation & Refinement
  const handleAIGeneration = async (isRefinement = false, forceGenerate = false, customTitle = null) => {
    const token = props.Auth?.user?.token;
    if (!token) {
      triggerAlert("Error: Admin Token not found! Please check if you are logged in.", "Session Expired", "error");
      return;
    }

    const activeTitle = customTitle || (isRefinement ? "" : aiInputTitle);
    if (!isRefinement && !activeTitle.trim()) {
      triggerAlert("Please write an article title to generate!", "Title Mandatory", "warning");
      return;
    }

    if (isRefinement && !aiRefinementPrompt.trim()) {
      triggerAlert("Please enter refinement instructions for the AI assistant!", "Prompt Mandatory", "warning");
      return;
    }

    setIsAiGenerating(true);
    if (isRefinement) {
      setRefinementBackup({
        title,
        category,
        quickAnswer,
        takeaways: [...takeaways],
        mainArticleText,
        relevanceSAARC,
        relevanceMENA,
        relevanceAsia,
        relevanceEurope,
        analysisTitle,
        analysisDesc,
        analysisUrl,
        faqs: [...faqs],
        sources: [...sources],
        metaTitle,
        metaDescription,
        focusKeyword,
        secondaryKeywords,
        featuredImage,
        articleEmbedding: [...articleEmbedding]
      });
    }
    try {
      const payload = isRefinement ? {
        refinementPrompt: aiRefinementPrompt,
        postType,
        parentPage,
        subCategory,
        tertiaryCategory,
        detailValue,
        writingTone,
        currentArticle: {
          title, slug, category, country, province, city, language,
          author, reviewer, editor, factChecker, publisher,
          quickAnswer, takeaways, mainArticleText,
          relevanceSAARC, relevanceMENA, relevanceAsia, relevanceEurope,
          analysisTitle, analysisDesc, analysisUrl, sources, faqs,
          relatedRatesSelected, encyclopediaSelected, relatedArticlesSelected,
          metaTitle, metaDescription, focusKeyword, secondaryKeywords,
          canonicalUrl, schemaType, featuredImage
        }
      } : {
        title: activeTitle,
        postType,
        parentPage,
        subCategory,
        tertiaryCategory,
        detailValue,
        force: forceGenerate,
        country,
        province,
        city,
        writingTone
      };

      // Stage 2: text-only write. Similarity is now its own button (Check
      // Duplicates), and the banner/embedding are separate steps, so this call
      // is fast and never blocks on image generation.
      const res = await writeArticle(payload, token);

      if (res && res.success && res.article) {
        const art = res.article;

        // Populate all fields beautifully.
        // If the AI returned a complete slug, let it win over the title-derived one.
        if (art.slug) {
          aiSlugRef.current = art.slug;
        }
        if (art.title) {
          setTitle(art.title);
          // Set focus keyword based on title keywords if not returned
          if (!art.focusKeyword) {
            setFocusKeyword(art.title.split(" ").slice(0, 3).join(" "));
          }
        }
        if (art.category) setCategory(art.category);
        if (art.quickAnswer) setQuickAnswer(art.quickAnswer);
        if (art.takeaways) setTakeaways(art.takeaways);
        if (art.mainArticleText) setMainArticleText(art.mainArticleText);
        if (art.relevanceSAARC) setRelevanceSAARC(art.relevanceSAARC);
        if (art.relevanceMENA) setRelevanceMENA(art.relevanceMENA);
        if (art.relevanceAsia) setRelevanceAsia(art.relevanceAsia);
        if (art.relevanceEurope) setRelevanceEurope(art.relevanceEurope);
        if (art.analysisTitle) setMarketAnalysisTitle(art.analysisTitle);
        if (art.analysisDesc) setMarketAnalysisDesc(art.analysisDesc);
        if (art.analysisUrl) setMarketAnalysisUrl(art.analysisUrl);
        if (art.faqs) setFaqs(art.faqs);
        if (art.sources) setSources(art.sources);
        if (art.metaTitle) setMetaTitle(art.metaTitle);
        if (art.metaDescription) setMetaDescription(art.metaDescription);
        if (art.focusKeyword) setFocusKeyword(art.focusKeyword);
        if (art.secondaryKeywords) setSecondaryKeywords(art.secondaryKeywords);
        if (art.featuredImage) setFeaturedImage(art.featuredImage);

        setRelatedRatesSelected(Array.isArray(art.relatedRatesSelected) ? art.relatedRatesSelected : []);
        setEncyclopediaSelected(Array.isArray(art.encyclopediaSelected) ? art.encyclopediaSelected : []);
        setRelatedArticlesSelected(Array.isArray(art.relatedArticlesSelected) ? art.relatedArticlesSelected : []);

        // Store pre-calculated embedding
        if (art.articleEmbedding) {
          setArticleEmbedding(art.articleEmbedding);
        } else {
          setArticleEmbedding([]);
        }

        // Pre-fill premium author credibility roles
        setAuthor("Dr. Wahab Naveed");
        setReviewer("Poultry Baba Team");
        setEditor("Poultry Baba Team");
        setPublisher("Poultry Baba Publisher");
        setFactChecker("Poultry Baba Team");

        setToastMessage(isRefinement ? "Article refined beautifully!" : "Complete article generated in 4 seconds!");
        setTimeout(() => setToastMessage(""), 4000);

        // Trigger premium, beautiful custom English success modal
        setShowSuccessModal(true);

        if (isRefinement) {
          setAiRefinementPrompt("");
        } else {
          setAiInputTitle("");
        }
      } else {
        throw new Error("Could not parse article returned from backend.");
      }
    } catch (err) {
      console.error(err);
      alert(`Generation Failed: ${err.message || "Unknown error occurred"}`);
    } finally {
      setIsAiGenerating(false);
    }
  };

  const handleUndoRefinement = () => {
    if (!refinementBackup) return;

    setTitle(refinementBackup.title || "");
    setCategory(refinementBackup.category || "");
    setQuickAnswer(refinementBackup.quickAnswer || "");
    setTakeaways(Array.isArray(refinementBackup.takeaways) ? refinementBackup.takeaways : []);
    setMainArticleText(refinementBackup.mainArticleText || "");
    setRelevanceSAARC(refinementBackup.relevanceSAARC || "");
    setRelevanceMENA(refinementBackup.relevanceMENA || "");
    setRelevanceAsia(refinementBackup.relevanceAsia || "");
    setRelevanceEurope(refinementBackup.relevanceEurope || "");
    setMarketAnalysisTitle(refinementBackup.analysisTitle || "");
    setMarketAnalysisDesc(refinementBackup.analysisDesc || "");
    setMarketAnalysisUrl(refinementBackup.analysisUrl || "");
    setFaqs(Array.isArray(refinementBackup.faqs) ? refinementBackup.faqs : []);
    setSources(Array.isArray(refinementBackup.sources) ? refinementBackup.sources : []);
    setMetaTitle(refinementBackup.metaTitle || "");
    setMetaDescription(refinementBackup.metaDescription || "");
    setFocusKeyword(refinementBackup.focusKeyword || "");
    setSecondaryKeywords(refinementBackup.secondaryKeywords || "");
    setFeaturedImage(refinementBackup.featuredImage || "");
    setArticleEmbedding(Array.isArray(refinementBackup.articleEmbedding) ? refinementBackup.articleEmbedding : []);

    setRefinementBackup(null);
    setToastMessage("Undo Successful! Article restored.");
    setTimeout(() => setToastMessage(""), 4000);
  };

  // Stage 1: Check Duplicates — similarity only, no content generation.
  const handleCheckDuplicates = async () => {
    const token = props.Auth?.user?.token;
    if (!token) {
      alert("Error: Admin Token not found! Please check if you are logged in.");
      return;
    }
    const titleToCheck = aiInputTitle || title;
    if (!titleToCheck || !titleToCheck.trim()) {
      alert("Please write a title first so we can check for duplicates!");
      return;
    }

    setIsCheckingSimilarity(true);
    try {
      const res = await checkSimilarity({ title: titleToCheck }, token);
      if (res && res.isSimilar) {
        setSimilarityWarning(res.similarArticle);
        setAiSuggestedTitles(res.suggestedTitles || []);
        setAiModalOpen(false); // Close Smart Writer modal immediately for high-fidelity transition!
        setShowSimilarityModal(true); // Pop up the SEO safeguard duplicates modal!
      } else {
        setToastMessage("No near-duplicate found — you're good to write this title.");
        setTimeout(() => setToastMessage(""), 4000);
      }
    } catch (err) {
      console.error("Check Duplicates Error:", err);
      alert(`Duplicate check failed: ${err.message || "Unknown error occurred"}`);
    } finally {
      setIsCheckingSimilarity(false);
    }
  };

  // Stage 4: Match Before Publish — final safety gate against near-duplicates.
  // Returns true if it is safe to proceed with publishing.
  const handleMatchBeforePublish = async () => {
    const token = props.Auth?.user?.token;
    if (!token) {
      alert("Error: Admin Token not found! Please check if you are logged in.");
      return false;
    }
    if (!title || !title.trim()) {
      alert("Please provide a title before publishing!");
      return false;
    }

    setIsMatchingBeforePublish(true);
    try {
      // Exclude the current article so editing an existing one doesn't match itself.
      const res = await checkSimilarity({ title, excludeId: articleId || undefined }, token);
      if (res && res.isSimilar) {
        setSimilarityWarning(res.similarArticle);
        setAiSuggestedTitles(res.suggestedTitles || []);
        setShowSimilarityModal(true);
        return false;
      }
      setToastMessage("No near-duplicate found — safe to publish.");
      setTimeout(() => setToastMessage(""), 4000);
      return true;
    } catch (err) {
      console.error("Match Before Publish Error:", err);
      alert(`Similarity match failed: ${err.message || "Unknown error occurred"}`);
      return false;
    } finally {
      setIsMatchingBeforePublish(false);
    }
  };

  // Utility to load an image with anonymous CORS and draw watermark logo onto it
  const addLogoWatermarkAndUpload = (imageUrl, token) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = imageUrl;

      img.onload = () => {
        const logo = new Image();
        logo.src = "/image/logo.png";

        logo.onload = () => {
          try {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            const ctx = canvas.getContext("2d");

            // 1. Draw the generated image as background
            ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight);

            // 2. Calculate logo dimensions (logo is a square badge, let's size it to 18% of image height)
            const logoHeight = img.naturalHeight * 0.18;
            const logoWidth = logoHeight; // Logo is square

            // 3. Draw on top-right with 3% margin from top and right
            const marginX = img.naturalWidth * 0.03;
            const marginY = img.naturalHeight * 0.03;
            const logoX = img.naturalWidth - logoWidth - marginX;
            const logoY = marginY;

            ctx.drawImage(logo, logoX, logoY, logoWidth, logoHeight);

            // 4. Export to blob
            canvas.toBlob(
              async (blob) => {
                if (!blob) {
                  reject(new Error("Canvas toBlob failed"));
                  return;
                }
                try {
                  const watermarkedFile = new File([blob], "watermarked_banner.png", { type: "image/png" });
                  const formData = new FormData();
                  formData.append("thumbnail", watermarkedFile);

                  const resp = await uploadThumnail(formData, token, (percent) => {
                    console.log(`Watermarked upload progress: ${percent}%`);
                  });

                  if (resp && resp.thumbnailUrl) {
                    resolve(resp.thumbnailUrl);
                  } else {
                    reject(new Error("Uploader did not return URL."));
                  }
                } catch (uploadErr) {
                  reject(uploadErr);
                }
              },
              "image/png"
            );
          } catch (err) {
            reject(err);
          }
        };

        logo.onerror = () => {
          reject(new Error("Failed to load logo image /image/logo.png"));
        };
      };

      img.onerror = () => {
        reject(new Error("Failed to load generated AI image " + imageUrl));
      };
    });
  };

  // AI Custom Banner Image Writer: Generates gorgeous custom image using Google Imagen 3
  const handleGenerateAIImage = async () => {
    const token = props.Auth?.user?.token;
    if (!token) {
      alert("Error: Admin Token not found! Please check if you are logged in.");
      return;
    }

    const titleToUse = title || aiInputTitle;
    if (!aiCustomImagePrompt.trim() && (!titleToUse || !titleToUse.trim())) {
      alert("Please enter either an article title or a custom image prompt first so we can generate the banner!");
      return;
    }

    setIsAiGeneratingImage(true);
    try {
      const res = await generateAIImage({
        title: titleToUse,
        postType,
        customPrompt: aiCustomImagePrompt
      }, token);

      if (res && res.success && res.imageUrl) {
        setToastMessage("AI banner generated! Adding custom Poultry Baba logo watermark...");

        try {
          // Attempt to add logo watermark and upload
          const watermarkedUrl = await addLogoWatermarkAndUpload(res.imageUrl, token);
          setFeaturedImage(watermarkedUrl);
          setIsAiGeneratingImage(false);
          setAiCustomImagePrompt(""); // Reset custom prompt input field
          setToastMessage("Premium AI banner with logo generated and uploaded successfully!");
          setTimeout(() => setToastMessage(""), 4000);
        } catch (watermarkErr) {
          console.warn("Watermarking failed or blocked by CORS. Falling back to original AI image:", watermarkErr);

          // Fallback to original non-watermarked image
          const img = new Image();
          img.src = res.imageUrl;
          img.onload = () => {
            setFeaturedImage(res.imageUrl);
            setIsAiGeneratingImage(false);
            setAiCustomImagePrompt(""); // Reset custom prompt input field
            setToastMessage("AI banner set (without logo due to network configuration)!");
            setTimeout(() => setToastMessage(""), 4000);
          };
          img.onerror = () => {
            setFeaturedImage(res.imageUrl);
            setIsAiGeneratingImage(false);
          };
        }
      } else {
        setIsAiGeneratingImage(false);
        throw new Error(res.error || "No image URL returned from server.");
      }
    } catch (err) {
      setIsAiGeneratingImage(false);
      console.error("AI Image Generation Error:", err);
      alert(`Image Generation Failed: ${err.message || "Unknown error occurred"}`);
    }
  };

  // Section-specific AI Refinement runner & mapper
  const openSectionRefiner = (name, key, value) => {
    setRefinerSectionName(name);
    setRefinerSectionKey(key);
    setRefinerCurrentValue(value);
    setRefinerInstruction("");
    setSectionRefinerOpen(true);
  };

  const handleRunSectionRefinement = async () => {
    const token = props.Auth?.user?.token;
    if (!token) {
      alert("Error: Admin Token not found! Please check if you are logged in.");
      return;
    }

    if (!refinerInstruction.trim()) {
      alert("Please enter refinement instructions first!");
      return;
    }

    setIsRefiningSection(true);
    try {
      const res = await refineArticleSection({
        sectionName: refinerSectionName,
        sectionKey: refinerSectionKey,
        currentValue: refinerCurrentValue,
        instruction: refinerInstruction,
        articleTitle: title || "General Poultry Article"
      }, token);

      if (res && res.success) {
        const refined = res.refinedContent;

        // Map and update correct React states based on sectionKey
        switch (refinerSectionKey) {
          case "title":
            setTitle(refined);
            break;
          case "category":
            setCategory(refined);
            break;
          case "quickAnswer":
            setQuickAnswer(refined);
            break;
          case "takeaways":
            if (Array.isArray(refined)) {
              setTakeaways(refined);
            } else if (typeof refined === "string") {
              setTakeaways(refined.split("\n").map(t => t.replace(/^[-\s*•\d.]+\s*/, "").trim()).filter(Boolean));
            }
            break;
          case "mainArticleText":
            setMainArticleText(refined);
            break;
          case "relevanceSAARC":
            setRelevanceSAARC(refined);
            break;
          case "relevanceMENA":
            setRelevanceMENA(refined);
            break;
          case "relevanceAsia":
            setRelevanceAsia(refined);
            break;
          case "relevanceEurope":
            setRelevanceEurope(refined);
            break;
          case "faqs":
            if (Array.isArray(refined)) {
              setFaqs(refined);
            }
            break;
          case "analysisTitle":
            setMarketAnalysisTitle(refined);
            break;
          case "analysisDesc":
            setMarketAnalysisDesc(refined);
            break;
          case "metaTitle":
            setMetaTitle(refined);
            break;
          case "metaDescription":
            setMetaDescription(refined);
            break;
          case "focusKeyword":
            setFocusKeyword(refined);
            break;
          case "secondaryKeywords":
            setSecondaryKeywords(refined);
            break;
          default:
            console.warn("Unknown section key refined:", refinerSectionKey);
        }

        setToastMessage(`Section "${refinerSectionName}" refined successfully with AI!`);
        setTimeout(() => setToastMessage(""), 4000);
        setSectionRefinerOpen(false);
        setRefinerInstruction("");
      } else {
        throw new Error(res.error || "No content returned from server.");
      }
    } catch (err) {
      console.error("AI Section Refinement Error:", err);
      alert(`Section Refinement Failed: ${err.message || "Unknown error occurred"}`);
    } finally {
      setIsRefiningSection(false);
    }
  };

  // Connect & publish live to MongoDB via articles CRUD API
  const handleSave = async (publishMode = false) => {
    const token = props.Auth?.user?.token;
    if (!token) {
      triggerAlert("Error: Admin Token not found! Please check if you are logged in.", "Session Expired", "error");
      return;
    }

    // Frontend Validation: Ensure featured image is not empty before publishing live
    if (publishMode && (!featuredImage || !featuredImage.trim())) {
      triggerAlert("Validation Error: Featured Banner Image is mandatory! Please upload an image or paste a valid image URL before publishing live.", "Image Mandatory", "error");
      return;
    }
    // Ensure that a new article draft cannot be saved if the completion progress is 20% or less
    if (!publishMode && !articleId && completionProgress <= 20) {
      triggerAlert(`Draft Save Blocked: Content progress is only ${completionProgress}%. You must have more than 20% completion progress to save a new draft.\n\nPlease add more content fields or use Gemini AI to generate details first!`, "Draft Progress Blocked", "warning");
      return;
    }

    setIsSaving(true);
    try {
      const artPayload = {
        title,
        permalink: slug,
        pageCategory: [category],
        articleType: "ARTICLE",
        shortDescription: metaDescription || quickAnswer,
        description: mainArticleText,
        articleImage: featuredImage ? [{ name: "Hero Banner", url: featuredImage, altText: focusKeyword }] : [],
        tags: focusKeyword ? [focusKeyword, ...secondaryKeywords.split(",").map(s => s.trim()).filter(Boolean)] : [],
        status: publishMode ? "Published" : "Draft",
        healthScore: contentHealthScore,
        seoScore: seoScore,
        
        // Structured AI meta fields
        quickAnswer,
        takeaways,
        relevanceSAARC,
        relevanceMENA,
        relevanceAsia,
        relevanceEurope,
        analysisTitle,
        analysisDesc,
        analysisUrl,
        faqs,
        sources,
        relatedRatesSelected,
        encyclopediaSelected,
        relatedArticlesSelected,
        metaTitle,
        metaDescription,
        focusKeyword,
        secondaryKeywords,
        canonicalUrl,
        schemaType,
        showTopRates,
        showPopularTags,
        showSocialLinks,
        showDownloadAppToggle,
        showAdsToggle,
        stickySidebarToggle,
        createdBy: author || "Admin",
        postType,
        mappedLocation,
        parentPage,
        subCategory,
        tertiaryCategory,
        detailValue,
        country,
        province,
        city,
        language,
        articleEmbedding,
        publishedAt: publishDate ? new Date(publishDate) : new Date()
      };

      let resp;
      const wasUpdate = !!articleId;
      setIsLastOperationUpdate(wasUpdate);

      if (articleId) {
        // Update existing article
        resp = await updateArticle({ articleId, ...artPayload }, token, () => {});
      } else {
        // Create new article
        resp = await createArticle(artPayload, token, () => {});
      }

      if (resp && resp.article) {
        setIsDirty(false);
        setToastMessage(publishMode ? "Article published successfully to live website!" : "Draft saved successfully!");
        setTimeout(() => setToastMessage(""), 4000);

        if (!publishMode) {
          // Clear all form fields so the form does not remain filled
          resetFormState();
          
          // Redirect the user back to the Saved Drafts list after 1 second
          if (props.setSelected) {
            setTimeout(() => {
              props.setSelected("Drafts");
            }, 1000);
          }
        } else {
          // Trigger premium custom English/Urdu save & publish success modal
          setShowPublishModal(true);
          setRefinementBackup(null); // Clear "Undo AI Refine" when successfully published

          // Clear all form fields so it is empty and ready for the next article!
          setTitle("");
          setSlug("");
          setQuickAnswer("");
          setTakeaways([]);
          setMainArticleText("");
          setAuthor("");
          setReviewer("");
          setEditor("");
          setPublisher("");
          setFactChecker("");
          setRelevanceSAARC("");
          setRelevanceMENA("");
          setRelevanceAsia("");
          setRelevanceEurope("");
          setMarketAnalysisTitle("");
          setMarketAnalysisDesc("");
          setMarketAnalysisUrl("");
          setFaqs([]);
          setSources([]);
          setMetaTitle("");
          setMetaDescription("");
          setFocusKeyword("");
          setSecondaryKeywords("");
          setCanonicalUrl("");
          setFeaturedImage("");
          setPostType("Article");
          setMappedLocation("Main Landing");
          setParentPage("Poultry");
          setSubCategory("General");
          setTertiaryCategory("");
          setDetailValue("");
          setArticleId(null);
          setStatus("Draft");
        }
      } else {
        throw new Error("API did not return a valid article object");
      }
    } catch (err) {
      console.error(err);
      const serverError = err.response?.data?.error || err.response?.data?.message || err.message || "Could not publish article";
      alert(`Save Failed: ${serverError}`);
    } finally {
      setIsSaving(false);
    }
  };

  const handleReset = () => {
    if (window.confirm("Are you sure you want to discard all changes?")) {
      setTitle("");
      setSlug("");
      setQuickAnswer("");
      setTakeaways([]);
      setMainArticleText("");
      setAuthor("");
      setReviewer("");
      setEditor("");
      setPublisher("");
      setFactChecker("");
      setRelevanceSAARC("");
      setRelevanceMENA("");
      setRelevanceAsia("");
      setRelevanceEurope("");
      setMarketAnalysisTitle("");
      setMarketAnalysisDesc("");
      setMarketAnalysisUrl("");
      setFaqs([]);
      setSources([]);
      setMetaTitle("");
      setMetaDescription("");
      setFocusKeyword("");
      setSecondaryKeywords("");
      setCanonicalUrl("");
      setFeaturedImage("");
      setPostType("Article");
      setMappedLocation("Main Landing");
      setParentPage("Poultry");
      setSubCategory("General");
      setTertiaryCategory("");
      setDetailValue("");
      setArticleId(null);
      setIsDirty(false);
      setToastMessage("Form completely reset.");
      setTimeout(() => setToastMessage(""), 2000);
    }
  };

  const scrollToSection = (id) => {
    setActiveSection(id);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  // Custom banner image uploader
  const handleImageChange = async (e) => {
    const token = props.Auth?.user?.token;
    if (!token) {
      alert("Admin session not found! Upload blocked.");
      return;
    }

    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("thumbnail", file);

      setToastMessage("Uploading custom banner...");
      setIsFileUploading(true);
      try {
        const resp = await uploadThumnail(formData, token, (percent) => {
          console.log(`Thumbnail upload percent: ${percent}%`);
        });
        if (resp && resp.thumbnailUrl) {
          // Pre-load image in browser memory so loader stays active until fully downloaded
          const img = new Image();
          img.src = resp.thumbnailUrl;
          img.onload = () => {
            setFeaturedImage(resp.thumbnailUrl);
            setIsFileUploading(false);
            setToastMessage("Custom banner uploaded and set!");
            setTimeout(() => setToastMessage(""), 3000);
          };
          img.onerror = () => {
            setFeaturedImage(resp.thumbnailUrl);
            setIsFileUploading(false);
            setTimeout(() => setToastMessage(""), 3000);
          };
        } else {
          setIsFileUploading(false);
          throw new Error("Uploader did not return thumbnail url.");
        }
      } catch (err) {
        setIsFileUploading(false);
        console.error(err);
        alert(`Upload Failed: ${err.message || "Cloud file upload failed"}`);
        setTimeout(() => setToastMessage(""), 3000);
      }
    }
  };

  const addTakeaway = () => {
    setTakeaways(["", ...takeaways]);
    setTimeout(() => {
      const el = document.getElementById("takeaway-input-0");
      if (el) el.focus();
    }, 50);
  };
  const updateTakeaway = (index, value) => {
    const list = [...takeaways];
    list[index] = value;
    setTakeaways(list);
  };
  const deleteTakeaway = (index) => setTakeaways(takeaways.filter((_, i) => i !== index));
  const moveTakeaway = (index, direction) => {
    if (direction === "up" && index === 0) return;
    if (direction === "down" && index === takeaways.length - 1) return;
    const target = direction === "up" ? index - 1 : index + 1;
    const list = [...takeaways];
    const temp = list[index];
    list[index] = list[target];
    list[target] = temp;
    setTakeaways(list);
  };

  const addFAQ = () => {
    setFaqs([{ question: "", answer: "" }, ...faqs]);
    setTimeout(() => {
      const el = document.getElementById("faq-input-0");
      if (el) el.focus();
    }, 50);
  };
  const updateFAQ = (index, field, value) => {
    const list = [...faqs];
    list[index][field] = value;
    setFaqs(list);
  };
  const deleteFAQ = (index) => setFaqs(faqs.filter((_, i) => i !== index));

  const addSource = () => {
    setSources([{ name: "", url: "", desc: "" }, ...sources]);
    setTimeout(() => {
      const el = document.getElementById("source-input-0");
      if (el) el.focus();
    }, 50);
  };
  const updateSource = (index, field, value) => {
    const list = [...sources];
    list[index][field] = value;
    setSources(list);
  };
  const deleteSource = (index) => setSources(sources.filter((_, i) => i !== index));

  return (
    <div className="cms-container text-slate-800 select-none">
      {/* Background Glowing Vector Orbs for Elite Depth */}
      <div style={{
        position: "absolute",
        top: "8%",
        right: "-5%",
        width: "500px",
        height: "500px",
        borderRadius: "50%",
        backgroundColor: "rgba(255, 159, 0, 0.045)",
        filter: "blur(120px)",
        pointerEvents: "none",
        zIndex: 0
      }}></div>
      <div style={{
        position: "absolute",
        bottom: "10%",
        left: "-5%",
        width: "550px",
        height: "550px",
        borderRadius: "50%",
        backgroundColor: "rgba(255, 159, 0, 0.03)",
        filter: "blur(130px)",
        pointerEvents: "none",
        zIndex: 0
      }}></div>
      {/* AI Processing modal blocker */}
      {isAiGenerating && (
        <div className="preview-modal-overlay" style={{ zIndex: 1000, display: "flex", alignItems: "center", justifyContent: "center", backdropFilter: "blur(12px)", backgroundColor: "rgba(15, 23, 42, 0.4)" }}>
          <div className="glass-panel text-center" style={{ width: "440px", height: "280px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", padding: "40px", borderRadius: "24px", border: "1px solid rgba(255, 255, 255, 0.4)", boxShadow: "0 20px 50px rgba(0,0,0,0.15)", boxSizing: "border-box" }}>
            <div className="spinner-spark" style={{ flexShrink: 0 }}>
              <Icons.Sparkles />
            </div>
            <h2 className="text-xl text-slate-900" style={{ fontWeight: "800", margin: "16px 0 8px", flexShrink: 0 }}>Gemini Content Engine Writing...</h2>
            <div className="text-xs text-slate-500 font-semibold" style={{ minHeight: "36px", margin: "0 auto 20px", display: "flex", alignItems: "center", justifyContent: "center", width: "100%", flexShrink: 0 }}>{stepMessages[aiGeneratingStep]}</div>
            <div style={{ width: "100%", height: "4px", backgroundColor: "#f1f5f9", borderRadius: "10px", overflow: "hidden", flexShrink: 0 }}>
              <div style={{ width: `${(aiGeneratingStep + 1) * (100 / stepMessages.length)}%`, height: "100%", backgroundColor: "#ffa000", borderRadius: "10px", transition: "width 0.8s ease" }}></div>
            </div>
          </div>
        </div>
      )}

      {/* Toast Alert Banner */}
      {isSavedToast && (
        <div style={{
          position: "fixed",
          top: "24px",
          right: "24px",
          zIndex: 9999999,
          backgroundColor: "#1e1b4b",
          color: "#ffffff",
          padding: "14px 24px",
          borderRadius: "14px",
          boxShadow: "0 20px 25px -5px rgba(251, 98, 34, 0.35), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          border: "2px solid #fb6222",
          display: "flex",
          alignItems: "center",
          gap: "12px",
          fontFamily: "Inter, sans-serif"
        }}>
          {/* Pulsing Orange Check Circle icon */}
          <div style={{
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            backgroundColor: "#fff7ed",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "2px solid #fb6222",
            flexShrink: 0
          }}>
            <svg style={{ width: "16px", height: "16px", color: "#fb6222" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <span style={{ fontSize: "14px", fontWeight: "800", letterSpacing: "0.2px" }}>
            {isSavedToast}
          </span>
        </div>
      )}

      {/* Unsaved Changes Header Alert */}
      {isDirty && (
        <div className="unsaved-header-strip transition-all duration-300">
          <div className="cms-flex cms-align-center cms-gap-2 text-slate-700 text-xs">
            <span style={{ width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#ff9f00", display: "inline-block" }}></span>
            <span style={{ fontWeight: "bold" }}>Unsaved draft:</span> You have unsaved updates on this article page.
          </div>
          <button onClick={() => handleSave(false)} className="cms-btn cms-btn-sm cms-btn-primary">
            Save Draft
          </button>
        </div>
      )}

      {/* CMS Top Header Bar */}
      <div className="cms-top-header glass-panel cms-flex cms-flex-col cms-gap-3" style={{ padding: "16px 24px", height: "auto" }}>
        {/* Row 1: Brand & Principal CTA */}
        <div className="cms-flex cms-flex-between cms-align-center cms-w-full">
          <div className="cms-flex cms-align-center cms-gap-3">
            <span className="icon-box"><Icons.Sparkles /></span>
            <div>
              <div className="cms-flex cms-align-center cms-gap-2">
                <h1 className="text-lg text-slate-900" style={{ margin: 0, fontWeight: "800", fontSize: "19px" }}>Poultry Baba Smart CMS</h1>
                <div className="cms-flex cms-align-center cms-gap-1 cms-status-pill" style={{ backgroundColor: "#f0fdf4", border: "1px solid #bbf7d0", padding: "2px 10px", borderRadius: "100px", color: "#16a34a" }}>
                  <span style={{ width: "6px", height: "6px", borderRadius: "50%", backgroundColor: isSaving ? "#d97706" : "#10b981", display: "inline-block" }}></span>
                  <span style={{ fontSize: "11px", fontWeight: "700" }}>{isSaving ? "Saving..." : "Connected & Secure"}</span>
                </div>
              </div>
              <p className="text-xs text-slate-500" style={{ margin: 0, marginTop: "2px" }}>Create, edit, optimize and publish interactive rich articles from one beautiful workspace.</p>
            </div>
          </div>

          {/* Action Buttons Group */}
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            {/* View Saved Drafts Modal Trigger Button */}
            <button
              type="button"
              onClick={() => {
                if (props.setSelected) {
                  props.setSelected("Drafts");
                } else {
                  setDraftsModalOpen(true);
                }
              }}
              style={{
                height: "42px",
                padding: "0 18px",
                fontSize: "13.5px",
                fontWeight: "750",
                borderRadius: "12px",
                border: "1.5px solid #1e293b",
                color: "#1e293b",
                backgroundColor: "#ffffff",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 10px rgba(30, 41, 59, 0.08)",
                whiteSpace: "nowrap"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#f8fafc";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#ffffff";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              <svg style={{ width: "16px", height: "16px", color: "#1e293b" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 19a2 2 0 01-2-2V7a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1M5 19h14a2 2 0 002-2v-5a2 2 0 00-2-2H9l-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
              Saved Drafts ({draftsList.length})
            </button>
            {/* Undo AI Refine Button */}
            {refinementBackup && (
              <button
                type="button"
                onClick={handleUndoRefinement}
                style={{
                  height: "42px",
                  padding: "0 18px",
                  fontSize: "13.5px",
                  fontWeight: "750",
                  borderRadius: "12px",
                  border: "1.5px solid #ef4444",
                  color: "#ef4444",
                  backgroundColor: "#fef2f2",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "6px",
                  transition: "all 0.2s ease",
                  boxShadow: "0 2px 10px rgba(239, 68, 68, 0.12)",
                  whiteSpace: "nowrap"
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#fee2e2";
                  e.currentTarget.style.transform = "translateY(-1px)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#fef2f2";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
              >
                <Icons.Undo /> Undo AI Refine
              </button>
            )}

            {/* Gemini AI Writer / Refiner Button */}
            <button
              type="button"
              onClick={() => setAiModalOpen(true)}
              style={{
                height: "42px",
                padding: "0 22px",
                fontSize: "14px",
                fontWeight: "800",
                borderRadius: "12px",
                boxShadow: articleId ? "0 4px 15px rgba(249, 115, 22, 0.35)" : "0 4px 15px rgba(255, 159, 0, 0.3)",
                background: articleId 
                  ? "linear-gradient(135deg, #f97316 0%, #ff9f00 100%)" 
                  : "linear-gradient(135deg, #ff9f00 0%, #ffb74d 100%)",
                border: "none",
                color: "#ffffff",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                transition: "all 0.2s ease",
                animation: "pulseRingGreen 2s infinite",
                whiteSpace: "nowrap"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.transform = "translateY(-1px)";
                e.currentTarget.style.boxShadow = articleId 
                  ? "0 6px 20px rgba(249, 115, 22, 0.5)" 
                  : "0 6px 20px rgba(255, 159, 0, 0.45)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = articleId 
                  ? "0 4px 15px rgba(249, 115, 22, 0.35)" 
                  : "0 4px 15px rgba(255, 159, 0, 0.3)";
              }}
            >
              <Icons.Sparkles style={{ width: "16px", height: "16px" }} />
              {articleId ? "AI Refine Article" : "Gemini AI Writer"}
            </button>
          </div>
        </div>

        {/* Row 2: Separator Line & Live Metrics Row */}
        <div style={{ width: "100%", height: "1px", backgroundColor: "#f1f5f9" }}></div>

        <div className="cms-flex cms-align-center cms-flex-between cms-w-full cms-top-metrics-row" style={{ gap: "12px", flexWrap: "wrap" }}>
          {/* Tracker 1: Content Quality */}
          <div className="cms-flex cms-align-center cms-gap-3 cms-flex-1 cms-metric-box" style={{ minWidth: "200px", backgroundColor: "#ffffff", padding: "8px 16px", borderRadius: "12px", border: "1px solid #e2e8f0" }}>
            <div style={{ position: "relative", width: "32px", height: "32px" }}>
              <svg style={{ width: "32px", height: "32px" }}>
                <circle className="circle-track" strokeWidth="2.5" stroke="#e2e8f0" fill="transparent" r="13" cx="16" cy="16" />
                <circle className="circle-progress progress-ring-circle" strokeWidth="2.5" strokeDasharray={`${2 * Math.PI * 13}`} strokeDashoffset={`${2 * Math.PI * 13 * (1 - displayHealthScore / 100)}`} strokeLinecap="round" stroke={displayHealthScore >= 80 ? "#10b981" : displayHealthScore >= 50 ? "#ff9f00" : "#ef4444"} fill="transparent" r="13" cx="16" cy="16" />
              </svg>
              <div style={{ position: "absolute", inset: 0, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "9px", fontWeight: "bold", color: displayHealthScore >= 80 ? "#10b981" : displayHealthScore >= 50 ? "#ff9f00" : "#ef4444" }}>{displayHealthScore}%</div>
            </div>
            <div>
              <p style={{ margin: 0, fontSize: "9px", textTransform: "uppercase", fontWeight: "bold", color: "#64748b", letterSpacing: "0.5px" }}>Content Quality</p>
              <p style={{ margin: 0, fontSize: "12.5px", fontWeight: "bold", color: "#1e293b" }}>Content Health Score</p>
            </div>
          </div>

          {/* Tracker 2: SEO Optimizer */}
          <div className="cms-flex cms-align-center cms-gap-3 cms-flex-1 cms-metric-box" style={{ minWidth: "200px", backgroundColor: "#ffffff", padding: "8px 16px", borderRadius: "12px", border: "1px solid #e2e8f0" }}>
            <div className="cms-flex cms-flex-center" style={{ width: "32px", height: "32px", borderRadius: "8px", fontWeight: "bold", fontSize: "12px", backgroundColor: displaySeoScore > 75 ? "#d1fae5" : "#fef3c7", color: displaySeoScore > 75 ? "#065f46" : "#b45309" }}>
              {displaySeoScore}
            </div>
            <div>
              <p style={{ margin: 0, fontSize: "9px", textTransform: "uppercase", fontWeight: "bold", color: "#64748b", letterSpacing: "0.5px" }}>SEO Optimizer</p>
              <p style={{ margin: 0, fontSize: "12.5px", fontWeight: "bold", color: "#1e293b" }}>Dynamic Score</p>
            </div>
          </div>

          {/* Tracker 3: Word Count */}
          <div className="cms-flex cms-align-center cms-gap-3 cms-flex-1 cms-metric-box" style={{ minWidth: "200px", backgroundColor: "#ffffff", padding: "8px 16px", borderRadius: "12px", border: "1px solid #e2e8f0" }}>
            <div className="cms-flex cms-flex-center" style={{ width: "32px", height: "32px", borderRadius: "8px", fontSize: "15px", backgroundColor: "#d1fae5", color: "#065f46" }}>
              <svg style={{ width: "16px", height: "16px" }} fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
            </div>
            <div>
              <p style={{ margin: 0, fontSize: "9px", textTransform: "uppercase", fontWeight: "bold", color: "#64748b", letterSpacing: "0.5px" }}>Word Count</p>
              <p style={{ margin: 0, fontSize: "12.5px", fontWeight: "bold", color: "#1e293b" }}>{articleStats.words} Words</p>
            </div>
          </div>

          {/* Tracker 4: Read Time */}
          <div className="cms-flex cms-align-center cms-gap-3 cms-flex-1 cms-metric-box" style={{ minWidth: "200px", backgroundColor: "#ffffff", padding: "8px 16px", borderRadius: "12px", border: "1px solid #e2e8f0" }}>
            <div className="cms-flex cms-flex-center" style={{ width: "32px", height: "32px", borderRadius: "8px", fontSize: "15px", backgroundColor: "#e0f2fe", color: "#0369a1" }}>
              <svg style={{ width: "16px", height: "16px" }} fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <p style={{ margin: 0, fontSize: "9px", textTransform: "uppercase", fontWeight: "bold", color: "#64748b", letterSpacing: "0.5px" }}>Read Time</p>
              <p style={{ margin: 0, fontSize: "12.5px", fontWeight: "bold", color: "#1e293b" }}>{articleStats.readingTime} Min</p>
            </div>
          </div>
        </div>
      </div>

      <div className="cms-w-full" style={{ padding: "24px" }}>
        <div className="cms-flex-col cms-gap-4" style={{ maxWidth: "1200px", margin: "0 auto" }}>

            {/* LEGACY / MANUAL ARTICLE AUTO-ENRICHMENT BANNER */}
            {isLegacyArticle && (
              <div 
                style={{
                  background: "linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%)",
                  border: "1.5px solid #fed7aa",
                  borderRadius: "16px",
                  padding: "20px 24px",
                  marginBottom: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "20px",
                  boxShadow: "0 10px 25px -5px rgba(249, 115, 22, 0.08)",
                  flexWrap: "wrap"
                }}
              >
                <div style={{ display: "flex", alignItems: "flex-start", gap: "16px", flex: "1", minWidth: "280px" }}>
                  <span style={{ fontSize: "28px", lineHeight: "1" }}>💡</span>
                  <div>
                    <h4 style={{ margin: 0, fontSize: "15px", fontWeight: "900", color: "#ea580c", letterSpacing: "-0.2px" }}>
                      Legacy / Manual Article Detected (Missing Structured Fields)
                    </h4>
                    <p style={{ margin: "4px 0 0 0", fontSize: "13px", color: "#7c2d12", fontWeight: "600", lineHeight: "1.5" }}>
                      This article was created from a legacy record or uploaded manually. Consequently, its advanced structured fields (such as Quick Answer, Checklist, FAQs, or Regional Market Relevance) are currently empty. You can automatically enrich and populate all of these missing fields with AI!
                    </p>
                    <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#9a3412", fontWeight: "500" }}>
                      Simply click the button on the right to open the AI panel, and then press <strong>"AI Refine Article"</strong> to fully optimize and enrich this article forever.
                    </p>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => setAiModalOpen(true)}
                  style={{
                    backgroundColor: "#ea580c",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "12px",
                    padding: "10px 20px",
                    fontSize: "13px",
                    fontWeight: "800",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(234, 88, 12, 0.25)",
                    transition: "all 0.2s ease",
                    whiteSpace: "nowrap"
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#c2410c";
                    e.currentTarget.style.transform = "translateY(-1px)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "#ea580c";
                    e.currentTarget.style.transform = "translateY(0)";
                  }}
                >
                  Auto-Enrich Missing Fields
                </button>
              </div>
            )}

            {/* POST-TYPE & DEEP CATEGORIZATION SELECTION HEADER CARD */}
            <div className="cms-card" style={{ borderLeft: "6px solid #ff9f00", background: "linear-gradient(to right, #ffffff, #fafafa)", boxShadow: "0 12px 30px rgba(0,0,0,0.04)", borderRadius: "20px" }}>
              <div className="cms-card-header" style={{ paddingBottom: "18px", borderBottom: "1.5px solid #f1f5f9" }}>
                <div className="cms-flex cms-align-center cms-gap-3">
                  <span className="icon-box" style={{ backgroundColor: "rgba(255, 159, 0, 0.1)", color: "#ff9f00", width: "42px", height: "42px", borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center" }}><Icons.Settings style={{ width: "20px", height: "20px" }} /></span>
                  <div>
                    <h2 style={{ margin: 0, fontSize: "19px", fontWeight: "900", letterSpacing: "-0.3px" }} className="text-slate-900">CMS Post-Type & Category Target Manager</h2>
                    <p style={{ margin: 0, fontSize: "12.5px" }} className="text-slate-500">Route your content dynamically to specific landing zones or the specialized Encyclopedia taxonomy.</p>
                  </div>
                </div>
              </div>

              <div className="cms-form-grid" style={{ gridTemplateColumns: "1fr", gap: "24px", marginTop: "24px" }}>
                {/* 1. Core Post Type Selection */}
                <div>
                  <label className="premium-label" style={{ fontSize: "12.5px", color: "#475569", fontWeight: "900", textTransform: "uppercase", letterSpacing: "0.8px", marginBottom: "12px", display: "block" }}>Select Publishing Format</label>
                  
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: "16px", marginTop: "10px" }}>
                    {/* FORMAT TILE 1: Standard Article */}
                    <div 
                      onClick={() => setPostType("Article")}
                      style={{
                        padding: "20px",
                        borderRadius: "16px",
                        border: postType === "Article" ? "2.5px solid #ff9f00" : "1.5px solid #e2e8f0",
                        background: postType === "Article" ? "linear-gradient(135deg, #ffffff, #fffaf6)" : "#ffffff",
                        boxShadow: postType === "Article" ? "0 10px 25px -5px rgba(255, 159, 0, 0.15)" : "none",
                        cursor: "pointer",
                        transition: "all 0.2s ease-in-out",
                        display: "flex",
                        alignItems: "center",
                        gap: "16px"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-3px)";
                        if (postType !== "Article") e.currentTarget.style.borderColor = "#ff9f00";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        if (postType !== "Article") e.currentTarget.style.borderColor = "#e2e8f0";
                      }}
                    >
                      <div style={{
                        width: "52px",
                        height: "52px",
                        borderRadius: "14px",
                        background: postType === "Article" ? "linear-gradient(135deg, #ff9f00, #ffb74d)" : "#f1f5f9",
                        color: postType === "Article" ? "#ffffff" : "#475569",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "24px",
                        transition: "all 0.2s ease",
                        boxShadow: postType === "Article" ? "0 4px 14px rgba(255, 159, 0, 0.3)" : "none"
                      }}>
                        📰
                      </div>
                      <div style={{ textAlign: "left" }}>
                        <h4 style={{ margin: "0 0 2px 0", fontSize: "16px", fontWeight: "900", color: postType === "Article" ? "#ff9f00" : "#1e293b" }}>Standard Article / Blog</h4>
                        <p style={{ margin: 0, fontSize: "12.5px", color: "#64748b", fontWeight: "500" }}>Long-form posts, news updates, or detailed market analysis.</p>
                      </div>
                    </div>

                    {/* FORMAT TILE 2: Encyclopedia Q&A */}
                    <div 
                      onClick={() => setPostType("Encyclopedia")}
                      style={{
                        padding: "20px",
                        borderRadius: "16px",
                        border: postType === "Encyclopedia" ? "2.5px solid #ffb74d" : "1.5px solid #e2e8f0",
                        background: postType === "Encyclopedia" ? "linear-gradient(135deg, #ffffff, #fffdfa)" : "#ffffff",
                        boxShadow: postType === "Encyclopedia" ? "0 10px 25px -5px rgba(255, 126, 64, 0.15)" : "none",
                        cursor: "pointer",
                        transition: "all 0.2s ease-in-out",
                        display: "flex",
                        alignItems: "center",
                        gap: "16px"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateY(-3px)";
                        if (postType !== "Encyclopedia") e.currentTarget.style.borderColor = "#ffb74d";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        if (postType !== "Encyclopedia") e.currentTarget.style.borderColor = "#e2e8f0";
                      }}
                    >
                      <div style={{
                        width: "52px",
                        height: "52px",
                        borderRadius: "14px",
                        background: postType === "Encyclopedia" ? "linear-gradient(135deg, #ffb74d, #ffa000)" : "#f1f5f9",
                        color: postType === "Encyclopedia" ? "#ffffff" : "#475569",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "24px",
                        transition: "all 0.2s ease",
                        boxShadow: postType === "Encyclopedia" ? "0 4px 14px rgba(255, 126, 64, 0.3)" : "none"
                      }}>
                        📖
                      </div>
                      <div style={{ textAlign: "left" }}>
                        <h4 style={{ margin: "0 0 2px 0", fontSize: "16px", fontWeight: "900", color: postType === "Encyclopedia" ? "#ffb74d" : "#1e293b" }}>Encyclopedia Short Q&A</h4>
                        <p style={{ margin: 0, fontSize: "12.5px", color: "#64748b", fontWeight: "500" }}>Short, deeply classified question-and-answer library entries.</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 2. Conditionally rendered targets based on selection */}
                {postType === "Article" ? (
                  <div style={{ backgroundColor: "#f8fafc", padding: "20px", borderRadius: "16px", border: "1.5px solid #e2e8f0" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "14px" }}>
                      <label className="premium-label" style={{ fontSize: "12.5px", fontWeight: "800", color: "#1e293b", margin: 0 }}>Target Page Target Location</label>
                    </div>
                    <p style={{ margin: "0 0 12px 0", fontSize: "12.5px", color: "#64748b", fontWeight: "500" }}>Choose precisely where on the live website this blog/news post will be featured.</p>
                    <select 
                      value={mappedLocation} 
                      onChange={(e) => setMappedLocation(e.target.value)}
                      className="premium-input"
                      style={{ backgroundColor: "#ffffff", height: "48px", fontSize: "14px", fontWeight: "700", color: "#1e293b", border: "2px solid #e2e8f0", borderRadius: "12px", padding: "0 16px" }}
                    >
                      <option value="Main Landing">Main Landing Page (Featured Blogs Grid)</option>
                      <option value="murghi mandi">Murghi Mandi Page (B2B Trade Index)</option>
                      <option value="Poultry Plaza">Poultry Plaza (Medicine & Feed Shop Guides)</option>
                      <option value="Poultry Rates">Poultry Rates Page (Daily Rates Commentary)</option>
                      <option value="Reviews">Reviews Section (Expert Poultry Testimonials)</option>
                    </select>
                  </div>
                ) : (
                  <div style={{ backgroundColor: "rgba(255, 159, 0, 0.02)", padding: "24px", borderRadius: "18px", border: "2px dashed rgba(255, 159, 0, 0.2)" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "18px" }}>
                      <span className="icon-box" style={{ width: "32px", height: "32px", backgroundColor: "rgba(255, 159, 0, 0.1)", color: "#ff9f00", fontSize: "13px", fontWeight: "bold", borderRadius: "8px" }}>QA</span>
                      <h4 style={{ margin: 0, fontSize: "14px", fontWeight: "900", color: "#0f172a" }}>Encyclopedia Taxonomy Classification</h4>
                    </div>

                    <div className="cms-form-grid cms-form-grid-3" style={{ gap: "20px" }}>
                      {/* Parent Page Selection */}
                      <div>
                        <label className="premium-label" style={{ fontSize: "12px", color: "#64748b", fontWeight: "800", textTransform: "uppercase" }}>Parent Category</label>
                        <select 
                          value={parentPage} 
                          onChange={(e) => {
                            const parent = e.target.value;
                            setParentPage(parent);
                            const defaults = ENCYCLOPEDIA_TAXONOMY[parent].subcategories;
                            setSubCategory(defaults[0] || "");
                            setTertiaryCategory("");
                          }}
                          className="premium-input"
                          style={{ backgroundColor: "#ffffff", height: "46px", fontSize: "13px", fontWeight: "700", border: "2px solid #e2e8f0", borderRadius: "10px" }}
                        >
                          <option value="Poultry">Poultry Knowledge Base</option>
                          <option value="Poultry Rates">Poultry Rates & Mandis</option>
                          <option value="Poultry Plaza">Poultry Plaza Store</option>
                          <option value="Breed">Poultry Breeds Encyclopedia</option>
                        </select>
                      </div>

                      {/* Subcategory Selection */}
                      <div>
                        <label className="premium-label" style={{ fontSize: "12px", color: "#64748b", fontWeight: "800", textTransform: "uppercase" }}>Sub-Category</label>
                        <select 
                          value={subCategory} 
                          onChange={(e) => {
                            setSubCategory(e.target.value);
                            setTertiaryCategory("");
                          }}
                          className="premium-input"
                          style={{ backgroundColor: "#ffffff", height: "46px", fontSize: "13px", fontWeight: "700", border: "2px solid #e2e8f0", borderRadius: "10px" }}
                        >
                          {ENCYCLOPEDIA_TAXONOMY[parentPage].subcategories.map(sub => (
                            <option key={sub} value={sub}>{sub}</option>
                          ))}
                        </select>
                      </div>

                      {/* Tertiary Category Selection (Salt / Detail) */}
                      <div>
                        <label className="premium-label" style={{ fontSize: "12px", color: "#64748b", fontWeight: "800", textTransform: "uppercase" }}>Tertiary Group / Detail</label>
                        {ENCYCLOPEDIA_TAXONOMY[parentPage].tertiary && ENCYCLOPEDIA_TAXONOMY[parentPage].tertiary[subCategory] ? (
                          <select 
                            value={tertiaryCategory} 
                            onChange={(e) => setTertiaryCategory(e.target.value)}
                            className="premium-input"
                            style={{ backgroundColor: "#ffffff", height: "46px", fontSize: "13px", fontWeight: "700", border: "2px solid #e2e8f0", borderRadius: "10px" }}
                          >
                            <option value="">-- Select Group --</option>
                            {ENCYCLOPEDIA_TAXONOMY[parentPage].tertiary[subCategory].map(tert => (
                              <option key={tert} value={tert}>{tert}</option>
                            ))}
                          </select>
                        ) : (
                          <input 
                            type="text" 
                            disabled 
                            placeholder="No subgroups available" 
                            className="premium-input" 
                            style={{ backgroundColor: "#f1f5f9", height: "46px", border: "1.5px solid #e2e8f0", borderRadius: "10px", cursor: "not-allowed", opacity: 0.6 }} 
                          />
                        )}
                      </div>
                    </div>

                    {/* Specific Detail (Salt / Breed Name) Input */}
                    <div style={{ marginTop: "20px" }}>
                      <label className="premium-label" style={{ fontSize: "12px", fontWeight: "800", color: "#1e293b" }}>Specific Chemical Salt / Breed / Brand Identifier (Optional)</label>
                      <p style={{ margin: "2px 0 10px 0", fontSize: "12px", color: "#64748b", fontWeight: "500" }}>Enter specific details like "Amoxicillin", "Tylosin Tartrate", or "Cobb 500" to bind this short Q&A to exact items.</p>
                      <input 
                        type="text" 
                        value={detailValue} 
                        onChange={(e) => setDetailValue(e.target.value)}
                        className="premium-input"
                        placeholder="e.g. 'Amoxicillin Trihydrate' or 'Ross 308'"
                        style={{ backgroundColor: "#ffffff", height: "46px", fontSize: "13px", fontWeight: "600", border: "2px solid #e2e8f0", borderRadius: "10px" }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* SECTION 1: HEADER SECTION */}
            <div id="header" className="cms-card" onClick={() => setActiveSection("header")}>
              <div className="cms-card-header">
                <div className="cms-flex cms-align-center cms-gap-3">
                  <span className="icon-box"><Icons.Header /></span>
                  <div>
                    <h2 style={{ margin: 0, fontSize: "16px", fontWeight: "bold" }} className="text-slate-900">1. Article Header & Metadata</h2>
                    <p style={{ margin: 0, fontSize: "12px" }} className="text-slate-500">Basic metadata and hero card details for website display.</p>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <button
                    type="button"
                    onClick={() => openSectionRefiner("Article Title", "title", title)}
                    className="ai-refine-trigger"
                  >
                    <Icons.Sparkles style={{ width: "13.5px", height: "13.5px", stroke: "currentColor" }} />
                    AI Refine Title
                  </button>
                  <div className="cms-flex cms-align-center cms-gap-2">
                    <span className="cms-badge cms-badge-amber">Header Meta</span>
                    <span className={`cms-badge ${status === "Published" ? "cms-badge-published" : "cms-badge-draft"}`}>
                      {status}
                    </span>
                  </div>
                </div>
              </div>

              <div className="cms-form-grid cms-form-grid-4">
                <div style={{ gridColumn: "span 4" }}>
                  <label className="premium-label">Article Title</label>
                  <input
                    type="text"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    className="premium-input text-slate-900"
                    style={{ fontWeight: "bold", fontSize: "16px" }}
                    placeholder="Enter article title..."
                  />
                </div>

                <div style={{ gridColumn: "span 2" }}>
                  <label className="premium-label">URL Slug (Auto Generated)</label>
                  <div className="premium-input cms-flex cms-align-center" style={{ backgroundColor: "#f8fafc" }}>
                    <span style={{ fontSize: "14px", color: "#94a3b8", marginRight: "4px" }}>/blogs/</span>
                    <input
                      type="text"
                      value={slug}
                      onChange={(e) => setSlug(e.target.value)}
                      style={{ border: "none", background: "transparent", outline: "none", width: "100%", fontSize: "14px", color: "#334155", fontWeight: "600" }}
                    />
                  </div>
                </div>

                <div style={{ gridColumn: "span 2" }}>
                  <label className="premium-label">Category (Target Website Section)</label>
                  <select value={category} onChange={(e) => setCategory(e.target.value)} className="premium-input" style={{ fontWeight: "700", color: "#1e293b" }}>
                    <option value="blogs">Main Blogs & Articles Page</option>
                    <option value="murghi mandi">Murghi Mandi Page</option>
                    <option value="Poultry plaza">Poultry Plaza Store Page</option>
                    <option value="poultry bazar">Poultry Bazar Page</option>
                    <option value="home">Home Page</option>
                    <option value="rates">Daily Rates Page</option>
                  </select>
                </div>

                {/* Hidden geographic metadata fields - handled automatically by smart AI detection */}
                {/* 
                <div style={{ gridColumn: "span 1" }}>
                  <label className="premium-label">Country</label>
                  <input type="text" value={country} onChange={(e) => setCountry(e.target.value)} className="premium-input" />
                </div>
                <div style={{ gridColumn: "span 1" }}>
                  <label className="premium-label">Province</label>
                  <input type="text" value={province} onChange={(e) => setProvince(e.target.value)} className="premium-input" />
                </div>
                <div style={{ gridColumn: "span 1" }}>
                  <label className="premium-label">City</label>
                  <input type="text" value={city} onChange={(e) => setCity(e.target.value)} className="premium-input" />
                </div>
                */}
                <div style={{ gridColumn: "span 1" }}>
                  <label className="premium-label">Article Language</label>
                  <select value={language} onChange={(e) => setLanguage(e.target.value)} className="premium-input">
                    <option>English</option>
                    <option>Urdu</option>
                  </select>
                </div>

                <div style={{ gridColumn: "span 1" }}>
                  <label className="premium-label">Publish Date</label>
                  <input type="date" value={publishDate} onChange={(e) => setPublishDate(e.target.value)} className="premium-input" />
                </div>
                <div style={{ gridColumn: "span 1" }}>
                  <label className="premium-label">Updated Date</label>
                  <input type="date" value={updatedDate} onChange={(e) => setUpdatedDate(e.target.value)} className="premium-input" />
                </div>
                <div style={{ gridColumn: "span 2" }}>
                  <label className="premium-label">Publish Status</label>
                  <div className="cms-flex cms-gap-2">
                    <button type="button" onClick={() => setStatus("Published")} className={`cms-btn ${status === "Published" ? "cms-btn-primary" : "cms-btn-secondary"}`} style={{ flex: 1 }}>
                      Published
                    </button>
                    <button type="button" onClick={() => setStatus("Draft")} className={`cms-btn ${status === "Draft" ? "cms-btn-primary" : "cms-btn-secondary"}`} style={{ flex: 1 }}>
                      Draft
                    </button>
                  </div>
                </div>

                {/* Featured Image upload zone */}
                <div style={{ gridColumn: "span 4", marginTop: "16px" }}>
                  <label className="premium-label">Featured Image (Upload file or Paste Browser URL)</label>
                  <div className="cms-flex-col cms-gap-4">
                    {/* Top Row: Two-column grid with Drag/Drop Left & Preview Right */}
                    <div className="cms-form-grid cms-form-grid-2" style={{ alignItems: "stretch" }}>
                      {/* Drag & drop zone */}
                      <div style={{ border: "2px dashed #cbd5e1", borderRadius: "12px", padding: "20px", textAlign: "center", backgroundColor: "#f8fafc", position: "relative", minHeight: "220px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", overflow: "hidden" }}>
                        <input
                          type="file"
                          accept="image/*"
                          onChange={handleImageChange}
                          disabled={isFileUploading || isAiGeneratingImage}
                          style={{ position: "absolute", inset: 0, opacity: 0, cursor: (isFileUploading || isAiGeneratingImage) ? "not-allowed" : "pointer" }}
                        />
                        <svg style={{ width: "32px", height: "32px", color: "#94a3b8", margin: "0 auto 12px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                        </svg>
                        <p style={{ margin: 0, fontSize: "14px", fontWeight: "bold", color: "#475569" }}>Click or drag a banner image here</p>
                        <p style={{ margin: "6px 0 0", fontSize: "12px", color: "#94a3b8" }}>Supports PNG, JPEG up to 3MB</p>

                        {/* File Uploading Glassmorphic Overlay */}
                        {isFileUploading && (
                          <div style={{
                            position: "absolute",
                            inset: 0,
                            backgroundColor: "rgba(255, 255, 255, 0.85)",
                            backdropFilter: "blur(4px)",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 10
                          }}>
                            <div className="premium-spinner" style={{
                              width: "36px",
                              height: "36px",
                              border: "3px solid #e2e8f0",
                              borderTop: "3px solid #f59e0b",
                              borderRadius: "50%",
                              animation: "spin 1s linear infinite",
                              marginBottom: "10px"
                            }} />
                            <span style={{ fontSize: "13px", fontWeight: "800", color: "#d97706", letterSpacing: "0.5px", textTransform: "uppercase" }}>Uploading File...</span>
                          </div>
                        )}
                      </div>

                      {/* Image Preview Box */}
                      <div style={{ backgroundColor: "#f8fafc", borderRadius: "12px", overflow: "hidden", border: "1px solid #e2e8f0", display: "flex", alignItems: "center", justifyContent: "center", minHeight: "220px", position: "relative" }}>
                        {featuredImage ? (
                          <img src={featuredImage} alt="Preview" style={{ width: "100%", height: "100%", objectFit: "cover", maxHeight: "300px" }} />
                        ) : (
                          <div className="text-center" style={{ padding: "20px" }}>
                            <span style={{ fontSize: "13px", color: "#94a3b8", fontWeight: "bold", display: "block" }}>No Image Selected</span>
                            <span style={{ fontSize: "12px", color: "#94a3b8", marginTop: "4px", display: "block" }}>Image is mandatory to save/publish!</span>
                          </div>
                        )}

                        {/* Custom Style Block for Infinite Spin Keyframe Animation */}
                        <style>{`
                          @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                          }
                        `}</style>

                        {/* AI Image Generation Glassmorphic Overlay */}
                        {isAiGeneratingImage && (
                          <div style={{
                            position: "absolute",
                            inset: 0,
                            backgroundColor: "rgba(15, 23, 42, 0.85)",
                            backdropFilter: "blur(5px)",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 10,
                            color: "#ffffff"
                          }}>
                            <div className="premium-spinner" style={{
                              width: "36px",
                              height: "36px",
                              border: "3px solid rgba(255,255,255,0.2)",
                              borderTop: "3px solid #fbbf24",
                              borderRadius: "50%",
                              animation: "spin 0.9s linear infinite",
                              marginBottom: "12px"
                            }} />
                            <span style={{ fontSize: "11px", fontWeight: "900", color: "#fbbf24", letterSpacing: "1px", textTransform: "uppercase", textAlign: "center", padding: "0 10px" }}>
                              Generating AI Banner...
                            </span>
                            <span style={{ fontSize: "9px", color: "#94a3b8", marginTop: "4px", textTransform: "uppercase" }}>Google Imagen 3 Active</span>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Custom Prompt Row: Custom AI prompt input for Imagen 3 */}
                    <div className="cms-flex-col cms-gap-1" style={{ width: "100%", borderTop: "1px dashed #e2e8f0", paddingTop: "14px", marginTop: "4px" }}>
                      <div className="cms-mobile-stack-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <label className="premium-label" style={{ fontSize: "12.5px", color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px", fontWeight: "700", margin: 0 }}>
                          Or Write Custom AI Image Prompt (Bypasses Title)
                        </label>
                        <button
                          type="button"
                          onClick={() => setImagePromptModalOpen(true)}
                          style={{
                            border: "none",
                            background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                            color: "#ffffff",
                            fontSize: "12.5px",
                            fontWeight: "800",
                            padding: "10px 18px",
                            borderRadius: "10px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            boxShadow: "0 4px 12px rgba(16, 185, 129, 0.25)",
                            opacity: isAiGeneratingImage ? 0.6 : 1,
                            pointerEvents: isAiGeneratingImage ? "none" : "auto",
                            transition: "all 0.2s"
                          }}
                        >
                          <Icons.Sparkles style={{ width: "13px", height: "13px" }} />
                          {isAiGeneratingImage ? "Generating banner..." : "AI Generate Custom Banner"}
                        </button>
                      </div>
                    </div>

                    {/* Bottom Row: URL Input stretching 100% full-width across its own row */}
                    <div className="cms-flex-col cms-gap-1" style={{ width: "100%", borderTop: "1px dashed #e2e8f0", paddingTop: "12px", marginTop: "4px" }}>
                      <div className="cms-mobile-stack-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "4px" }}>
                        <label className="premium-label" style={{ fontSize: "12px", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px", margin: 0 }}>
                          Or Paste image URL directly from browser
                        </label>
                        <button
                          type="button"
                          disabled={isAiGeneratingImage}
                          onClick={handleGenerateAIImage}
                          style={{
                            border: "none",
                            background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                            color: "#ffffff",
                            fontSize: "12.5px",
                            fontWeight: "800",
                            padding: "10px 18px",
                            borderRadius: "10px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            gap: "4px",
                            boxShadow: "0 4px 12px rgba(245, 158, 11, 0.25)",
                            opacity: isAiGeneratingImage ? 0.6 : 1,
                            pointerEvents: isAiGeneratingImage ? "none" : "auto",
                            transition: "all 0.2s"
                          }}
                        >
                          <Icons.Sparkles style={{ width: "13px", height: "13px" }} />
                          {isAiGeneratingImage ? "Generating banner..." : "AI Regenerate Banner"}
                        </button>
                      </div>
                      <input
                        type="text"
                        value={featuredImage || ""}
                        onChange={(e) => setFeaturedImage(e.target.value)}
                        className="premium-input"
                        placeholder="https://images.unsplash.com/photo-..."
                        style={{ height: "44px", width: "100%" }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* SECTION 2: AUTHOR SECTION */}
            <div id="author" className="cms-card" onClick={() => setActiveSection("author")}>
              <div className="cms-card-header">
                <div className="cms-flex cms-align-center cms-gap-3">
                  <span className="icon-box"><Icons.User /></span>
                  <div>
                    <h2 style={{ margin: 0, fontSize: "16px", fontWeight: "bold" }} className="text-slate-900">2. Author & Credibility Roles</h2>
                    <p style={{ margin: 0, fontSize: "12px" }} className="text-slate-500">Assign verified professionals to ensure trust and authenticity.</p>
                  </div>
                </div>
              </div>

              <div className="cms-form-grid cms-form-grid-3">
                <div>
                  <label className="premium-label">Author Name</label>
                  <input
                    type="text"
                    list="author-options"
                    value={author}
                    onChange={(e) => setAuthor(e.target.value)}
                    className="premium-input"
                    style={{ fontWeight: "700", color: "#1e293b" }}
                    placeholder="Select or type author name..."
                  />
                  <datalist id="author-options">
                    <option value="Dr. Wahab Naveed" />
                    <option value="Farjad Mousa" />
                    <option value="Zaheer Abbas Malik" />
                  </datalist>
                </div>
                <div>
                  <label className="premium-label">Reviewer</label>
                  <input type="text" value={reviewer} onChange={(e) => setReviewer(e.target.value)} className="premium-input" />
                </div>
                <div>
                  <label className="premium-label">Editor</label>
                  <input type="text" value={editor} onChange={(e) => setEditor(e.target.value)} className="premium-input" />
                </div>
                <div>
                  <label className="premium-label">Fact Checker</label>
                  <input type="text" value={factChecker} onChange={(e) => setFactChecker(e.target.value)} className="premium-input" />
                </div>
                <div>
                  <label className="premium-label">Publisher</label>
                  <input type="text" value={publisher} onChange={(e) => setPublisher(e.target.value)} className="premium-input" />
                </div>
              </div>
            </div>

            {/* SECTION 3: QUICK ANSWER SECTION */}
            <div id="quickAnswer" className="cms-card" onClick={() => setActiveSection("quickAnswer")}>
              <div className="cms-card-header">
                <div className="cms-flex cms-align-center cms-gap-3">
                  <span className="icon-box"><Icons.Sparkles /></span>
                  <div>
                    <h2 style={{ margin: 0, fontSize: "16px", fontWeight: "bold" }} className="text-slate-900">3. Quick Answer Block (AI Rich Box)</h2>
                    <p style={{ margin: 0, fontSize: "12px" }} className="text-slate-500">Concise answer shown inside high-visibility widget at start of the post.</p>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <button
                    type="button"
                    onClick={() => openSectionRefiner("Quick Answer Block", "quickAnswer", quickAnswer)}
                    className="ai-refine-trigger"
                  >
                    <Icons.Sparkles style={{ width: "13.5px", height: "13.5px", stroke: "currentColor" }} />
                    AI Refine
                  </button>
                  <span className="cms-badge cms-badge-published" style={{ fontFamily: "monospace" }}>
                    {quickAnswer ? quickAnswer.length : 0} / 400 Chars
                  </span>
                </div>
              </div>

              <div>
                <textarea
                  value={quickAnswer}
                  onChange={(e) => setQuickAnswer(e.target.value.substring(0, 400))}
                  rows="4"
                  className="premium-input"
                  style={{ borderLeft: "4px solid #ff9f00", paddingLeft: "16px", fontStyle: "italic", fontFamily: "serif", backgroundColor: "#f8fafc" }}
                  placeholder="Give a summary answer to user queries..."
                ></textarea>
                <p style={{ fontSize: "12px", color: "#94a3b8", marginTop: "4px" }}>This box is optimized for immediate answers on mobile screens, keep it precise under 400 characters.</p>
              </div>
            </div>

            {/* SECTION 4: KEY TAKEAWAYS SECTION */}
            <div id="takeaways" className="cms-card" onClick={() => setActiveSection("takeaways")}>
              <div className="cms-card-header">
                <div className="cms-flex cms-align-center cms-gap-3">
                  <span className="icon-box"><Icons.List /></span>
                  <div>
                    <h2 style={{ margin: 0, fontSize: "16px", fontWeight: "bold" }} className="text-slate-900">4. Key Takeaways Checklist</h2>
                    <p style={{ margin: 0, fontSize: "12px" }} className="text-slate-500">A dynamic list of summarized points displayed with check marks.</p>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <button
                    type="button"
                    onClick={() => openSectionRefiner("Key Takeaways Checklist", "takeaways", takeaways)}
                    className="ai-refine-trigger"
                  >
                    <Icons.Sparkles style={{ width: "13.5px", height: "13.5px", stroke: "currentColor" }} />
                    AI Refine
                  </button>
                  <button
                    type="button"
                    onClick={addTakeaway}
                    className="cms-btn cms-btn-sm cms-btn-dark"
                  >
                    <Icons.Plus /> Add Point
                  </button>
                </div>
              </div>

              <div className="cms-flex-col cms-gap-2">
                {takeaways && takeaways.map((point, index) => (
                  <div key={index} className="cms-flex cms-align-center cms-gap-2 bg-slate-50" style={{ padding: "8px 12px", border: "1px solid #cbd5e1", borderRadius: "10px" }}>
                    <div className="cms-flex cms-flex-center" style={{ width: "24px", height: "24px", borderRadius: "50%", backgroundColor: "#ecfdf5", color: "#10b981" }}>
                      <Icons.Check style={{ color: "#10b981", width: "12px", height: "12px" }} />
                    </div>
                    <input
                      id={`takeaway-input-${index}`}
                      type="text"
                      value={point}
                      onChange={(e) => updateTakeaway(index, e.target.value)}
                      style={{ border: "none", background: "transparent", outline: "none", width: "100%", fontSize: "13px", color: "#334155", fontWeight: "600" }}
                      placeholder="Enter critical takeaway point..."
                    />
                    
                    {/* Reordering and Delete controls */}
                    <div className="cms-flex cms-gap-1">
                      <button type="button" onClick={() => moveTakeaway(index, "up")} disabled={index === 0} className="cms-btn cms-btn-secondary" style={{ padding: "4px 8px" }}>
                        <Icons.ArrowUp />
                      </button>
                      <button type="button" onClick={() => moveTakeaway(index, "down")} disabled={index === takeaways.length - 1} className="cms-btn cms-btn-secondary" style={{ padding: "4px 8px" }}>
                        <Icons.ArrowDown />
                      </button>
                      <button type="button" onClick={() => deleteTakeaway(index)} className="cms-btn cms-btn-danger" style={{ padding: "4px 8px" }}>
                        <Icons.Trash />
                      </button>
                    </div>
                  </div>
                ))}

                {(!takeaways || takeaways.length === 0) && (
                  <div style={{ textAlign: "center", padding: "20px", border: "1px dashed #cbd5e1", borderRadius: "12px", color: "#94a3b8", fontSize: "12px" }}>
                    No takeaways added. Click "+ Add Point" to create.
                  </div>
                )}
              </div>
            </div>

            {/* SECTION 5: MAIN ARTICLE CONTENT (RICH BLOCK EDITOR) */}
            <div id="mainArticle" className="cms-card" onClick={() => setActiveSection("mainArticle")}>
              <div className="cms-card-header">
                <div className="cms-flex cms-align-center cms-gap-3">
                  <span className="icon-box"><Icons.Header /></span>
                  <div>
                    <h2 style={{ margin: 0, fontSize: "16px", fontWeight: "bold" }} className="text-slate-900">5. Main Article Rich-Content Editor</h2>
                    <p style={{ margin: 0, fontSize: "12px" }} className="text-slate-500">Edit core body text. Automatic Table of Contents will scan headings from this workspace.</p>
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <button
                    type="button"
                    onClick={() => openSectionRefiner("Main Article Content", "mainArticleText", mainArticleText)}
                    className="ai-refine-trigger"
                  >
                    <Icons.Sparkles style={{ width: "13.5px", height: "13.5px", stroke: "currentColor" }} />
                    AI Refine
                  </button>
                  <div className="cms-flex cms-gap-2">
                    <span className="cms-badge cms-badge-draft">Words: {articleStats.words}</span>
                    <span className="cms-badge cms-badge-amber">Reading: {articleStats.readingTime} min</span>
                  </div>
                </div>
              </div>

              {/* Gutenberg mock formatting Toolbar */}
              <div className="editor-toolbar" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 16px" }}>
                <div style={{ display: "flex", gap: "6px", flexWrap: "wrap" }}>
                  <button type="button" onClick={() => setMainArticleText((mainArticleText || "") + "<h2>Heading 2</h2>\n")} className="editor-toolbar-btn">H2</button>
                  <button type="button" onClick={() => setMainArticleText((mainArticleText || "") + "<h3>Heading 3</h3>\n")} className="editor-toolbar-btn">H3</button>
                  <button type="button" onClick={() => setMainArticleText((mainArticleText || "") + "<strong>Bold Text</strong>")} className="editor-toolbar-btn">B</button>
                  <button type="button" onClick={() => setMainArticleText((mainArticleText || "") + "<em>Italic Text</em>")} className="editor-toolbar-btn">I</button>
                  <button type="button" onClick={() => setMainArticleText((mainArticleText || "") + "<ul>\n  <li>List Item</li>\n</ul>\n")} className="editor-toolbar-btn">• List</button>
                  <button type="button" onClick={() => setMainArticleText((mainArticleText || "") + '<div class="editor-callout">\n  <strong>Callout:</strong> Put highlighted content here.\n</div>\n')} className="editor-toolbar-btn" style={{ color: "#60a5fa" }}>💡 Callout</button>
                  <button type="button" onClick={() => setMainArticleText((mainArticleText || "") + '<div class="editor-warning">\n  <strong>Warning:</strong> Be careful of rate changes.\n</div>\n')} className="editor-toolbar-btn" style={{ color: "#fbbf24" }}>⚠️ Warning</button>
                  <button type="button" onClick={() => setMainArticleText((mainArticleText || "") + '<div class="editor-success">\n  <strong>Success:</strong> Mandi rate verified.\n</div>\n')} className="editor-toolbar-btn" style={{ color: "#34d399" }}>✅ Success</button>
                  <button type="button" onClick={() => setMainArticleText((mainArticleText || "") + '<div class="editor-info">\n  <strong>Info:</strong> Rates are closing.\n</div>\n')} className="editor-toolbar-btn" style={{ color: "#a5b4fc" }}>ℹ️ Info</button>
                  <button type="button" onClick={() => setMainArticleText((mainArticleText || "") + "<hr />\n")} className="editor-toolbar-btn">― Divider</button>
                </div>
                
                {/* Mode Selector Toggle */}
                <div style={{ display: "flex", gap: "4px", backgroundColor: "#1e293b", padding: "3px", borderRadius: "8px" }}>
                  <button
                    type="button"
                    onClick={() => setEditorTab("edit")}
                    style={{
                      border: "none",
                      backgroundColor: editorTab === "edit" ? "#ff9f00" : "transparent",
                      color: editorTab === "edit" ? "#ffffff" : "#94a3b8",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      fontSize: "11px",
                      fontWeight: "700",
                      cursor: "pointer",
                      transition: "all 0.2s"
                    }}
                  >
                    📝 HTML
                  </button>
                  <button
                    type="button"
                    onClick={() => setEditorTab("preview")}
                    style={{
                      border: "none",
                      backgroundColor: editorTab === "preview" ? "#ff9f00" : "transparent",
                      color: editorTab === "preview" ? "#ffffff" : "#94a3b8",
                      padding: "4px 10px",
                      borderRadius: "6px",
                      fontSize: "11px",
                      fontWeight: "700",
                      cursor: "pointer",
                      transition: "all 0.2s"
                    }}
                  >
                    👁️ Preview
                  </button>
                </div>
              </div>

              {editorTab === "edit" ? (
                <textarea
                  value={mainArticleText}
                  onChange={(e) => setMainArticleText(e.target.value)}
                  rows="18"
                  className="premium-input"
                  style={{ 
                    borderRadius: "0 0 12px 12px", 
                    borderTop: "none", 
                    fontFamily: "monospace", 
                    fontSize: "13px", 
                    backgroundColor: "#fafaf9",
                    height: "380px",
                    lineHeight: "1.6"
                  }}
                  placeholder="Compose using raw formatting or layout blocks..."
                ></textarea>
              ) : (
                <div 
                  className="premium-preview-container" 
                  style={{
                    padding: "24px",
                    backgroundColor: "#ffffff",
                    border: "1px solid #cbd5e1",
                    borderTop: "none",
                    borderRadius: "0 0 12px 12px",
                    minHeight: "380px",
                    maxHeight: "600px",
                    overflowY: "auto",
                    fontSize: "15px",
                    lineHeight: "1.75",
                    color: "#1e293b"
                  }}
                >
                  <div 
                    dangerouslySetInnerHTML={{ __html: mainArticleText || "<p style='color: #94a3b8; font-style: italic;'>Write something to see a visual preview here...</p>" }}
                  />
                </div>
              )}


              {/* Table of Contents Sync list */}
              <div style={{ 
                marginTop: "24px", 
                padding: "24px", 
                backgroundColor: "#fcfaf7", 
                border: "1.5px dashed #f5e3d3", 
                borderLeft: "5px solid #ff9f00", 
                borderRadius: "16px" 
              }}>
                <div className="cms-flex-between cms-mobile-stack-row" style={{ marginBottom: "16px" }}>
                  <div className="cms-flex cms-align-center cms-gap-2">
                    <span className="icon-box" style={{ padding: "6px", backgroundColor: "rgba(255, 159, 0, 0.1)", color: "#ff9f00" }}>
                      <Icons.Sync style={{ animation: "spin 6s linear infinite" }} />
                    </span>
                    <h3 style={{ margin: 0, fontSize: "14.5px", fontWeight: "800", color: "#0f172a", letterSpacing: "0.3px" }}>
                      Auto-Generated Table of Contents
                    </h3>
                  </div>
                  <span className="cms-badge" style={{ backgroundColor: "#ffedd5", color: "#d97706", borderColor: "#ffedd5", fontWeight: "800", fontSize: "12px" }}>
                    {autoTOC.length} Anchors Detected
                  </span>
                </div>

                {autoTOC.length > 0 ? (
                  <div className="cms-form-grid cms-form-grid-2" style={{ gap: "14px" }}>
                    {autoTOC.map((head, idx) => (
                      <div 
                        key={idx} 
                        className="cms-flex cms-align-center cms-gap-3"
                        style={{ 
                          backgroundColor: "#ffffff", 
                          padding: "14px 18px", 
                          borderRadius: "12px", 
                          border: "1px solid #e2e8f0", 
                          boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                          transition: "all 0.2s ease",
                          cursor: "default"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.borderColor = "#ff9f00";
                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(255, 159, 0, 0.08)";
                          e.currentTarget.style.transform = "translateY(-1px)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.borderColor = "#e2e8f0";
                          e.currentTarget.style.boxShadow = "0 2px 4px rgba(0,0,0,0.02)";
                          e.currentTarget.style.transform = "none";
                        }}
                      >
                        <span style={{ 
                          display: "inline-flex", 
                          alignItems: "center", 
                          justifyContent: "center", 
                          width: "24px", 
                          height: "24px", 
                          borderRadius: "6px", 
                          backgroundColor: "#fff7ed", 
                          color: "#ff9f00", 
                          fontWeight: "800", 
                          fontSize: "12.5px",
                          border: "1px solid #ffedd5",
                          flexShrink: 0
                        }}>
                          {idx + 1}
                        </span>
                        <span style={{ fontSize: "13.5px", fontWeight: "700", color: "#334155", lineHeight: "1.4" }}>{head}</span>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={{ margin: 0, fontSize: "13px", color: "#94a3b8", fontStyle: "italic" }}>No headings (h2 or h3) found in main article body yet. Write headings above to sync automatically!</p>
                )}
              </div>
            </div>

            {/* SECTION 6: MARKET RELEVANCE CARD GRID */}
            <div id="marketRelevance" className="cms-card" onClick={() => setActiveSection("marketRelevance")}>
              <div className="cms-card-header">
                <div className="cms-flex cms-align-center cms-gap-3">
                  <span className="icon-box"><Icons.Globe /></span>
                  <div>
                    <h2 style={{ margin: 0, fontSize: "16px", fontWeight: "bold" }} className="text-slate-900">6. Regional Market Relevance Commentaries</h2>
                    <p style={{ margin: 0, fontSize: "12px" }} className="text-slate-500">Edit region-specific impact descriptors below. Displays beautifully as colored badges.</p>
                  </div>
                </div>
              </div>

              <div className="cms-form-grid cms-form-grid-2" style={{ gap: "20px" }}>
                {/* SAARC Card */}
                <div style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0fdf4 100%)",
                  border: "1.5px solid #bbf7d0",
                  borderRadius: "16px",
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  boxShadow: "0 4px 10px rgba(16, 185, 129, 0.02)",
                  transition: "all 0.2s ease"
                }}>
                  <div className="cms-mobile-stack-row" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px dashed rgba(16, 185, 129, 0.25)", paddingBottom: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span style={{
                        backgroundColor: "#10b981",
                        color: "#ffffff",
                        padding: "4px 10px",
                        borderRadius: "8px",
                        fontSize: "11px",
                        fontWeight: "900",
                        letterSpacing: "0.5px"
                      }}>SAARC</span>
                      <span style={{ fontSize: "13px", fontWeight: "700", color: "#065f46", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Market Impact
                      </span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <button
                        type="button"
                        onClick={() => openSectionRefiner("SAARC Market Relevance", "relevanceSAARC", relevanceSAARC)}
                        className="ai-refine-trigger"
                      >
                        <Icons.Sparkles style={{ width: "13.5px", height: "13.5px", stroke: "currentColor" }} />
                        AI Refine
                      </button>
                      <Icons.Globe style={{ width: "16px", height: "16px", color: "#10b981", opacity: 0.8 }} />
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <label className="premium-label" style={{ fontSize: "11px", color: "#047857", textTransform: "uppercase", letterSpacing: "0.5px", margin: 0 }}>
                      SAARC Relevance Comment
                    </label>
                    <textarea
                      value={relevanceSAARC}
                      onChange={(e) => setRelevanceSAARC(e.target.value)}
                      rows="3"
                      placeholder="Describe how this affects Pakistan, India, Bangladesh and other SAARC poultry markets..."
                      style={{
                        width: "100%",
                        padding: "12px 14px",
                        borderRadius: "12px",
                        border: "1px solid #cbd5e1",
                        backgroundColor: "#ffffff",
                        fontSize: "13.5px",
                        lineHeight: "1.5",
                        color: "#1e293b",
                        resize: "none",
                        transition: "all 0.2s ease",
                        outline: "none",
                        boxShadow: "inset 0 1px 2px rgba(0,0,0,0.02)"
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#10b981";
                        e.target.style.boxShadow = "0 0 0 3px rgba(16, 185, 129, 0.12), inset 0 1px 2px rgba(0,0,0,0.02)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#cbd5e1";
                        e.target.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.02)";
                      }}
                    />
                  </div>
                </div>

                {/* MENA Card */}
                <div style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #fffbeb 100%)",
                  border: "1.5px solid #fde68a",
                  borderRadius: "16px",
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  boxShadow: "0 4px 10px rgba(245, 158, 11, 0.02)",
                  transition: "all 0.2s ease"
                }}>
                  <div className="cms-mobile-stack-row" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px dashed rgba(245, 158, 11, 0.25)", paddingBottom: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span style={{
                        backgroundColor: "#f59e0b",
                        color: "#ffffff",
                        padding: "4px 10px",
                        borderRadius: "8px",
                        fontSize: "11px",
                        fontWeight: "900",
                        letterSpacing: "0.5px"
                      }}>MENA</span>
                      <span style={{ fontSize: "13px", fontWeight: "700", color: "#78350f", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Market Impact
                      </span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <button
                        type="button"
                        onClick={() => openSectionRefiner("MENA Market Relevance", "relevanceMENA", relevanceMENA)}
                        className="ai-refine-trigger"
                      >
                        <Icons.Sparkles style={{ width: "13.5px", height: "13.5px", stroke: "currentColor" }} />
                        AI Refine
                      </button>
                      <Icons.Globe style={{ width: "16px", height: "16px", color: "#f59e0b", opacity: 0.8 }} />
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <label className="premium-label" style={{ fontSize: "11px", color: "#b45309", textTransform: "uppercase", letterSpacing: "0.5px", margin: 0 }}>
                      MENA Relevance Comment
                    </label>
                    <textarea
                      value={relevanceMENA}
                      onChange={(e) => setRelevanceMENA(e.target.value)}
                      rows="3"
                      placeholder="Describe the relevance to Middle East and North Africa region feed/meat trade..."
                      style={{
                        width: "100%",
                        padding: "12px 14px",
                        borderRadius: "12px",
                        border: "1px solid #cbd5e1",
                        backgroundColor: "#ffffff",
                        fontSize: "13.5px",
                        lineHeight: "1.5",
                        color: "#1e293b",
                        resize: "none",
                        transition: "all 0.2s ease",
                        outline: "none",
                        boxShadow: "inset 0 1px 2px rgba(0,0,0,0.02)"
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#f59e0b";
                        e.target.style.boxShadow = "0 0 0 3px rgba(245, 158, 11, 0.12), inset 0 1px 2px rgba(0,0,0,0.02)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#cbd5e1";
                        e.target.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.02)";
                      }}
                    />
                  </div>
                </div>

                {/* ASIA Card */}
                <div style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #fff1f2 100%)",
                  border: "1.5px solid #fecdd3",
                  borderRadius: "16px",
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  boxShadow: "0 4px 10px rgba(244, 63, 94, 0.02)",
                  transition: "all 0.2s ease"
                }}>
                  <div className="cms-mobile-stack-row" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px dashed rgba(244, 63, 94, 0.25)", paddingBottom: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span style={{
                        backgroundColor: "#f43f5e",
                        color: "#ffffff",
                        padding: "4px 10px",
                        borderRadius: "8px",
                        fontSize: "11px",
                        fontWeight: "900",
                        letterSpacing: "0.5px"
                      }}>ASIA</span>
                      <span style={{ fontSize: "13px", fontWeight: "700", color: "#9f1239", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Market Impact
                      </span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <button
                        type="button"
                        onClick={() => openSectionRefiner("Asia Market Relevance", "relevanceAsia", relevanceAsia)}
                        className="ai-refine-trigger"
                      >
                        <Icons.Sparkles style={{ width: "13.5px", height: "13.5px", stroke: "currentColor" }} />
                        AI Refine
                      </button>
                      <Icons.Globe style={{ width: "16px", height: "16px", color: "#f43f5e", opacity: 0.8 }} />
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <label className="premium-label" style={{ fontSize: "11px", color: "#be123c", textTransform: "uppercase", letterSpacing: "0.5px", margin: 0 }}>
                      Asia Relevance Comment
                    </label>
                    <textarea
                      value={relevanceAsia}
                      onChange={(e) => setRelevanceAsia(e.target.value)}
                      rows="3"
                      placeholder="Describe implications for wider Asian poultry/grain markets (Central Asia, SA, China)..."
                      style={{
                        width: "100%",
                        padding: "12px 14px",
                        borderRadius: "12px",
                        border: "1px solid #cbd5e1",
                        backgroundColor: "#ffffff",
                        fontSize: "13.5px",
                        lineHeight: "1.5",
                        color: "#1e293b",
                        resize: "none",
                        transition: "all 0.2s ease",
                        outline: "none",
                        boxShadow: "inset 0 1px 2px rgba(0,0,0,0.02)"
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#f43f5e";
                        e.target.style.boxShadow = "0 0 0 3px rgba(244, 63, 94, 0.12), inset 0 1px 2px rgba(0,0,0,0.02)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#cbd5e1";
                        e.target.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.02)";
                      }}
                    />
                  </div>
                </div>

                {/* EUROPE Card */}
                <div style={{
                  background: "linear-gradient(135deg, #ffffff 0%, #f0f9ff 100%)",
                  border: "1.5px solid #bfdbfe",
                  borderRadius: "16px",
                  padding: "20px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  boxShadow: "0 4px 10px rgba(59, 130, 246, 0.02)",
                  transition: "all 0.2s ease"
                }}>
                  <div className="cms-mobile-stack-row" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderBottom: "1px dashed rgba(59, 130, 246, 0.25)", paddingBottom: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span style={{
                        backgroundColor: "#3b82f6",
                        color: "#ffffff",
                        padding: "4px 10px",
                        borderRadius: "8px",
                        fontSize: "11px",
                        fontWeight: "900",
                        letterSpacing: "0.5px"
                      }}>EUROPE</span>
                      <span style={{ fontSize: "13px", fontWeight: "700", color: "#1e3a8a", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Market Impact
                      </span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <button
                        type="button"
                        onClick={() => openSectionRefiner("Europe Market Relevance", "relevanceEurope", relevanceEurope)}
                        className="ai-refine-trigger"
                      >
                        <Icons.Sparkles style={{ width: "13.5px", height: "13.5px", stroke: "currentColor" }} />
                        AI Refine
                      </button>
                      <Icons.Globe style={{ width: "16px", height: "16px", color: "#3b82f6", opacity: 0.8 }} />
                    </div>
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                    <label className="premium-label" style={{ fontSize: "11px", color: "#1d4ed8", textTransform: "uppercase", letterSpacing: "0.5px", margin: 0 }}>
                      Europe Relevance Comment
                    </label>
                    <textarea
                      value={relevanceEurope}
                      onChange={(e) => setRelevanceEurope(e.target.value)}
                      rows="3"
                      placeholder="Describe potential export/import impacts or feed safety regulation standards relevant to EU..."
                      style={{
                        width: "100%",
                        padding: "12px 14px",
                        borderRadius: "12px",
                        border: "1px solid #cbd5e1",
                        backgroundColor: "#ffffff",
                        fontSize: "13.5px",
                        lineHeight: "1.5",
                        color: "#1e293b",
                        resize: "none",
                        transition: "all 0.2s ease",
                        outline: "none",
                        boxShadow: "inset 0 1px 2px rgba(0,0,0,0.02)"
                      }}
                      onFocus={(e) => {
                        e.target.style.borderColor = "#3b82f6";
                        e.target.style.boxShadow = "0 0 0 3px rgba(59, 130, 246, 0.12), inset 0 1px 2px rgba(0,0,0,0.02)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#cbd5e1";
                        e.target.style.boxShadow = "inset 0 1px 2px rgba(0,0,0,0.02)";
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Market Analysis card */}
              <div style={{ marginTop: "20px", padding: "16px", backgroundColor: "#f8fafc", borderRadius: "16px", border: "1px solid #e2e8f0" }}>
                <h3 style={{ margin: "0 0 12px", fontSize: "13px", fontWeight: "bold", color: "#1e293b" }}>Market Analysis & Expert Insights Card</h3>
                <div className="cms-form-grid cms-form-grid-2">
                  <div>
                    <label className="premium-label">Card Title</label>
                    <input type="text" value={analysisTitle} onChange={(e) => setMarketAnalysisTitle(e.target.value)} className="premium-input" />
                  </div>
                  <div>
                    <label className="premium-label">Read More URL</label>
                    <input type="text" value={analysisUrl} onChange={(e) => setMarketAnalysisUrl(e.target.value)} className="premium-input text-xs" style={{ fontFamily: "monospace" }} />
                  </div>
                  <div className="cms-grid-span-2">
                    <label className="premium-label">Short Description Summary</label>
                    <textarea value={analysisDesc} onChange={(e) => setMarketAnalysisDesc(e.target.value)} rows="2" className="premium-input" />
                  </div>
                </div>
              </div>
            </div>

            {/* SECTION 7: FAQ & SOURCES */}
            <div id="faqs" className="cms-card" onClick={() => setActiveSection("faqs")}>
              <div className="cms-flex-col cms-gap-6">
                
                {/* FAQs Builder */}
                <div>
                  <div className="cms-flex-between cms-mobile-stack-row" style={{ borderBottom: "1.5px solid #f1f5f9", paddingBottom: "12px", marginBottom: "16px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <div className="cms-flex cms-align-center cms-gap-2">
                      <span className="icon-box" style={{ padding: "6px", backgroundColor: "rgba(255, 159, 0, 0.1)", color: "#ff9f00" }}><Icons.Question /></span>
                      <h3 className="builder-section-header" style={{ fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Dynamic FAQ Builder</h3>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <button
                        type="button"
                        onClick={() => openSectionRefiner("Faqs Section", "faqs", faqs)}
                        className="ai-refine-trigger"
                      >
                        <Icons.Sparkles style={{ width: "13.5px", height: "13.5px", stroke: "currentColor" }} />
                        AI Refine FAQs
                      </button>
                      <button 
                        type="button" 
                        onClick={addFAQ} 
                        className="cms-btn" 
                        style={{ 
                          border: "none",
                          color: "#ffffff", 
                          background: "linear-gradient(135deg, #ffb74d 0%, #ff9f00 100%)", 
                          fontWeight: "800",
                          fontSize: "13px",
                          padding: "10px 18px",
                          borderRadius: "10px",
                          boxShadow: "0 4px 12px rgba(255, 159, 0, 0.2)",
                          transition: "all 0.2s ease",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px"
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.transform = "scale(1.03) translateY(-1px)";
                          e.currentTarget.style.boxShadow = "0 6px 16px rgba(255, 159, 0, 0.35)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.transform = "none";
                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(255, 159, 0, 0.2)";
                        }}
                      >
                        <Icons.Plus /> Add New FAQ Block
                      </button>
                    </div>
                  </div>

                  <div className="cms-flex-col cms-gap-4">
                    {faqs && faqs.map((faq, index) => (
                      <div key={index} className="builder-item-card builder-item-card-faq cms-flex-col cms-gap-4" style={{ padding: "20px 24px" }}>
                        <button type="button" onClick={() => deleteFAQ(index)} style={{ position: "absolute", top: "18px", right: "18px" }} className="cms-btn-danger" title="Delete FAQ">
                          <Icons.Trash style={{ width: "16px", height: "16px" }} />
                        </button>
                        <div style={{ paddingRight: "48px" }}>
                          <label className="builder-item-label" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Question #{index + 1}</label>
                          <input id={`faq-input-${index}`} type="text" value={faq.question} onChange={(e) => updateFAQ(index, "question", e.target.value)} className="premium-input" style={{ fontWeight: "700", height: "48px", fontSize: "14.5px" }} placeholder="e.g., 'Why do egg prices fluctuate daily in Punjab?'" />
                        </div>
                        <div>
                          <label className="builder-item-label" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Answer</label>
                          <textarea value={faq.answer} onChange={(e) => updateFAQ(index, "answer", e.target.value)} rows="4" className="premium-input" style={{ fontSize: "14.5px", lineHeight: "1.6", padding: "12px 16px" }} placeholder="Give a detailed answer here..." />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Elegant Separator */}
                <div style={{ height: "1.5px", backgroundColor: "#f1f5f9", margin: "24px 0 12px" }}></div>

                {/* Sources & Methodology builder */}
                <div>
                  <div className="cms-flex-between cms-mobile-stack-row" style={{ borderBottom: "1.5px solid #f1f5f9", paddingBottom: "12px", marginBottom: "16px" }}>
                    <div className="cms-flex cms-align-center cms-gap-2">
                      <span className="icon-box" style={{ padding: "6px", backgroundColor: "rgba(255, 159, 0, 0.1)", color: "#ffa000" }}><Icons.Globe /></span>
                      <h3 className="builder-section-header" style={{ fontSize: "16px", fontWeight: "800", color: "#0f172a" }}>Sources & Methodology</h3>
                    </div>
                    <button 
                      type="button" 
                      onClick={addSource} 
                      className="cms-btn" 
                      style={{ 
                        border: "none",
                        color: "#ffffff", 
                        background: "linear-gradient(135deg, #f5a65b 0%, #ffa000 100%)", 
                        fontWeight: "800",
                        fontSize: "13px",
                        padding: "10px 18px",
                        borderRadius: "10px",
                        boxShadow: "0 4px 12px rgba(255, 159, 0, 0.2)",
                        transition: "all 0.2s ease",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px"
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "scale(1.03) translateY(-1px)";
                        e.currentTarget.style.boxShadow = "0 6px 16px rgba(255, 159, 0, 0.35)";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "none";
                        e.currentTarget.style.boxShadow = "0 4px 12px rgba(255, 159, 0, 0.2)";
                      }}
                    >
                      <Icons.Plus /> Add New Source Block
                    </button>
                  </div>

                  <div className="cms-flex-col cms-gap-4">
                    {sources && sources.map((src, index) => (
                      <div key={index} className="builder-item-card builder-item-card-source cms-flex-col cms-gap-4" style={{ padding: "20px 24px" }}>
                        <button type="button" onClick={() => deleteSource(index)} style={{ position: "absolute", top: "18px", right: "18px" }} className="cms-btn-danger" title="Delete Source">
                          <Icons.Trash style={{ width: "16px", height: "16px" }} />
                        </button>
                        <div className="cms-form-grid cms-form-grid-2" style={{ gap: "16px", paddingRight: "48px" }}>
                          <div>
                            <label className="builder-item-label" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Source Name</label>
                            <input id={`source-input-${index}`} type="text" value={src.name} onChange={(e) => updateSource(index, "name", e.target.value)} className="premium-input" style={{ fontWeight: "700", height: "48px", fontSize: "14.5px" }} placeholder="e.g., 'Mandi Auction Records'" />
                          </div>
                          <div>
                            <label className="builder-item-label" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Verification URL</label>
                            <input type="text" value={src.url} onChange={(e) => updateSource(index, "url", e.target.value)} className="premium-input" style={{ fontFamily: "monospace", height: "48px", fontSize: "14px" }} placeholder="e.g., 'https://punjabmandi.gov.pk'" />
                          </div>
                        </div>
                        <div>
                          <label className="builder-item-label" style={{ fontSize: "12px", letterSpacing: "0.5px" }}>Method Description</label>
                          <input type="text" value={src.desc} onChange={(e) => updateSource(index, "desc", e.target.value)} className="premium-input" style={{ height: "48px", fontSize: "14px" }} placeholder="e.g., 'Official daily auction data from regulated markets...'" />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

              </div>
            </div>

            {/* SECTION 8: CROSS LINK SELECTORS */}
            <div id="selectors" className="cms-card" onClick={() => setActiveSection("selectors")}>
              <div className="cms-card-header">
                <div className="cms-flex cms-align-center cms-gap-3">
                  <span className="icon-box"><Icons.Settings /></span>
                  <div>
                    <h2 style={{ margin: 0, fontSize: "16px", fontWeight: "bold" }} className="text-slate-900">8. Smart Cross-Linking Selectors</h2>
                    <p style={{ margin: 0, fontSize: "12px" }} className="text-slate-500">Attach related rate pages, encyclopedias, and internal blog articles to improve Google SEO ranking.</p>
                  </div>
                </div>
              </div>

              <div className="cms-form-grid cms-form-grid-3">
                {/* Related Rates Selector */}
                <div>
                  <label className="premium-label">Related Rate Pages (Multi Select)</label>
                  <div className="multi-select-box">
                    {SELECT_OPTIONS.RelatedRates.map((opt) => {
                      const isSelected = relatedRatesSelected.includes(opt);
                      return (
                        <label key={opt} className={`multi-select-item ${isSelected ? "multi-select-item-checked" : ""}`}>
                          <input
                            type="checkbox"
                            className="multi-select-checkbox"
                            checked={isSelected}
                            onChange={() => {
                              if (isSelected) {
                                setRelatedRatesSelected(relatedRatesSelected.filter(o => o !== opt));
                              } else {
                                setRelatedRatesSelected([...relatedRatesSelected, opt]);
                              }
                            }}
                          />
                          <span>{opt.split("|")[0]}</span>
                        </label>
                      );
                    })}
                  </div>
                </div>

                {/* Encyclopedia Selector */}
                <div>
                  <label className="premium-label">Encyclopedia Guides (Multi Select)</label>
                  <div className="multi-select-box">
                    {(dbEncyclopedia.length > 0 ? dbEncyclopedia : SELECT_OPTIONS.Encyclopedia).map((opt) => {
                      const isSelected = encyclopediaSelected.includes(opt);
                      return (
                        <label key={opt} className={`multi-select-item ${isSelected ? "multi-select-item-checked" : ""}`}>
                          <input
                            type="checkbox"
                            className="multi-select-checkbox"
                            checked={isSelected}
                            onChange={() => {
                              if (isSelected) {
                                setEncyclopediaSelected(encyclopediaSelected.filter(o => o !== opt));
                              } else {
                                setEncyclopediaSelected([...encyclopediaSelected, opt]);
                              }
                            }}
                          />
                          <span>{opt.split("|")[0]}</span>
                        </label>
                      );
                    })}
                  </div>
                </div>

                {/* Related Articles Selector */}
                <div>
                  <label className="premium-label">Related Internal Blogs (Multi Select)</label>
                  <div className="multi-select-box">
                    {(dbArticles.length > 0 ? dbArticles : SELECT_OPTIONS.Articles).map((opt) => {
                      const isSelected = relatedArticlesSelected.includes(opt);
                      return (
                        <label key={opt} className={`multi-select-item ${isSelected ? "multi-select-item-checked" : ""}`}>
                          <input
                            type="checkbox"
                            className="multi-select-checkbox"
                            checked={isSelected}
                            onChange={() => {
                              if (isSelected) {
                                setRelatedArticlesSelected(relatedArticlesSelected.filter(o => o !== opt));
                              } else {
                                setRelatedArticlesSelected([...relatedArticlesSelected, opt]);
                              }
                            }}
                          />
                          <span>{opt.split("|")[0]}</span>
                        </label>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>

            {/* SECTION 9: SEO CONFIGURATION PANEL */}
            <div id="seo" className="cms-card" onClick={() => setActiveSection("seo")}>
              <div className="cms-card-header">
                <div className="cms-flex cms-align-center cms-gap-3">
                  <span className="icon-box"><Icons.Seo /></span>
                  <div>
                    <h2 style={{ margin: 0, fontSize: "16px", fontWeight: "bold" }} className="text-slate-900">9. Live Search SEO Optimizer</h2>
                    <p style={{ margin: 0, fontSize: "12px" }} className="text-slate-500">Configure key titles and descriptions. The preview shows live layout in search results.</p>
                  </div>
                </div>
                <div>
                  <span className="cms-badge cms-badge-published">
                    Score: {displaySeoScore} / 100
                  </span>
                </div>
              </div>

              <div className="cms-form-grid cms-form-grid-2">
                <div className="cms-flex-col cms-gap-3">
                  <div>
                    <div className="cms-mobile-stack-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "4px" }}>
                      <label className="premium-label" style={{ margin: 0 }}>Meta Search Title</label>
                      <button
                        type="button"
                        onClick={() => openSectionRefiner("Meta Search Title", "metaTitle", metaTitle)}
                        className="ai-refine-trigger"
                      >
                        <Icons.Sparkles style={{ width: "13.5px", height: "13.5px", stroke: "currentColor" }} />
                        AI Refine
                      </button>
                    </div>
                    <input type="text" value={metaTitle} onChange={(e) => setMetaTitle(e.target.value)} className="premium-input text-xs font-semibold" />
                  </div>

                  <div>
                    <div className="cms-mobile-stack-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "4px" }}>
                      <label className="premium-label" style={{ margin: 0 }}>Meta Description</label>
                      <button
                        type="button"
                        onClick={() => openSectionRefiner("Meta Description", "metaDescription", metaDescription)}
                        className="ai-refine-trigger"
                      >
                        <Icons.Sparkles style={{ width: "13.5px", height: "13.5px", stroke: "currentColor" }} />
                        AI Refine
                      </button>
                    </div>
                    <textarea value={metaDescription} onChange={(e) => setMetaDescription(e.target.value)} rows="3" className="premium-input text-xs font-semibold" />
                    <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#94a3b8" }}>Perfect range: 110-160 characters (Current: {metaDescription ? metaDescription.length : 0})</p>
                  </div>

                  <div className="cms-form-grid cms-form-grid-2">
                    <div>
                      <label className="premium-label">Focus Keyword</label>
                      <input type="text" value={focusKeyword} onChange={(e) => setFocusKeyword(e.target.value)} className="premium-input text-xs font-bold" />
                    </div>
                    <div>
                      <label className="premium-label">Secondary Keywords</label>
                      <input type="text" value={secondaryKeywords} onChange={(e) => setSecondaryKeywords(e.target.value)} className="premium-input text-xs" />
                    </div>
                  </div>

                  <div className="cms-form-grid cms-form-grid-2">
                    <div>
                      <label className="premium-label">Canonical URL</label>
                      <input type="text" value={canonicalUrl} onChange={(e) => setCanonicalUrl(e.target.value)} className="premium-input text-xs" style={{ fontFamily: "monospace" }} />
                    </div>
                    <div>
                      <label className="premium-label">Schema Type</label>
                      <select value={schemaType} onChange={(e) => setSchemaType(e.target.value)} className="premium-input text-xs">
                        <option>NewsArticle</option>
                        <option>BlogPosting</option>
                        <option>WebPage</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* Google Snippet Live Simulator */}
                <div style={{ padding: "20px", backgroundColor: "#f8fafc", border: "1.5px solid #e2e8f0", borderRadius: "18px", display: "flex", flexDirection: "column", gap: "16px" }}>
                  <p style={{ margin: 0, fontSize: "11px", fontWeight: "800", textTransform: "uppercase", color: "#64748b", letterSpacing: "1px" }}>Google Mobile Search Snippet Preview</p>
                  
                  <div className="google-preview-box" style={{
                    backgroundColor: "#ffffff",
                    border: "1.5px solid #e2e8f0",
                    borderRadius: "16px",
                    padding: "16px",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.02)",
                    display: "flex",
                    flexDirection: "column",
                    gap: "6px"
                  }}>
                    {/* Google Mobile Header */}
                    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "4px" }}>
                      {/* Stylized custom brand favicon logo */}
                      <div style={{
                        width: "28px",
                        height: "28px",
                        borderRadius: "50%",
                        backgroundColor: "#fff7ed",
                        border: "1px solid #fed7aa",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "12px",
                        fontWeight: "900",
                        color: "#ea580c"
                      }}>
                        P
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: "1px" }}>
                        <span style={{ fontSize: "13px", fontWeight: "700", color: "#202124", lineHeight: "1.1" }}>Poultry Baba</span>
                        <span style={{ fontSize: "11px", color: "#5f6368", lineHeight: "1.1" }}>
                          https://poultrybaba.com <span style={{ color: "#70757a" }}>› blogs › {slug || "white-layer-chicks"}</span>
                        </span>
                      </div>
                    </div>
                    {/* Google Title */}
                    <h3 className="google-preview-title" style={{
                      color: "#1a0dab",
                      fontFamily: "Roboto, Arial, sans-serif",
                      fontSize: "18px",
                      fontWeight: "400",
                      lineHeight: "1.25",
                      margin: "0 0 4px 0",
                      wordBreak: "break-word",
                      letterSpacing: "0.1px"
                    }}>{metaTitle || "Please enter metadata..."}</h3>
                    {/* Google Description */}
                    <p className="google-preview-desc" style={{
                      color: "#4d5156",
                      fontFamily: "Roboto, Arial, sans-serif",
                      fontSize: "13px",
                      lineHeight: "1.45",
                      margin: 0,
                      wordBreak: "break-word"
                    }}>{metaDescription || "Please write SEO description summary..."}</p>
                  </div>

                  <div style={{ height: "1px", backgroundColor: "#e2e8f0" }}></div>

                  {/* SEO Score criteria checks checklist */}
                  <p style={{ margin: 0, fontSize: "11px", fontWeight: "800", textTransform: "uppercase", color: "#64748b", letterSpacing: "1px" }}>SEO Optimizer Checklist</p>
                  
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {/* Check 1 */}
                    {(() => {
                      const isChecked = !!(focusKeyword && metaTitle.toLowerCase().includes(focusKeyword.toLowerCase()));
                      return (
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          padding: "10px 14px",
                          backgroundColor: isChecked ? "#f0fdf4" : "#f8fafc",
                          border: isChecked ? "1.5px solid #bbf7d0" : "1.5px solid #e2e8f0",
                          borderRadius: "12px",
                          transition: "all 0.2s ease"
                        }}>
                          <span style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            backgroundColor: isChecked ? "#10b981" : "#e2e8f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#ffffff",
                            flexShrink: 0
                          }}>
                            {isChecked ? <Icons.Check style={{ width: "12px", height: "12px" }} /> : <span style={{ width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#94a3b8" }} />}
                          </span>
                          <span style={{ fontSize: "12px", fontWeight: "600", color: isChecked ? "#166534" : "#475569" }}>
                            Focus keyword found in Meta Search Title (+20)
                          </span>
                        </div>
                      );
                    })()}

                    {/* Check 2 */}
                    {(() => {
                      const isChecked = !!(metaDescription && metaDescription.length >= 110 && metaDescription.length <= 160);
                      return (
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          padding: "10px 14px",
                          backgroundColor: isChecked ? "#f0fdf4" : "#f8fafc",
                          border: isChecked ? "1.5px solid #bbf7d0" : "1.5px solid #e2e8f0",
                          borderRadius: "12px",
                          transition: "all 0.2s ease"
                        }}>
                          <span style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            backgroundColor: isChecked ? "#10b981" : "#e2e8f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#ffffff",
                            flexShrink: 0
                          }}>
                            {isChecked ? <Icons.Check style={{ width: "12px", height: "12px" }} /> : <span style={{ width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#94a3b8" }} />}
                          </span>
                          <span style={{ fontSize: "12px", fontWeight: "600", color: isChecked ? "#166534" : "#475569" }}>
                            Meta Description size within perfect range (110-160 Chars) (+20)
                          </span>
                        </div>
                      );
                    })()}

                    {/* Check 3 */}
                    {(() => {
                      const isChecked = !!(articleStats.words > 150);
                      return (
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          padding: "10px 14px",
                          backgroundColor: isChecked ? "#f0fdf4" : "#f8fafc",
                          border: isChecked ? "1.5px solid #bbf7d0" : "1.5px solid #e2e8f0",
                          borderRadius: "12px",
                          transition: "all 0.2s ease"
                        }}>
                          <span style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            backgroundColor: isChecked ? "#10b981" : "#e2e8f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#ffffff",
                            flexShrink: 0
                          }}>
                            {isChecked ? <Icons.Check style={{ width: "12px", height: "12px" }} /> : <span style={{ width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#94a3b8" }} />}
                          </span>
                          <span style={{ fontSize: "12px", fontWeight: "600", color: isChecked ? "#166534" : "#475569" }}>
                            Main Article contains adequate word counts (+20)
                          </span>
                        </div>
                      );
                    })()}

                    {/* Check 4 */}
                    {(() => {
                      const isChecked = !!(focusKeyword && slug.toLowerCase().includes(focusKeyword.toLowerCase().replace(/\s+/g, "-")));
                      return (
                        <div style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          padding: "10px 14px",
                          backgroundColor: isChecked ? "#f0fdf4" : "#f8fafc",
                          border: isChecked ? "1.5px solid #bbf7d0" : "1.5px solid #e2e8f0",
                          borderRadius: "12px",
                          transition: "all 0.2s ease"
                        }}>
                          <span style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            backgroundColor: isChecked ? "#10b981" : "#e2e8f0",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#ffffff",
                            flexShrink: 0
                          }}>
                            {isChecked ? <Icons.Check style={{ width: "12px", height: "12px" }} /> : <span style={{ width: "6px", height: "6px", borderRadius: "50%", backgroundColor: "#94a3b8" }} />}
                          </span>
                          <span style={{ fontSize: "12px", fontWeight: "600", color: isChecked ? "#166534" : "#475569" }}>
                            Focus keyword present inside URL Slug (+20)
                          </span>
                        </div>
                      );
                    })()}
                  </div>
                </div>
              </div>
            </div>

            {/* SECTION 10: SIDEBAR CONFIGURATION SETTINGS */}
            <div id="sidebarSettings" className="cms-card" onClick={() => setActiveSection("sidebarSettings")}>
              <div className="cms-card-header">
                <div className="cms-flex cms-align-center cms-gap-3">
                  <span className="icon-box"><Icons.Settings /></span>
                  <div>
                    <h2 style={{ margin: 0, fontSize: "16px", fontWeight: "bold" }} className="text-slate-900">10. Custom Sidebar Layout Config</h2>
                    <p style={{ margin: 0, fontSize: "12px" }} className="text-slate-500">Determine custom sidebars widgets and toggles shown globally beside the article layout.</p>
                  </div>
                </div>
              </div>

              <div className="cms-form-grid cms-form-grid-3">
                <div 
                  className={`sidebar-toggle-card ${showTopRates ? "sidebar-toggle-card-checked" : ""}`}
                  onClick={() => setShowTopRates(!showTopRates)}
                >
                  <div>
                    <span className="sidebar-toggle-title">Top Rates Sidebar Widget</span>
                    <span className="sidebar-toggle-desc">Displays top 4 live rates on sidebar</span>
                  </div>
                  <input 
                    type="checkbox" 
                    checked={showTopRates} 
                    onChange={(e) => {
                      e.stopPropagation(); // prevent double toggle
                      setShowTopRates(e.target.checked);
                    }} 
                    className="multi-select-checkbox" 
                  />
                </div>

                <div 
                  className={`sidebar-toggle-card ${showPopularTags ? "sidebar-toggle-card-checked" : ""}`}
                  onClick={() => setShowPopularTags(!showPopularTags)}
                >
                  <div>
                    <span className="sidebar-toggle-title">Popular Tags Cloud</span>
                    <span className="sidebar-toggle-desc">Shows clickable tags inside widget</span>
                  </div>
                  <input 
                    type="checkbox" 
                    checked={showPopularTags} 
                    onChange={(e) => {
                      e.stopPropagation();
                      setShowPopularTags(e.target.checked);
                    }} 
                    className="multi-select-checkbox" 
                  />
                </div>

                <div 
                  className={`sidebar-toggle-card ${showSocialLinks ? "sidebar-toggle-card-checked" : ""}`}
                  onClick={() => setShowSocialLinks(!showSocialLinks)}
                >
                  <div>
                    <span className="sidebar-toggle-title">Social Network Icons</span>
                    <span className="sidebar-toggle-desc">Renders follow buttons</span>
                  </div>
                  <input 
                    type="checkbox" 
                    checked={showSocialLinks} 
                    onChange={(e) => {
                      e.stopPropagation();
                      setShowSocialLinks(e.target.checked);
                    }} 
                    className="multi-select-checkbox" 
                  />
                </div>

                <div 
                  className={`sidebar-toggle-card ${showDownloadAppToggle ? "sidebar-toggle-card-checked" : ""}`}
                  onClick={() => setShowDownloadAppToggle(!showDownloadAppToggle)}
                >
                  <div>
                    <span className="sidebar-toggle-title">Mobile App Banner</span>
                    <span className="sidebar-toggle-desc">Google Play store direct link</span>
                  </div>
                  <input 
                    type="checkbox" 
                    checked={showDownloadAppToggle} 
                    onChange={(e) => {
                      e.stopPropagation();
                      setShowDownloadAppToggle(e.target.checked);
                    }} 
                    className="multi-select-checkbox" 
                  />
                </div>

                <div 
                  className={`sidebar-toggle-card ${showAdsToggle ? "sidebar-toggle-card-checked" : ""}`}
                  onClick={() => setShowAdsToggle(!showAdsToggle)}
                >
                  <div>
                    <span className="sidebar-toggle-title">Google Advertisements</span>
                    <span className="sidebar-toggle-desc">Injects monetization ad blocks</span>
                  </div>
                  <input 
                    type="checkbox" 
                    checked={showAdsToggle} 
                    onChange={(e) => {
                      e.stopPropagation();
                      setShowAdsToggle(e.target.checked);
                    }} 
                    className="multi-select-checkbox" 
                  />
                </div>

                <div 
                  className={`sidebar-toggle-card ${stickySidebarToggle ? "sidebar-toggle-card-checked" : ""}`}
                  onClick={() => setStickySidebarToggle(!stickySidebarToggle)}
                >
                  <div>
                    <span className="sidebar-toggle-title">Fixed Sidebar Scroll</span>
                    <span className="sidebar-toggle-desc">Makes widget sticky during scroll</span>
                  </div>
                  <input 
                    type="checkbox" 
                    checked={stickySidebarToggle} 
                    onChange={(e) => {
                      e.stopPropagation();
                      setStickySidebarToggle(e.target.checked);
                    }} 
                    className="multi-select-checkbox" 
                  />
                </div>
              </div>
        </div>
      </div>
    </div>

      {/* FOOTER: STICKY GLASSMORPHIC ACTION PANEL */}
      <div className="cms-sticky-footer glass-panel cms-flex-between">
        <div className="cms-flex cms-align-center cms-gap-2">
          <span style={{ display: "inline-block", width: "8px", height: "8px", borderRadius: "50%", backgroundColor: "#10b981" }}></span>
          <span style={{ fontSize: "12px", color: "#64748b", fontWeight: "bold" }}>Connected & Secure CMS Session. Auto-saving active.</span>
        </div>

        <div className="cms-flex cms-gap-3">
          <button type="button" onClick={handleReset} className="cms-btn cms-btn-secondary">
            Discard & Reset
          </button>
          
          <button type="button" onClick={() => setPreviewOpen(true)} className="cms-btn cms-btn-dark">
            <Icons.Eye /> Interactive Preview
          </button>

          <button type="button" onClick={() => handleSave(false)} className="cms-btn cms-btn-amber">
            Save Draft
          </button>

          <button
            type="button"
            disabled={isMatchingBeforePublish}
            onClick={handleMatchBeforePublish}
            className="cms-btn cms-btn-secondary"
          >
            {isMatchingBeforePublish ? "Matching..." : "Match Before Publish"}
          </button>

          <button type="button" onClick={() => handleSave(true)} className="cms-btn cms-btn-primary">
            Publish Live
          </button>
        </div>
      </div>

      {/* ==================================
          PREVIEW MODAL INTERACTIVE POPUP
          (Live front-end simulation)
         ================================== */}
      {previewOpen && (
        <div className="preview-modal-overlay">
          <div className="preview-modal-content">
            {/* Modal Top Control Bar */}
            <div style={{ backgroundColor: "#0f172a", padding: "14px 24px", color: "#ffffff" }} className="cms-flex-between">
              <div className="cms-flex cms-align-center cms-gap-2">
                <span style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: "#ef4444", display: "inline-block" }}></span>
                <span style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: "#f59e0b", display: "inline-block" }}></span>
                <span style={{ width: "12px", height: "12px", borderRadius: "50%", backgroundColor: "#10b981", display: "inline-block" }}></span>
                <span style={{ fontSize: "12px", fontWeight: "bold", color: "#94a3b8", marginLeft: "10px" }}>Live Website Layout Preview (Responsive Simulator)</span>
              </div>
              <button onClick={() => setPreviewOpen(false)} className="cms-btn cms-btn-sm cms-btn-secondary">
                ✕ Close Preview
              </button>
            </div>

            {/* Inner body replicating the screenshots perfectly */}
            <div style={{ padding: "24px", display: "grid", gridTemplateColumns: "1fr", gap: "24px" }} className="cms-form-grid">
              <div style={{ backgroundColor: "#ffffff", padding: "24px", borderRadius: "16px", border: "1px solid #e2e8f0" }} className="cms-flex-col cms-gap-4">
                
                {/* Categories breadcrumb */}
                <div className="cms-flex cms-gap-2">
                  <span className="cms-badge cms-badge-published" style={{ backgroundColor: "#603813", color: "#ffffff", borderColor: "#603813" }}>{category}</span>
                  <span className="cms-badge cms-badge-published" style={{ backgroundColor: "#10b981", color: "#ffffff", borderColor: "#10b981" }}>{country}</span>
                  <span className="cms-badge cms-badge-published" style={{ backgroundColor: "#ffa000", color: "#ffffff", borderColor: "#ffa000" }}>{province}</span>
                </div>

                {/* Big Title */}
                <h1 style={{ fontSize: "24px", fontWeight: "800", color: "#000000", margin: "12px 0", fontFamily: "Playfair Display, serif" }}>{title || "Untitled Article"}</h1>

                {/* Grid layout with hero image and details */}
                <div className="cms-form-grid cms-form-grid-2" style={{ alignItems: "center" }}>
                  {featuredImage ? (
                    <div style={{ borderRadius: "12px", overflow: "hidden", border: "1px solid #e2e8f0", aspectRatio: "16/9" }}>
                      <img src={featuredImage} alt="Article Hero" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    </div>
                  ) : (
                    <div style={{ borderRadius: "12px", padding: "40px", border: "1px dashed #cbd5e1", textAlign: "center", backgroundColor: "#f8fafc", color: "#94a3b8", fontSize: "13px" }}>
                      No hero image generated or selected yet.
                    </div>
                  )}

                  {/* Authorship credentials */}
                  <div className="cms-flex-col cms-gap-3" style={{ fontSize: "12px", color: "#475569" }}>
                    <div className="cms-flex cms-gap-4">
                      <div>
                        <p style={{ margin: "0 0 2px", fontSize: "10px", fontWeight: "bold", textTransform: "uppercase", color: "#94a3b8" }}>Author</p>
                        <p style={{ margin: 0, fontWeight: "bold", color: "#1e293b" }}>{author || "Not Assigned"}</p>
                      </div>
                      <div>
                        <p style={{ margin: "0 0 2px", fontSize: "10px", fontWeight: "bold", textTransform: "uppercase", color: "#94a3b8" }}>Reviewer</p>
                        <p style={{ margin: 0, fontWeight: "bold", color: "#1e293b" }}>{reviewer || "Not Assigned"}</p>
                      </div>
                    </div>
                    <div className="cms-flex cms-gap-4">
                      <div>
                        <p style={{ margin: "0 0 2px", fontSize: "10px", fontWeight: "bold", textTransform: "uppercase", color: "#94a3b8" }}>Published</p>
                        <p style={{ margin: 0, fontWeight: "bold" }}>{publishDate}</p>
                      </div>
                      <div>
                        <p style={{ margin: "0 0 2px", fontSize: "10px", fontWeight: "bold", textTransform: "uppercase", color: "#94a3b8" }}>Updated</p>
                        <p style={{ margin: 0, fontWeight: "bold" }}>{updatedDate}</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Quick Answer card block */}
                {quickAnswer && (
                  <div style={{ backgroundColor: "#f0fdf4", padding: "20px", borderRadius: "16px", border: "1px solid #bbf7d0" }} className="cms-flex-col cms-gap-3">
                    <span className="cms-badge cms-badge-published">Quick Answer</span>
                    <p style={{ fontSize: "13.5px", fontFamily: "serif", fontStyle: "italic", color: "#14532d", margin: "8px 0" }}>"{quickAnswer}"</p>
                    
                    {/* Takeaways List */}
                    {takeaways && takeaways.length > 0 && (
                      <div style={{ marginTop: "12px" }}>
                        <h3 style={{ margin: "0 0 8px", fontSize: "12.5px", fontWeight: "bold", color: "#14532d" }}>Key Takeaways</h3>
                        <div className="cms-form-grid cms-form-grid-2 text-xs">
                          {takeaways.map((p, idx) => (
                            <div key={idx} className="cms-flex cms-align-center cms-gap-2" style={{ fontWeight: "600" }}>
                              <span style={{ color: "#10b981", fontWeight: "bold" }}>✓</span>
                              <span>{p}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}

                {/* Table of Contents Box */}
                {autoTOC.length > 0 && (
                  <div style={{ backgroundColor: "#fdfbf7", border: "1px solid #f5e6d3", padding: "16px", borderRadius: "16px" }}>
                    <h3 style={{ margin: "0 0 8px", fontSize: "12px", fontWeight: "bold", color: "#7c2d12", textTransform: "uppercase" }}>Table of Contents</h3>
                    <div className="cms-form-grid cms-form-grid-2" style={{ gap: "8px" }}>
                      {autoTOC.map((head, idx) => (
                        <div key={idx} style={{ fontSize: "12px", fontWeight: "bold", color: "#7c2d12" }}>{head}</div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Main Article Body formatting */}
                {mainArticleText ? (
                  <div className="prose text-xs text-slate-700" style={{ lineHeight: "1.6" }} dangerouslySetInnerHTML={{ __html: mainArticleText }} />
                ) : (
                  <p style={{ fontSize: "13px", color: "#94a3b8", fontStyle: "italic" }}>Main body is currently empty. Use the AI Content Writer at the top left to write it instantly!</p>
                )}

                {/* Market Relevance */}
                {(relevanceSAARC || relevanceMENA || relevanceAsia || relevanceEurope) && (
                  <div style={{ backgroundColor: "#f0f9ff", border: "1px solid #bae6fd", padding: "16px", borderRadius: "16px" }} className="cms-flex-col cms-gap-3">
                    <h3 style={{ margin: 0, fontSize: "13px", fontWeight: "bold", color: "#0369a1" }}>Poultry Market Relevance</h3>
                    <div className="cms-flex-col cms-gap-2 text-xs">
                      {relevanceSAARC && (
                        <div className="cms-flex cms-align-center cms-gap-2 font-semibold">
                          <span className="cms-badge cms-badge-published" style={{ backgroundColor: "#10b981", color: "#ffffff", borderColor: "#10b981" }}>SAARC</span>
                          <span>{relevanceSAARC}</span>
                        </div>
                      )}
                      {relevanceMENA && (
                        <div className="cms-flex cms-align-center cms-gap-2 font-semibold">
                          <span className="cms-badge cms-badge-amber" style={{ backgroundColor: "#ff9f00", color: "#ffffff", borderColor: "#ff9f00" }}>MENA</span>
                          <span>{relevanceMENA}</span>
                        </div>
                      )}
                      {relevanceAsia && (
                        <div className="cms-flex cms-align-center cms-gap-2 font-semibold">
                          <span className="cms-badge cms-badge-draft" style={{ backgroundColor: "#e11d48", color: "#ffffff", borderColor: "#e11d48" }}>Asia</span>
                          <span>{relevanceAsia}</span>
                        </div>
                      )}
                      {relevanceEurope && (
                        <div className="cms-flex cms-align-center cms-gap-2 font-semibold">
                          <span className="cms-badge cms-badge-draft" style={{ backgroundColor: "#475569", color: "#ffffff", borderColor: "#475569" }}>Europe</span>
                          <span>{relevanceEurope}</span>
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* FAQ section rendering accordion */}
                {faqs && faqs.length > 0 && (
                  <div className="cms-flex-col cms-gap-2">
                    <h3 style={{ margin: "12px 0 4px", fontSize: "13.5px", fontWeight: "bold", color: "#1e293b" }}>Frequently Asked Questions</h3>
                    {faqs.map((f, idx) => (
                      <div key={idx} className="preview-faq-item">
                        <div className="preview-faq-question">
                          <span>{f.question}</span>
                          <span style={{ color: "#cbd5e1" }}>▼</span>
                        </div>
                        <p style={{ margin: "8px 0 0", fontSize: "12px", color: "#475569", borderTop: "1px solid #f1f5f9", paddingTop: "8px", lineHeight: "1.5" }}>{f.answer}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Redesigned Premium SaaS-Quality SEO Similarity Modal */}
      {showSimilarityModal && similarityWarning && (
        <div 
          className="preview-modal-overlay" 
          onClick={() => {
            setShowSimilarityModal(false);
            setAiModalOpen(true); // Reopen Gemini Smart Writer modal immediately on click outside!
          }}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(15, 23, 42, 0.5)",
            backdropFilter: "blur(8px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 999999,
            animation: "fadeIn 200ms ease-out",
            padding: "20px"
          }}
        >
          <div 
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              width: "100%",
              maxWidth: "680px",
              boxShadow: "0 20px 40px -5px rgba(15, 23, 42, 0.1), 0 0 1px rgba(0, 0, 0, 0.05)",
              border: "1px solid #e2e8f0",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              overflow: "hidden",
              animation: "scaleIn 200ms cubic-bezier(0.16, 1, 0.3, 1)",
              maxHeight: "85vh"
            }}
          >
            {/* Top orange brand highlight bar */}
            <div style={{
              width: "100%",
              height: "4px",
              background: "linear-gradient(90deg, #ffa000 0%, #ff6f00 100%)",
              flexShrink: 0
            }} />

            {/* Clean Sticky Header Row */}
            <div style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "16px 24px",
              borderBottom: "1px solid #f1f5f9",
              backgroundColor: "#ffffff",
              zIndex: 10,
              flexShrink: 0
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <div style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "8px",
                  backgroundColor: "#fff9e6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  border: "1px solid rgba(255, 160, 0, 0.25)"
                }}>
                  <svg style={{ width: "18px", height: "18px", color: "#ffa000" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <div>
                  <h3 style={{ margin: 0, fontSize: "16px", fontWeight: "700", color: "#0f172a", letterSpacing: "-0.3px" }}>
                    Similar Content Detected
                  </h3>
                  <p style={{ margin: "2px 0 0", fontSize: "11px", color: "#94a3b8", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                    🛡️ SEO QUALITY SAFEGUARD
                  </p>
                </div>
              </div>
              <button 
                type="button"
                onClick={() => {
                  setShowSimilarityModal(false);
                  setAiModalOpen(true); // Reopen Gemini Smart Writer modal immediately on close icon click!
                }}
                style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "50%",
                  border: "none",
                  backgroundColor: "transparent",
                  color: "#94a3b8",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.2s"
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#f1f5f9";
                  e.currentTarget.style.color = "#475569";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = "#94a3b8";
                }}
              >
                <svg style={{ width: "16px", height: "16px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Scrollable Content Body with consistent 24px padding */}
            <div style={{
              padding: "20px 24px",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              backgroundColor: "#ffffff"
            }}>
              
              {/* Softer Compact Match Alert Card */}
              <div style={{
                backgroundColor: "#fef2f2",
                border: "1px solid #fee2e2",
                borderRadius: "10px",
                padding: "12px 16px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "16px"
              }}>
                <div style={{ display: "flex", flexDirection: "column", gap: "2px", minWidth: 0, flex: 1 }}>
                  <span style={{ fontSize: "10px", fontWeight: "800", color: "#ef4444", letterSpacing: "0.5px", textTransform: "uppercase" }}>
                    EXISTING LIVE TOPIC
                  </span>
                  <a 
                    href={`https://poultrybaba.com/blogs/${similarityWarning.permalink}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{ 
                      fontSize: "13.5px", 
                      fontWeight: "600", 
                      color: "#991b1b", 
                      textDecoration: "underline",
                      lineHeight: "1.4",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "block"
                    }}
                  >
                    {similarityWarning.title}
                  </a>
                </div>
                <span style={{
                  fontSize: "11px",
                  fontWeight: "800",
                  color: "#b91c1c",
                  backgroundColor: "#fee2e2",
                  padding: "4px 10px",
                  borderRadius: "12px",
                  border: "1px solid rgba(239, 68, 68, 0.15)",
                  flexShrink: 0,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "3px"
                }}>
                  🔴 {(similarityWarning.similarity * 100).toFixed(1)}% Match
                </span>
              </div>

              {/* Concise Secondary Description */}
              <p style={{ margin: 0, fontSize: "13px", color: "#64748b", lineHeight: "1.5" }}>
                To avoid keyword cannibalization and protect Poultry Baba's search authority, please choose a recommended title or proceed manually.
              </p>

              {/* Recommended Titles Section (Top 3 Clickable Cards) */}
              {aiSuggestedTitles && aiSuggestedTitles.length > 0 && (
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  marginTop: "4px"
                }}>
                  <span style={{ 
                    fontSize: "11px", 
                    textTransform: "uppercase", 
                    fontWeight: "800", 
                    color: "#475569", 
                    letterSpacing: "0.5px",
                    display: "block"
                  }}>
                    💡 RECOMMENDED SEO-SAFE OPTIONS
                  </span>
                  <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    {aiSuggestedTitles.slice(0, 3).map((option, idx) => (
                      <button
                        key={idx}
                        type="button"
                        onClick={() => {
                          setAiInputTitle(option);
                          setTitle(option);
                          setShowSimilarityModal(false);
                          handleAIGeneration(false, true, option);
                        }}
                        style={{
                          padding: "12px 16px",
                          backgroundColor: "#ffffff",
                          border: "1px solid #e2e8f0",
                          borderRadius: "10px",
                          textAlign: "left",
                          fontSize: "13px",
                          fontWeight: "600",
                          color: "#1e293b",
                          cursor: "pointer",
                          transition: "all 0.2s cubic-bezier(0.16, 1, 0.3, 1)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "12px",
                          outline: "none",
                          boxShadow: "none"
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.transform = "translateY(-1.5px)";
                          e.currentTarget.style.backgroundColor = "#fffdf5";
                          e.currentTarget.style.borderColor = "#ffa000";
                          e.currentTarget.style.boxShadow = "0 4px 12px rgba(255, 160, 0, 0.06)";
                          const arrow = e.currentTarget.querySelector(".arrow-icon");
                          if (arrow) arrow.style.transform = "translateX(4px)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.backgroundColor = "#ffffff";
                          e.currentTarget.style.borderColor = "#e2e8f0";
                          e.currentTarget.style.boxShadow = "none";
                          const arrow = e.currentTarget.querySelector(".arrow-icon");
                          if (arrow) arrow.style.transform = "translateX(0)";
                        }}
                      >
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flex: 1, minWidth: 0 }}>
                          <span style={{ fontSize: "14px", flexShrink: 0 }}>✨</span>
                          <span style={{ lineHeight: "1.4", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{option}</span>
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 }}>
                          <span style={{
                            fontSize: "9px",
                            fontWeight: "800",
                            color: "#15803d",
                            backgroundColor: "#dcfce7",
                            padding: "2px 6px",
                            borderRadius: "6px"
                          }}>
                            RECOMMENDED
                          </span>
                          <svg 
                            className="arrow-icon"
                            style={{ width: "14px", height: "14px", color: "#ffa000", transition: "transform 0.2s" }} 
                            fill="none" 
                            stroke="currentColor" 
                            viewBox="0 0 24 24"
                          >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 5l7 7-7 7" />
                          </svg>
                        </div>
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>

            {/* Sticky Action Footer */}
            <div style={{
              display: "flex",
              gap: "12px",
              padding: "16px 24px",
              borderTop: "1px solid #f1f5f9",
              backgroundColor: "#f8fafc",
              justifyContent: "space-between",
              alignItems: "center",
              flexShrink: 0
            }}>
              <button
                type="button"
                onClick={() => {
                  setShowSimilarityModal(false);
                  handleAIGeneration(false, true);
                }}
                style={{
                  flex: 1,
                  height: "40px",
                  borderRadius: "8px",
                  border: "1px solid #cbd5e1",
                  backgroundColor: "#ffffff",
                  color: "#475569",
                  fontWeight: "600",
                  fontSize: "13px",
                  cursor: "pointer",
                  transition: "all 0.2s"
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#f1f5f9";
                  e.currentTarget.style.borderColor = "#94a3b8";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#ffffff";
                  e.currentTarget.style.borderColor = "#cbd5e1";
                }}
              >
                Proceed Anyway
              </button>
              <button
                type="button"
                onClick={() => {
                  const opt = aiSuggestedTitles[0];
                  setAiInputTitle(opt);
                  setTitle(opt);
                  setShowSimilarityModal(false);
                  handleAIGeneration(false, true, opt);
                }}
                style={{
                  flex: 1,
                  height: "40px",
                  borderRadius: "8px",
                  border: "none",
                  background: "linear-gradient(135deg, #ffa000 0%, #ff6f00 100%)",
                  color: "#ffffff",
                  fontWeight: "600",
                  fontSize: "13px",
                  cursor: "pointer",
                  boxShadow: "0 2px 8px rgba(255, 160, 0, 0.2)",
                  transition: "all 0.2s"
                }}
                onMouseOver={(e) => e.currentTarget.style.filter = "brightness(0.95)"}
                onMouseOut={(e) => e.currentTarget.style.filter = "brightness(1)"}
              >
                Use Recommended Title
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Section-Specific AI Refiner Modal */}
      {sectionRefinerOpen && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(15, 23, 42, 0.6)",
          backdropFilter: "blur(8px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999999,
          animation: "fadeIn 0.25s ease-out"
        }}>
          <div style={{
            backgroundColor: "#ffffff",
            borderRadius: "24px",
            width: "90%",
            maxWidth: "600px",
            padding: "28px",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            border: "1px solid rgba(16, 185, 129, 0.2)",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            animation: "scaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)"
          }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <div style={{
                  backgroundColor: "#ecfdf5",
                  padding: "8px",
                  borderRadius: "12px",
                  color: "#10b981",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                  <Icons.Sparkles style={{ width: "20px", height: "20px" }} />
                </div>
                <div>
                  <h3 style={{ fontSize: "16px", fontWeight: "800", color: "#0f172a", margin: 0 }}>
                    Section AI Refiner
                  </h3>
                  <p style={{ fontSize: "11px", color: "#64748b", margin: 0 }}>
                    Refining: <strong>{refinerSectionName}</strong>
                  </p>
                </div>
              </div>
              <button
                type="button"
                onClick={() => setSectionRefinerOpen(false)}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: "18px",
                  color: "#94a3b8",
                  cursor: "pointer"
                }}
              >
                ✕
              </button>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <label className="premium-label" style={{ fontSize: "11px", textTransform: "uppercase", color: "#475569" }}>
                Current Section Content (Reference)
              </label>
              <div style={{
                maxHeight: "120px",
                overflowY: "auto",
                backgroundColor: "#f8fafc",
                borderRadius: "12px",
                padding: "12px",
                border: "1px solid #e2e8f0",
                fontSize: "12px",
                color: "#334155",
                lineHeight: "1.5"
              }}>
                {typeof refinerCurrentValue === "object" ? (
                  <pre style={{ margin: 0, fontSize: "11px", fontFamily: "monospace" }}>
                    {JSON.stringify(refinerCurrentValue, null, 2)}
                  </pre>
                ) : (
                  <div dangerouslySetInnerHTML={{ __html: refinerCurrentValue || "(Empty Content)" }} />
                )}
              </div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
              <label className="premium-label" style={{ fontSize: "11px", textTransform: "uppercase", color: "#475569" }}>
                AI Refinement Instruction
              </label>
              <textarea
                value={refinerInstruction}
                onChange={(e) => setRefinerInstruction(e.target.value)}
                placeholder="e.g. Translate this section to Roman Urdu, make it more detailed, write it in bullet points, or fix the formatting..."
                style={{
                  height: "110px",
                  width: "100%",
                  borderRadius: "12px",
                  border: "1px solid #cbd5e1",
                  padding: "12px",
                  fontSize: "13px",
                  lineHeight: "1.5",
                  outline: "none",
                  resize: "none"
                }}
              />
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "8px" }}>
              <button
                type="button"
                onClick={() => setSectionRefinerOpen(false)}
                className="premium-btn"
                style={{
                  backgroundColor: "#f1f5f9",
                  color: "#475569",
                  padding: "10px 20px",
                  fontSize: "13px",
                  fontWeight: "600",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                  cursor: "pointer"
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={isRefiningSection}
                onClick={handleRunSectionRefinement}
                style={{
                  background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                  color: "#ffffff",
                  padding: "10px 24px",
                  fontSize: "13px",
                  fontWeight: "700",
                  borderRadius: "10px",
                  border: "none",
                  boxShadow: "0 4px 6px rgba(16, 185, 129, 0.25)",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  opacity: isRefiningSection ? 0.6 : 1,
                  pointerEvents: isRefiningSection ? "none" : "auto"
                }}
              >
                <Icons.Sparkles style={{ width: "14px", height: "14px" }} />
                {isRefiningSection ? "Refining Section..." : "Apply AI Refinement"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Premium Multi-Line Custom Prompt Image Generator Modal */}
      {imagePromptModalOpen && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(15, 23, 42, 0.6)",
          backdropFilter: "blur(8px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999999,
          animation: "fadeIn 0.25s ease-out"
        }}>
          <div 
            className="cms-modal-card"
            style={{
              animation: "scaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)"
            }}
          >
            {/* Locked Non-Scrolling Header */}
            <div className="cms-modal-header">
              <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <div style={{
                  backgroundColor: "#ecfdf5",
                  padding: "10px",
                  borderRadius: "14px",
                  color: "#10b981",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                }}>
                  <Icons.Sparkles style={{ width: "22px", height: "22px", stroke: "#10b981" }} />
                </div>
                <div>
                  <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "800", color: "#0f172a" }}>
                    Custom AI Image Generator
                  </h3>
                  <p style={{ margin: "3px 0 0", fontSize: "11px", color: "#475569", fontWeight: "750", textTransform: "uppercase", letterSpacing: "0.75px" }}>
                    Powered by Google Imagen 3 Active
                  </p>
                </div>
              </div>
              <button 
                type="button"
                onClick={() => setImagePromptModalOpen(false)}
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "50%",
                  border: "none",
                  backgroundColor: "#f1f5f9",
                  color: "#334155",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  transition: "all 0.2s"
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#e2e8f0"}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#f1f5f9"}
              >
                <svg style={{ width: "18px", height: "18px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Inner Custom Scrollable Content Area */}
            <div className="cms-modal-body custom-scrollbar">
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <label className="premium-label" style={{ margin: 0, fontSize: "12.5px", fontWeight: "800", color: "#334155" }}>
                  Write Detailed Multi-Line Prompt
                </label>
                <textarea
                  value={aiCustomImagePrompt}
                  onChange={(e) => setAiCustomImagePrompt(e.target.value)}
                  rows="3"
                  placeholder="Describe what you want to see in the banner image in rich detail (e.g. fluffy yellow chicks on a clean farm, eating grains of pearl millet / bajra seed, photorealistic photography, warm morning sunlight, highly detailed 8k...)"
                  style={{
                    width: "100%",
                    padding: "16px",
                    borderRadius: "14px",
                    border: "1.5px solid #cbd5e1",
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "1.5",
                    color: "#0f172a",
                    outline: "none",
                    resize: "none",
                    transition: "border-color 0.2s",
                    fontFamily: "inherit"
                  }}
                  onFocus={(e) => e.currentTarget.style.borderColor = "#10b981"}
                  onBlur={(e) => e.currentTarget.style.borderColor = "#cbd5e1"}
                />
                <div className="cms-flex-between" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: "12px", fontWeight: "700", color: "#64748b" }}>
                  <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                    <Icons.Lightbulb style={{ width: "15px", height: "15px", color: "#10b981", flexShrink: 0 }} />
                    <span>Use English or Roman Urdu tags below to speed up creation.</span>
                  </span>
                  <span style={{ backgroundColor: "#f1f5f9", padding: "2px 8px", borderRadius: "6px", color: "#0f172a", flexShrink: 0 }}>{aiCustomImagePrompt.length} characters</span>
                </div>
              </div>

              {/* Quick-add Tag Suggestions Row */}
              <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <span style={{ fontSize: "12px", fontWeight: "900", color: "#334155", textTransform: "uppercase", letterSpacing: "0.5px", display: "flex", alignItems: "center", gap: "6px" }}>
                  <svg style={{ width: "16px", height: "16px", color: "#10b981" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M7 7h.01M6 20h12a2 2 0 002-2V8a2 2 0 00-.586-1.414l-2-2A2 2 0 0016 4H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                  Recommended Quick Tags (Tap to add)
                </span>
                <div className="cms-flex cms-gap-2" style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                  {[
                    "Fluffy baby yellow chicks",
                    "Brown layer chicks",
                    "White layer chicks",
                    "Eating pearl millet (bajra)",
                    "Modern Pakistani poultry farm",
                    "Organic chicken feeding",
                    "Cinematic volumetric lighting",
                    "Photorealistic 8k camera lens"
                  ].map((tag) => (
                    <button
                      key={tag}
                      type="button"
                      onClick={() => {
                        const prefix = aiCustomImagePrompt.trim() ? aiCustomImagePrompt.trim() + ", " : "";
                        setAiCustomImagePrompt(prefix + tag);
                      }}
                      style={{
                        border: "1px solid rgba(16, 185, 129, 0.15)",
                        background: "rgba(16, 185, 129, 0.05)",
                        color: "#065f46",
                        padding: "8px 14px",
                        borderRadius: "100px",
                        fontSize: "12px",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "all 0.25s cubic-bezier(0.4, 0, 0.2, 1)",
                        boxShadow: "0 2px 4px rgba(16, 185, 129, 0.04)"
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.background = "rgba(16, 185, 129, 0.1)";
                        e.currentTarget.style.borderColor = "#10b981";
                        e.currentTarget.style.transform = "translateY(-1.5px)";
                        e.currentTarget.style.boxShadow = "0 4px 10px rgba(16, 185, 129, 0.12)";
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.background = "rgba(16, 185, 129, 0.05)";
                        e.currentTarget.style.borderColor = "rgba(16, 185, 129, 0.15)";
                        e.currentTarget.style.transform = "none";
                        e.currentTarget.style.boxShadow = "0 2px 4px rgba(16, 185, 129, 0.04)";
                      }}
                    >
                      + {tag}
                    </button>
                  ))}
                </div>
              </div>

              {/* Loading step tracker inside the popup modal */}
              {isAiGeneratingImage && (
                <div style={{
                  backgroundColor: "#f8fafc",
                  border: "2px dashed #10b981",
                  borderRadius: "18px",
                  padding: "18px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "12px",
                  animation: "pulse 1.5s infinite"
                }}>
                  <div className="emerald-spinner" style={{
                    width: "32px",
                    height: "32px",
                    border: "3.5px solid #e2e8f0",
                    borderTop: "3.5px solid #10b981",
                    borderRadius: "50%",
                    animation: "spin 0.8s linear infinite"
                  }}></div>
                  <div style={{ textAlign: "center" }}>
                    <p style={{ margin: 0, fontSize: "14px", fontWeight: "900", color: "#065f46" }}>
                      Generating Customized Banner...
                    </p>
                    <p style={{ margin: "4px 0 0", fontSize: "12px", color: "#475569", fontWeight: "700" }}>
                      Imagen 3 is rendering photorealistic shapes. Please stand by.
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* Non-Scrolling Bottom Actions Footer */}
            <div className="cms-modal-footer">
              <button
                type="button"
                onClick={() => setImagePromptModalOpen(false)}
                style={{
                  backgroundColor: "#ffffff",
                  color: "#334155",
                  padding: "11px 22px",
                  fontSize: "14px",
                  fontWeight: "750",
                  borderRadius: "12px",
                  border: "1.5px solid #e2e8f0",
                  cursor: "pointer",
                  transition: "all 0.2s"
                }}
                onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#f1f5f9"}
                onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#ffffff"}
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={isAiGeneratingImage || !aiCustomImagePrompt.trim()}
                onClick={async () => {
                  try {
                    await handleGenerateAIImage();
                    setImagePromptModalOpen(false); // Close on success
                  } catch (err) {
                    console.error("AI image generation error in popup:", err);
                  }
                }}
                style={{
                  background: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                  color: "#ffffff",
                  padding: "12px 26px",
                  fontSize: "14px",
                  fontWeight: "800",
                  borderRadius: "12px",
                  border: "none",
                  boxShadow: "0 4px 12px rgba(16, 185, 129, 0.25)",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  opacity: (isAiGeneratingImage || !aiCustomImagePrompt.trim()) ? 0.6 : 1,
                  pointerEvents: (isAiGeneratingImage || !aiCustomImagePrompt.trim()) ? "none" : "auto",
                  transition: "all 0.2s"
                }}
                onMouseOver={(e) => e.currentTarget.style.transform = "translateY(-1px)"}
                onMouseOut={(e) => e.currentTarget.style.transform = "none"}
              >
                <Icons.Sparkles style={{ width: "15px", height: "15px" }} />
                Generate Banner
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Premium English Success Modal Overlay */}
      {showSuccessModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(15, 23, 42, 0.6)",
          backdropFilter: "blur(8px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999999,
          animation: "fadeIn 0.25s ease-out"
        }}>
          <div style={{
            backgroundColor: "#ffffff",
            borderRadius: "24px",
            width: "90%",
            maxWidth: "500px",
            padding: "32px",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            border: "1px solid rgba(245, 158, 11, 0.2)",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            transform: "translateY(0)",
            animation: "scaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)"
          }}>
            {/* Animated Golden Pulse Ring with Sparkle Icon */}
            <div style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              backgroundColor: "rgba(245, 158, 11, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #f59e0b",
              animation: "pulseRing 2s infinite"
            }}>
              <svg style={{ width: "40px", height: "40px", color: "#f59e0b" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
              </svg>
            </div>

            {/* Typography */}
            <div className="cms-flex-col cms-gap-2">
              <h2 style={{
                margin: 0,
                fontSize: "24px",
                fontWeight: "800",
                color: "#1e293b",
                letterSpacing: "-0.5px"
              }}>
                ✨ Generation Successful!
              </h2>
              <p style={{
                margin: "8px 0 0",
                fontSize: "14.5px",
                color: "#475569",
                lineHeight: "1.6",
                padding: "0 8px"
              }}>
                Congratulations! Gemini has successfully generated your high-quality poultry article and structured fields.
              </p>
              <div style={{
                backgroundColor: "#fdfbf7",
                border: "1px dashed #f5e6d3",
                borderRadius: "12px",
                padding: "12px",
                fontSize: "13px",
                color: "#7c2d12",
                fontWeight: "500",
                lineHeight: "1.5",
                marginTop: "12px"
              }}>
                💡 Please scroll down to review, analyze, and proofread all fields before publishing live.
              </div>
            </div>

            {/* Action Button */}
            <button
              onClick={() => setShowSuccessModal(false)}
              style={{
                backgroundColor: "#ff9f00",
                color: "#ffffff",
                border: "none",
                borderRadius: "14px",
                padding: "14px 28px",
                fontSize: "16px",
                fontWeight: "700",
                cursor: "pointer",
                boxShadow: "0 10px 15px -3px rgba(255, 159, 0, 0.4)",
                transition: "all 0.2s ease-in-out",
                width: "100%",
                marginTop: "8px"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#e68a00";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#ff9f00";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              Analyze & Review Content
            </button>
          </div>
        </div>
      )}

      {/* Saved Drafts List Modal Drawer */}
      {draftsModalOpen && (
        <div style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(15, 23, 42, 0.6)",
          backdropFilter: "blur(8px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999998,
          animation: "fadeIn 0.25s ease-out"
        }}>
          <div style={{
            background: "#ffffff",
            borderRadius: "20px",
            width: "700px",
            maxWidth: "95%",
            height: "80vh",
            maxHeight: "650px",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            border: "1px solid #e2e8f0",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            boxSizing: "border-box"
          }}>
            {/* Modal Header */}
            <div style={{
              padding: "20px 24px",
              borderBottom: "1px solid #f1f5f9",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              background: "linear-gradient(to right, #f8fafc, #ffffff)",
              flexShrink: 0
            }}>
              <div>
                <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "800", color: "#1e293b", fontFamily: "Outfit, sans-serif" }}>
                  Saved Drafts Workspace
                </h3>
                <p style={{ margin: "4px 0 0 0", fontSize: "12px", color: "#64748b" }}>
                  Load any of your previous article drafts to finish writing or publish them live.
                </p>
              </div>
              <button
                type="button"
                onClick={() => setDraftsModalOpen(false)}
                style={{
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                  color: "#94a3b8",
                  padding: "6px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  transition: "all 0.15s ease"
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#f1f5f9";
                  e.currentTarget.style.color = "#475569";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = "#94a3b8";
                }}
              >
                <svg style={{ width: "20px", height: "20px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Drafts List Container */}
            <div style={{ flex: 1, padding: "20px 24px", overflowY: "auto", background: "#f8fafc" }}>
              {isLoadingDrafts ? (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: "12px" }}>
                  <div style={{
                    width: "36px",
                    height: "36px",
                    borderRadius: "50%",
                    border: "3px solid #f1f5f9",
                    borderTopColor: "#fb6222",
                    animation: "pulseRingGreen 1s linear infinite"
                  }}></div>
                  <span style={{ fontSize: "13.5px", fontWeight: "600", color: "#475569" }}>Loading drafts from database...</span>
                </div>
              ) : draftsList.length === 0 ? (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100%", gap: "12px", textAlign: "center" }}>
                  <div style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "50%",
                    background: "#fff7ed",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                    <svg style={{ width: "32px", height: "32px", color: "#fb6222" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                  </div>
                  <span style={{ fontSize: "15px", fontWeight: "750", color: "#1e293b" }}>No Saved Drafts Found!</span>
                  <span style={{ fontSize: "12.5px", color: "#64748b", maxWidth: "320px" }}>You haven't saved any article drafts yet. Start writing a new article and click "Save Draft" to see it here!</span>
                </div>
              ) : (
                <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                  {draftsList.map((draft) => {
                    const filledFields = [
                      draft.title,
                      draft.description,
                      draft.quickAnswer,
                      draft.articleImage?.[0]?.url,
                      draft.focusKeyword,
                      draft.metaDescription,
                      draft.subCategory,
                      draft.province,
                      draft.city
                    ].filter(Boolean).length;
                    const progressVal = Math.round((filledFields / 9) * 100);

                    return (
                      <div
                        key={draft._id}
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "14px",
                          border: "1px solid #e2e8f0",
                          padding: "16px",
                          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.02)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: "16px",
                          transition: "all 0.2s ease"
                        }}
                      >
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <h4 style={{
                            margin: 0,
                            fontSize: "14.5px",
                            fontWeight: "800",
                            color: "#1e293b",
                            lineHeight: "1.4",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                          }}>
                            {draft.title || "Untitled Draft Article"}
                          </h4>
                          <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "6px" }}>
                            <span style={{ fontSize: "11px", fontWeight: "600", color: "#64748b", display: "inline-flex", alignItems: "center", gap: "4px" }}>
                              <svg style={{ width: "12px", height: "12px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                              </svg>
                              {new Date(draft.updatedAt || draft.createdAt).toLocaleDateString("en-US", { day: "numeric", month: "short", year: "numeric" })}
                            </span>
                            <span style={{ fontSize: "11px", fontWeight: "700", color: "#fb6222", backgroundColor: "#fff7ed", padding: "1px 8px", borderRadius: "100px" }}>
                              {draft.pageCategory?.[0] || "No Category"}
                            </span>
                          </div>

                          {/* Completion Progress Bar */}
                          <div style={{ marginTop: "12px", width: "100%", maxWidth: "200px" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "4px" }}>
                              <span style={{ fontSize: "10px", fontWeight: "700", color: "#64748b" }}>Progress:</span>
                              <span style={{ fontSize: "10px", fontWeight: "800", color: progressVal > 50 ? "#10b981" : "#fb6222" }}>{progressVal}%</span>
                            </div>
                            <div style={{ width: "100%", height: "5px", backgroundColor: "#f1f5f9", borderRadius: "100px", overflow: "hidden" }}>
                              <div style={{
                                width: `${progressVal}%`,
                                height: "100%",
                                backgroundColor: progressVal > 50 ? "#10b981" : "#fb6222",
                                borderRadius: "100px"
                              }}></div>
                            </div>
                          </div>
                        </div>

                        {/* Action Buttons Container */}
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          {/* Resume Button */}
                          <button
                            type="button"
                            onClick={() => loadDraftIntoEditor(draft)}
                            style={{
                              padding: "8px 16px",
                              borderRadius: "10px",
                              background: "linear-gradient(135deg, #1e293b 0%, #0f172a 100%)",
                              color: "#ffffff",
                              border: "none",
                              fontSize: "12px",
                              fontWeight: "800",
                              cursor: "pointer",
                              display: "inline-flex",
                              alignItems: "center",
                              gap: "6px",
                              transition: "all 0.15s ease",
                              boxShadow: "0 4px 6px -1px rgba(15, 23, 42, 0.15)"
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.filter = "brightness(0.9)";
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.filter = "none";
                            }}
                          >
                            Resume Writing
                            <svg style={{ width: "12px", height: "12px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 5l7 7-7 7" />
                            </svg>
                          </button>

                          {/* Delete Button */}
                          <button
                            type="button"
                            onClick={async () => {
                              if (window.confirm("Are you sure you want to permanently delete this draft? This action cannot be undone.")) {
                                try {
                                  const token = props.Auth?.user?.token;
                                  if (!token) return;
                                  await deleteArticle({ articleId: draft._id }, token);
                                  setToastMessage("Draft article deleted successfully!");
                                  setTimeout(() => setToastMessage(""), 4000);
                                  fetchDrafts();
                                } catch (err) {
                                  console.error("Failed to delete draft:", err);
                                  triggerAlert("Failed to delete draft. Please try again.", "Error", "error");
                                }
                              }
                            }}
                            style={{
                              width: "36px",
                              height: "36px",
                              borderRadius: "10px",
                              backgroundColor: "#fef2f2",
                              border: "1.5px solid #fee2e2",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              cursor: "pointer",
                              color: "#ef4444",
                              transition: "all 0.15s ease"
                            }}
                            onMouseOver={(e) => {
                              e.currentTarget.style.backgroundColor = "#fee2e2";
                              e.currentTarget.style.color = "#b91c1c";
                            }}
                            onMouseOut={(e) => {
                              e.currentTarget.style.backgroundColor = "#fef2f2";
                              e.currentTarget.style.color = "#ef4444";
                            }}
                            title="Delete Draft"
                          >
                            <svg style={{ width: "16px", height: "16px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* Modal Footer */}
            <div style={{
              padding: "16px 24px",
              borderTop: "1px solid #f1f5f9",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              background: "#ffffff",
              flexShrink: 0
            }}>
              <button
                type="button"
                onClick={() => setDraftsModalOpen(false)}
                style={{
                  padding: "10px 20px",
                  borderRadius: "10px",
                  background: "#f1f5f9",
                  color: "#475569",
                  border: "none",
                  fontWeight: "700",
                  fontSize: "13px",
                  cursor: "pointer",
                  transition: "all 0.15s ease"
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = "#e2e8f0";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = "#f1f5f9";
                }}
              >
                Close Window
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Premium Custom Alert Modal */}
      {customAlert.isOpen && (
        <div style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(15, 23, 42, 0.6)",
          backdropFilter: "blur(8px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999999,
          animation: "fadeIn 0.25s ease-out"
        }}>
          <div style={{
            background: "#ffffff",
            borderRadius: "16px",
            width: "480px",
            maxWidth: "90%",
            boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
            border: "1px solid #e2e8f0",
            padding: "24px",
            transform: "scale(1)",
            animation: "scaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)",
            boxSizing: "border-box"
          }}>
            {/* Header Icon + Title */}
            <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "16px" }}>
              <div style={{
                width: "42px",
                height: "42px",
                borderRadius: "50%",
                background: customAlert.type === "error" ? "#fef2f2" : customAlert.type === "success" ? "#ecfdf5" : "#fffbeb",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0
              }}>
                {customAlert.type === "error" ? (
                  <svg style={{ width: "22px", height: "22px", color: "#ef4444" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                ) : customAlert.type === "success" ? (
                  <svg style={{ width: "22px", height: "22px", color: "#10b981" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  <svg style={{ width: "22px", height: "22px", color: "#f59e0b" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                  </svg>
                )}
              </div>
              <h3 style={{
                margin: 0,
                fontSize: "18px",
                fontWeight: "800",
                color: "#1e293b",
                fontFamily: "Outfit, Inter, sans-serif"
              }}>
                {customAlert.title}
              </h3>
            </div>

            {/* Message Content */}
            <p style={{
              margin: "0 0 24px 0",
              fontSize: "14px",
              color: "#475569",
              lineHeight: "1.6",
              fontFamily: "Inter, sans-serif",
              whiteSpace: "pre-line"
            }}>
              {customAlert.message}
            </p>

            {/* Action Buttons */}
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <button
                type="button"
                onClick={() => setCustomAlert(prev => ({ ...prev, isOpen: false }))}
                style={{
                  padding: "10px 22px",
                  borderRadius: "10px",
                  background: customAlert.type === "error" ? "#ef4444" : customAlert.type === "success" ? "#10b981" : "#fb6222",
                  color: "#ffffff",
                  border: "none",
                  fontWeight: "700",
                  fontSize: "14px",
                  cursor: "pointer",
                  boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                  transition: "all 0.15s ease",
                  fontFamily: "Inter, sans-serif"
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.filter = "brightness(0.95)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.filter = "none";
                }}
              >
                Got It / OK
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Premium Save & Publish Success Modal Overlay */}
      {showPublishModal && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(15, 23, 42, 0.6)",
          backdropFilter: "blur(8px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999999,
          animation: "fadeIn 0.25s ease-out"
        }}>
          <div style={{
            backgroundColor: "#ffffff",
            borderRadius: "24px",
            width: "90%",
            maxWidth: "500px",
            padding: "32px",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            border: "1px solid rgba(16, 185, 129, 0.2)",
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "20px",
            transform: "translateY(0)",
            animation: "scaleIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1)"
          }}>
            {/* Animated Green Pulse Ring with Checkmark Icon */}
            <div style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              backgroundColor: "rgba(16, 185, 129, 0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              border: "2px solid #10b981",
              animation: "pulseRingGreen 2s infinite"
            }}>
              <svg style={{ width: "40px", height: "40px", color: "#10b981" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M5 13l4 4L19 7" />
              </svg>
            </div>

            {/* Typography */}
            <div className="cms-flex-col cms-gap-2">
              <h2 style={{
                margin: 0,
                fontSize: "24px",
                fontWeight: "800",
                color: "#1e293b",
                letterSpacing: "-0.5px"
              }}>
                {isLastOperationUpdate ? "🎉 Article Updated Successfully!" : "🎉 Save & Publish Successful!"}
              </h2>
              <p style={{
                margin: "8px 0 0",
                fontSize: "14.5px",
                color: "#475569",
                lineHeight: "1.6",
                padding: "0 8px"
              }}>
                {isLastOperationUpdate 
                  ? "Mubarak Ho! Aapka refined article kamyabi se update ho gaya hai aur live website par publish ho chuka hai."
                  : "Mubarak Ho! Your article has been safely stored in the cloud database and published to the live platform."}
              </p>
              <div style={{
                backgroundColor: "#f0fdf4",
                border: "1px dashed #bbf7d0",
                borderRadius: "12px",
                padding: "12px",
                fontSize: "13px",
                color: "#166534",
                fontWeight: "500",
                lineHeight: "1.5",
                marginTop: "12px"
              }}>
                {isLastOperationUpdate
                  ? "✨ Refined article details have been saved, and all editing fields have been securely reset."
                  : "✨ All editing fields have been securely reset and prepared for your next poultry article."}
              </div>
            </div>

            {/* Action Button */}
            <button
              onClick={() => setShowPublishModal(false)}
              style={{
                backgroundColor: "#10b981",
                color: "#ffffff",
                border: "none",
                borderRadius: "14px",
                padding: "14px 28px",
                fontSize: "16px",
                fontWeight: "700",
                cursor: "pointer",
                boxShadow: "0 10px 15px -3px rgba(16, 185, 129, 0.4)",
                transition: "all 0.2s ease-in-out",
                width: "100%",
                marginTop: "8px"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#059669";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#10b981";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              Write Another Masterpiece
            </button>
          </div>
        </div>
      )}

      {/* Floating Gemini AI Workspace Modal */}
      {aiModalOpen && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(15, 23, 42, 0.45)",
          backdropFilter: "blur(12px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 99999,
          animation: "fadeIn 0.2s ease-out"
        }}>
          <div className="cms-modal-card cms-modal-card-amber" style={{ maxWidth: "580px", position: "relative" }}>
            {/* Close Button */}
            <button
              onClick={() => setAiModalOpen(false)}
              style={{
                position: "absolute",
                top: "20px",
                right: "20px",
                backgroundColor: "#f1f5f9",
                border: "none",
                borderRadius: "50%",
                width: "32px",
                height: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                color: "#64748b",
                zIndex: 20,
                transition: "all 0.15s ease"
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#e2e8f0";
                e.currentTarget.style.color = "#0f172a";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = "#f1f5f9";
                e.currentTarget.style.color = "#64748b";
              }}
            >
              <svg style={{ width: "16px", height: "16px" }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            {/* Locked Non-Scrolling Modal Header */}
            <div className="cms-modal-header" style={{ paddingBottom: "16px" }}>
              <div className="cms-flex cms-gap-3" style={{ paddingRight: "40px" }}>
                <span style={{
                  width: "44px",
                  height: "44px",
                  borderRadius: "12px",
                  backgroundColor: "rgba(255, 159, 0, 0.12)",
                  color: "#ff9f00",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                }}>
                  <Icons.Sparkles style={{ width: "22px", height: "22px" }} />
                </span>
                <div>
                  <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "800", color: "#0f172a" }}>
                    {articleId ? "Gemini AI Article Refiner" : "Gemini AI Smart Writer"}
                  </h3>
                  <p style={{ margin: "2px 0 0", fontSize: "12px", color: "#64748b" }}>
                    {articleId ? `Refining & optimizing: "${title || 'Untitled Article'}"` : "Instantly compose or refine your articles."}
                  </p>
                </div>
              </div>
            </div>

            {/* Inner Custom Scrollable Content Area */}
            <div className="cms-modal-body custom-scrollbar">
              {articleId ? (
                /* Mode A: Premium Dedicated AI Refiner (For existing articles) */
                <div className="cms-flex-col cms-gap-3" style={{ backgroundColor: "#fbfbfe", padding: "18px", borderRadius: "16px", border: "1px solid #eef2f6" }}>
                  <div className="cms-flex cms-align-center cms-gap-2">
                    <span style={{ fontSize: "13px", fontWeight: "800", color: "#ff9f00", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                      Select a preset or enter instructions to refine:
                    </span>
                  </div>
                  
                  {/* Interactive Quick Refinement Presets */}
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", margin: "6px 0 10px" }}>
                    {[
                      { label: "🏆 Maximize Quality (100% Score)", text: "Rewrite and structure this entire article to secure 100% SEO and Content Health. You MUST strictly do all of the following: 1) Format the text with clear hierarchical subheadings (use <h2> and <h3> tags). 2) Create at least one rich, structured HTML table (<table>, <tr>, <td>) containing relevant statistics or prices. 3) Inject clear numerical facts, figures, and rates in the text. 4) List authoritative 'Sources' or 'References' at the bottom of the content with URLs. 5) Write a detailed, comprehensive coverage exceeding 300 words. Make the tone highly authoritative, professional, and completely optimized for Google ranking." },
                      { label: "✨ Professional Polish", text: "Refine this article to make the tone highly professional, authoritative, engaging, and clear for poultry industry readers." },
                      { label: "🔍 SEO Optimization", text: "Optimize this article for search engines. Improve keyword placements, enhance readability, meta-tags alignment, and section transitions." },
                      { label: "✍️ Fix Grammar & Flow", text: "Scan and correct any grammatical errors, spelling mistakes, or awkward phrasing. Smooth out sentences for better flow." },
                      { label: "📰 News Story Format", text: "Format and refine the content style to read like an official, high-quality industry news story or press release." },
                      { label: "🌐 Urdu Polish", text: "Enhance and polish any Urdu sections, ensuring highly natural phrasing, proper grammar, and professional Urdu vocabulary." }
                    ].map((preset, idx) => (
                      <button
                        key={idx}
                        type="button"
                        onClick={() => setAiRefinementPrompt(preset.text)}
                        style={{
                          padding: "6px 14px",
                          fontSize: "12px",
                          fontWeight: "700",
                          borderRadius: "20px",
                          border: aiRefinementPrompt === preset.text 
                            ? (preset.label.includes("100%") ? "2px solid #b45309" : "1.5px solid #ff9f00") 
                            : (preset.label.includes("100%") ? "1.5px solid #fcd34d" : "1px solid #e2e8f0"),
                          backgroundColor: aiRefinementPrompt === preset.text 
                            ? (preset.label.includes("100%") ? "#fef3c7" : "#fffbeb") 
                            : (preset.label.includes("100%") ? "#fffbeb" : "#ffffff"),
                          color: aiRefinementPrompt === preset.text 
                            ? (preset.label.includes("100%") ? "#b45309" : "#ff9f00") 
                            : (preset.label.includes("100%") ? "#b45309" : "#475569"),
                          cursor: "pointer",
                          transition: "all 0.15s ease",
                          outline: "none",
                          boxShadow: preset.label.includes("100%") ? "0 2px 6px rgba(217, 119, 6, 0.08)" : "none"
                        }}
                        onMouseOver={(e) => {
                          if (aiRefinementPrompt !== preset.text) {
                            e.currentTarget.style.borderColor = preset.label.includes("100%") ? "#fbbf24" : "#cbd5e1";
                            e.currentTarget.style.backgroundColor = preset.label.includes("100%") ? "#fef3c7" : "#f8fafc";
                          }
                        }}
                        onMouseOut={(e) => {
                          if (aiRefinementPrompt !== preset.text) {
                            e.currentTarget.style.borderColor = preset.label.includes("100%") ? "#fcd34d" : "#e2e8f0";
                            e.currentTarget.style.backgroundColor = preset.label.includes("100%") ? "#fffbeb" : "#ffffff";
                          }
                        }}
                      >
                        {preset.label}
                      </button>
                    ))}
                  </div>

                  <textarea
                    value={aiRefinementPrompt}
                    onChange={(e) => setAiRefinementPrompt(e.target.value)}
                    rows="4"
                    style={{
                      width: "100%",
                      border: "1px solid #cbd5e1",
                      borderRadius: "12px",
                      padding: "12px 14px",
                      outline: "none",
                      fontSize: "13.5px",
                      fontWeight: "500",
                      backgroundColor: "#ffffff",
                      transition: "all 0.2s ease",
                      resize: "none",
                      lineHeight: "1.5",
                      fontFamily: "inherit"
                    }}
                    placeholder="Describe what to improve (e.g. 'Add a section warning farmers about winter feed costs' or choose a preset above)..."
                    onFocus={(e) => e.target.style.borderColor = "#ff9f00"}
                    onBlur={(e) => e.target.style.borderColor = "#cbd5e1"}
                  />
                  
                  <button
                    type="button"
                    onClick={() => {
                      setAiModalOpen(false);
                      handleAIGeneration(true);
                    }}
                    style={{
                      width: "100%",
                      height: "46px",
                      border: "none",
                      borderRadius: "12px",
                      color: "#ffffff",
                      background: "linear-gradient(135deg, #f97316 0%, #ff9f00 100%)",
                      fontWeight: "800",
                      fontSize: "14.5px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      boxShadow: "0 4px 15px rgba(249, 115, 22, 0.25)",
                      transition: "all 0.2s ease",
                      marginTop: "4px"
                    }}
                    onMouseOver={(e) => {
                      e.currentTarget.style.transform = "translateY(-1px)";
                      e.currentTarget.style.boxShadow = "0 6px 20px rgba(249, 115, 22, 0.35)";
                    }}
                    onMouseOut={(e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "0 4px 15px rgba(249, 115, 22, 0.25)";
                    }}
                  >
                    <Icons.Sparkles style={{ width: "18px", height: "16px", stroke: "currentColor" }} /> AI Refine Now
                  </button>
                </div>
              ) : (
                /* Mode B: Regular Full Writer Modal (For creating new articles) */
                <>
                  {/* Main Title Prompt Card Section */}
                  <div className="cms-flex-col cms-gap-3" style={{ backgroundColor: "#fafaf9", padding: "16px", borderRadius: "16px", border: "1px solid #f1f0ec" }}>
                    <div className="cms-flex cms-align-center cms-gap-2">
                      <span style={{ fontSize: "12px", fontWeight: "800", color: "#ff9f00", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Compose New Article
                      </span>
                    </div>
                    <textarea
                      value={aiInputTitle}
                      onChange={(e) => setAiInputTitle(e.target.value)}
                      rows={4}
                      style={{
                        width: "100%",
                        minHeight: "100px",
                        border: "1px solid #cbd5e1",
                        borderRadius: "12px",
                        padding: "12px 14px",
                        outline: "none",
                        fontSize: "14px",
                        fontWeight: "500",
                        backgroundColor: "#ffffff",
                        transition: "all 0.2s ease",
                        resize: "vertical",
                        lineHeight: "1.5",
                        fontFamily: "inherit"
                      }}
                      placeholder="Enter main title, keywords, or detailed prompt instructions (e.g., 'Write about maize prices, mention rates from www.poultrybaba.com')...."
                      onFocus={(e) => e.target.style.borderColor = "#ff9f00"}
                      onBlur={(e) => e.target.style.borderColor = "#cbd5e1"}
                    />
                    
                    {/* ARTICLE WRITING TONE SETTING */}
                    <div className="cms-flex-col cms-gap-2" style={{ marginTop: "12px", marginBottom: "12px" }}>
                      <label style={{ fontSize: "11px", fontWeight: "900", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Select Writing Tone
                      </label>
                      <div style={{ display: "flex", gap: "8px", width: "100%" }}>
                        {[
                          { key: "friendly", label: "Friendly", desc: "Warm & Conversational", emoji: "😊" },
                          { key: "professional", label: "Professional", desc: "Elite & Authoritative", emoji: "💼" },
                          { key: "informative", label: "Informative", desc: "Factual & Analytical", emoji: "📊" }
                        ].map((t) => {
                          const isSelected = writingTone === t.key;
                          return (
                            <button
                              key={t.key}
                              type="button"
                              onClick={() => setWritingTone(t.key)}
                              style={{
                                flex: 1,
                                padding: "10px 12px",
                                borderRadius: "12px",
                                border: isSelected ? "2px solid #ff9f00" : "1.5px solid #e2e8f0",
                                backgroundColor: isSelected ? "#fffbeb" : "#ffffff",
                                color: isSelected ? "#9a3412" : "#334155",
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: "4px",
                                transition: "all 0.2s ease",
                                boxShadow: isSelected ? "0 4px 12px rgba(255, 159, 0, 0.12)" : "none",
                              }}
                              onMouseOver={(e) => {
                                if (!isSelected) {
                                  e.currentTarget.style.borderColor = "#cbd5e1";
                                  e.currentTarget.style.backgroundColor = "#f8fafc";
                                }
                              }}
                              onMouseOut={(e) => {
                                if (!isSelected) {
                                  e.currentTarget.style.borderColor = "#e2e8f0";
                                  e.currentTarget.style.backgroundColor = "#ffffff";
                                }
                              }}
                            >
                              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                                <span style={{ fontSize: "15px" }}>{t.emoji}</span>
                                <span style={{ fontSize: "13px", fontWeight: "800" }}>{t.label}</span>
                              </div>
                              <span style={{ fontSize: "9px", fontWeight: "600", color: isSelected ? "#ea580c" : "#64748b" }}>{t.desc}</span>
                            </button>
                          );
                        })}
                      </div>
                    </div>

                    <button
                      type="button"
                      disabled={isCheckingSimilarity}
                      onClick={handleCheckDuplicates}
                      style={{
                        width: "100%",
                        height: "40px",
                        borderRadius: "12px",
                        color: "#ff9f00",
                        backgroundColor: "#fffbeb",
                        border: "1px solid rgba(255, 159, 0, 0.35)",
                        fontWeight: "700",
                        fontSize: "13.5px",
                        cursor: isCheckingSimilarity ? "not-allowed" : "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        opacity: isCheckingSimilarity ? 0.6 : 1
                      }}
                    >
                      {isCheckingSimilarity ? "Checking for duplicates..." : (
                        <>
                          <Icons.Search style={{ width: "16px", height: "16px", stroke: "currentColor" }} /> Check Duplicates
                        </>
                      )}
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setAiModalOpen(false);
                        handleAIGeneration(false);
                      }}
                      style={{
                        width: "100%",
                        height: "44px",
                        border: "none",
                        borderRadius: "12px",
                        color: "#ffffff",
                        background: "linear-gradient(135deg, #ff9f00 0%, #ffb74d 100%)",
                        fontWeight: "700",
                        fontSize: "14px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px",
                        boxShadow: "0 4px 12px rgba(255, 159, 0, 0.2)"
                      }}
                    >
                      <Icons.Sparkles style={{ width: "16px", height: "16px", stroke: "currentColor" }} /> Write Complete Article
                    </button>
                  </div>

                  {/* Refinement Assistant Section */}
                  <div className="cms-flex-col cms-gap-3" style={{ backgroundColor: "#fbfbfe", padding: "16px", borderRadius: "16px", border: "1px solid #eef2f6", marginTop: "16px" }}>
                    <div className="cms-flex cms-align-center cms-gap-2">
                      <span style={{ fontSize: "12px", fontWeight: "800", color: "#ff9f00", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                        Refine with AI Assistant
                      </span>
                    </div>
                    <textarea
                      value={aiRefinementPrompt}
                      onChange={(e) => setAiRefinementPrompt(e.target.value)}
                      rows="3"
                      style={{
                        width: "100%",
                        border: "1px solid #cbd5e1",
                        borderRadius: "12px",
                        padding: "10px 14px",
                        outline: "none",
                        fontSize: "13.5px",
                        fontWeight: "500",
                        backgroundColor: "#ffffff",
                        transition: "all 0.2s ease",
                        resize: "none"
                      }}
                      placeholder="e.g., 'Change FAQ 1 to be about feed cost warnings' or 'Translate SAARC block to Urdu'..."
                      onFocus={(e) => e.target.style.borderColor = "#ff9f00"}
                      onBlur={(e) => e.target.style.borderColor = "#cbd5e1"}
                    />
                    <button
                      type="button"
                      onClick={() => {
                        setAiModalOpen(false);
                        handleAIGeneration(true);
                      }}
                      style={{
                        width: "100%",
                        height: "44px",
                        border: "1px solid rgba(255, 159, 0, 0.3)",
                        borderRadius: "12px",
                        color: "#ff9f00",
                        backgroundColor: "#fffbeb",
                        fontWeight: "700",
                        fontSize: "14px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "8px"
                      }}
                    >
                      <Icons.Lightbulb style={{ width: "16px", height: "16px", stroke: "currentColor" }} /> Refine & Re-write Article
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const mapStateToProps = (store) => ({
  Auth: store.Authentication,
});

export default connect(mapStateToProps)(AIArticle);
